import {
  ACTIONS_CATEGORIES,
  CONFLUENCE,
  DATEV_ACCOUNTING,
  DATEV_HR,
  GOOGLE_CALENDAR,
  GOOGLE_DOCS,
  GOOGLE_DRIVE,
  GOOGLE_GMAIL,
  GOOGLE_SHEETS,
  HUBSPOT,
  JIRA,
  MICROSOFT_D365,
  MICROSOFT_ONEDRIVE,
  MICROSOFT_SHAREPOINT,
  MICROSOFT_TEAMS,
  OUTLOOK_CALENDAR,
  OUTLOOK_EMAIL,
  PERSONA_TYPE,
  SAP_S4HANA,
  SLACK,
  SQL_DATABASE
} from 'src/types/enum';

export const TRANSLATION_CONSTANTS = {
  // General
  empowerGPT: 'EmpowerGPT',
  knowledgeBaseChat: 'Knowledge Base Chat',
  enterprise: 'Enterprise',
  worldKnowledge: 'World Knowledge',
  noKnowledgeAccess: "You don't have access",
  generalChat: 'General Chat',
  languageSwitcher: 'Select Language',
  logout: 'Logout',
  profile: 'Profile',
  uploadImport: 'Upload / Import',
  documents: 'Documents',
  valuableInsights: 'Quickly extract valuable insights',
  uploadFiles: 'Upload files',
  clearFilters: 'Reset',
  resetFilters: 'Reset Filters',
  resetPassword: 'Change Password',
  userGroups: 'User Groups',
  userGroupName: 'User group name',
  accountType: 'Account Type',
  email: 'Email',
  expand: 'Expand',
  startChat: 'Start Chat',
  addToChat: 'Add to chat',
  addToAssistant: 'Add to Assistant',
  addToDataset: 'Add to Dataset',
  createdWithTime: 'Created {{time}} ago',
  modifiedWithTime: 'Modified {{time}} ago',
  syncedWithTime: 'Synced {{time}} ago',
  rolesAndPermissions: 'Roles And Permissions',
  selectItemsToDelete: 'Select Items to delete',
  selectItemsToTag: 'Select items to tag',
  selectItemsToMove: 'Select items to move',
  noPermissionToDelete: 'Do not have permission to delete',
  noPermissionToView: 'Do not have permission to view',
  noPermissionToMoveHere: 'Do not have permission to move here',
  noPermissionToDownload: 'Do not have permission to download',
  tagDisabledForWorkspaceChat:
    'Tags functionality is not available for workspace chats',
  typeToSearch: 'Type to search',
  searching: 'Searching...',
  usage: 'Usage',
  inPlanUsage: 'In-plan Usage',
  disclaimerEgpt:
    'AI Model can make mistakes, please consider verifying with the provided citations.',
  chatGPT: 'ChatGPT',
  reprocess: 'Reprocess',
  selectItemsToReprocess: 'Select items to reprocess',
  fileProcessing: 'File Processing',
  invalidFileType: 'Invalid file type',
  enterpriseKnowledgeChat: 'Enterprise Knowledge Chat',
  worldKnowledgeChat: 'World Knowledge Chat',
  ok: 'OK',
  goBack: 'Go Back',
  settings: 'Settings',
  adminConsole: 'Admin Console',
  version: 'Version',
  llmsSettingsHeading: 'AI Models Available in Chat',
  selectModels: 'Select Models',
  modelsWarning: 'Please select at least one model.',
  configure: 'Configure',
  tenantKnowledgeBase: '{{tenant}} Knowledge',
  selected: 'Selected',
  noInternet:
    'No internet connection. Please check your internet and try again.',
  loading: 'Loading',
  addMore: 'Add more',
  usageAndAnalytics: 'Usage and Analytics',
  userAndRoles: 'User and Roles',
  menu: 'Menu',
  noFileName: 'No File Name',
  inviteTeammates: 'Invite your teammates',
  inviteTeammatesDescription:
    'Enable your teammates with quick access to critical knowledge',
  newestToOldest: 'Newest to Oldest',
  oldestToNewest: 'Oldest to Newest',
  aToZ: 'A-Z',
  zToA: 'Z-A',
  count: 'Count',

  chargedTaxIncl: 'Charged (Tax incl)',
  chargedDate: 'Charged Date',
  consumptionDetails: 'Consumption Details',
  invoices: 'Invoices',
  invoice: 'Invoice',
  highToLow: 'High to low',
  lowToHigh: 'Low to high',
  current: 'Current',
  history: 'History',
  purchasedOn: 'Purchased on',
  expiresOn: 'Expires on',
  expiredOn: 'Expired on',
  creditsSpent: 'Credits Spent',
  startedOn: 'Started on',
  trialUsage: 'Trial usage',
  trialUsageTooltip:
    'Credits used vs total credits included in your trial period.',

  //Filters
  search: 'Search',
  avanceSearchPlaceholder: 'Search any file or document',
  searchUser: 'Search a user',
  searchTenant: 'Search a tenant',
  accountTypeSelect: 'Select Account Type',
  noOptions: 'No options',
  filters: 'Filters',
  revokeAccess: 'Revoke access',

  // Documents
  uploadDocs: 'Upload Documents',
  tagDocuments: 'Tag Documents',
  allDocuments: 'All documents',
  docName: 'Document name',
  uploadedBy: 'Uploaded By',
  modifiedBy: 'Modified By',
  syncedBy: 'Synced By',
  syncedOn: 'Synced On',
  syncing: 'Currently Syncing...',
  syncingInGridView: 'Please wait while the folder is being synced...',
  syncingFailed: 'Sync attempt failed',
  syncingFileLimitReached: 'Maximum file sync limit reached',
  uploadedOn: 'Uploaded On',
  uploadedContent: 'Uploaded Content',
  modifiedOn: 'Modified On',
  actions: 'Actions',
  view: 'View',
  share: 'Share',
  shared: 'Shared',
  sync: 'Sync',
  sharedWith: 'Shared with',
  invite: 'Invite',
  details: 'AI Overview',
  documentType: 'Document Type',
  size: 'Size',
  length: 'Length',
  description: 'Description',
  descriptionOptional: 'Description (optional)',
  rowsPerPage: 'Rows per page',
  noRowsFound: 'No rows found.',
  uploadTimeAndDateWithUser: 'Uploaded {{time}} by {{user}}',
  download: 'Download',
  uploadProgress: 'Upload Progress',
  document: 'Document',
  docsDropMessage: 'Drop the documents to start uploading',
  uploadDocFailed: `Failed to upload documents.`,
  uploadDocsFailed: `Failed to upload document.`,
  uploadMessage: `You have uploaded `,
  dropDocsMessage1: `Drop the documents to start uploading`,
  dropDocsMessage2: 'Drag & drop documents here',
  uploadDocsText: 'You can upload documents, audios, and videos.',
  dropDocsRestriction: 'You cannot upload these document types.',
  unauthorizedFilesError: "You don't have permission to upload files/folders.",
  dropDocsPartialRestriction: 'Some invalid document types were rejected.',
  failedFetchingDocuments: 'Failed to fetch documents.',
  uploadDocsSuccess: '{{count}} document(s) uploaded successfully.',
  uploadStatusBoxMessage:
    '{{count}} document(s) uploaded successfully. You can close the modal window.',
  uploadDocsWarningMessage:
    '{{count}} document(s) uploaded successfully and {{failed}} failed. Retrying...',
  uploadDocSuccess: '{{count}} document uploaded successfully!',
  documentsUploadSuccess: 'Documents uploaded successfully!',
  searchDocuments: 'Search Documents',
  enterTagName: 'Enter tag name',
  folderCreateSuccess: 'Folder created successfully!',
  folderAndUrlSuccess:
    'Folder created successfully! Web link generation is underway!',
  workspaceCreateSuccess: 'Workspace created successfully!',
  collectionCreateSuccess: 'Collection created successfully!',
  folderCreateError: 'Error creating resource!',
  folderCreateSuccessAccesError:
    'Folder created successfully!Failed to update access permission.',
  folderUpdateSuccessAccessError:
    'Folder updated successfully! Failed to update access permission.',
  selectTags: 'Select Tags',
  docTaggedSuccess: 'Documents tagged successfully!',
  docTaggedError: 'Error tagging documents!',
  docTagsDeleteSuccess: 'Tags deleted successfully!',
  docTagsDeleteError: 'Failed to delete tags!',
  docTagsUpdatedSuccess: 'Tags updated successfully!',
  docTagsUpdatedError: 'Failed to update tags!',
  selectedTags: 'Selected Tags',
  tags: 'Tags',
  selectUploadTags: 'Select tags to apply on uploaded documents',
  maxDocSize:
    'Document name length of "{{ name }}" exceeds the maximum limit of 200.',
  uploaded: 'Uploaded',
  status: 'Status',
  documentDeletionFailed: 'Failed to delete document.',
  attachedFile: 'Attached Files',
  excelOnlySelectionTitle: 'You can only select the excel files.',
  excelOnlySelectionDescription:
    'Data analysis can only be done using Excel files. Please use Excel files exclusively.',
  attachmentsMoreCount: '{{count}} more',
  clearAllFiles: 'Clear all',
  documentNotEmptyError: 'Deleting a non-empty folder is not allowed.',
  uploadFolder: 'Upload Folder',
  documentDeleteSuccess: 'Document deleted successfully!',
  documentsDeleteSuccess: 'Documents deleted successfully!',
  documentDeleteConfirmation: 'Are you sure you want to delete the document?',
  resourceDeleteConfirmation: 'Are you sure you want to delete the resource?',
  collectionDeleteSuccess: 'Collection deleted successfully!',
  collectionDeleteConfirmation:
    'Are you sure you want to delete the collection?',
  collectionDeletionFailed: 'Failed to delete collection.',
  workspaceDeletionFailed: 'Failed to delete workspace.',
  workspaceDeleteSuccess: 'Workspace deleted successfully!',
  workspaceDeleteConfirmation: 'Are you sure you want to delete the workspace?',
  multipleDocumentDeleteConfirmation:
    'Are you sure you want to delete the selected documents?',
  nestedFolderDelete:
    'This action will delete all selected folders, subfolders, and files. Do you want to continue?',
  multipleFilesReprocessConfirmation:
    'Are you sure you want to reprocess the selected document?',
  genericConfirmation: 'Are you sure?',
  retrialFailed: 'Failed to upload some documents please try again later.',
  deleteDocuments: 'Delete Documents',
  cancelUploadConfirmation:
    'Are you sure you want to cancel uploading the remaining files?',
  retryFailedDocuments: 'Retry Failed Documents',
  processingFailed: 'Processing Failed',
  processLastTransaction: 'Process Last Transaction',
  processAllTransactions: 'Process All Transactions',
  documentDownloadError: 'Failed to download document.',
  destinationFolder: 'Select Destination Folder',
  move: 'Move',
  moveDuplicateError: 'File/Folder already exists.',
  moveSuccess: 'File/Folder moved successfully.',
  moveFailed: 'Error moving File/Folder.',
  reprocessSuccess: 'Files queued for reprocessing successfully.',
  reprocessFailed: 'Error reprocessing files.',
  reprocessCountInfo: 'Reprocessing {{count}} files.',
  syncSuccess: 'Resource queued for syncing successfully.',
  syncFailed: 'Error syncing resource.',
  nameCharacterLengthError: 'Name should be between 1 to 200 characters.',
  name: 'Name',
  resourceSharingSuccessMessage: 'Resource permissions updated successfully',
  resourceSharingErrorMessage: 'Error while sharing resource.',
  userOrUserGroup: 'User or User Group',
  searchForUserOrUserGroup: 'Search for User or User Group',
  message: 'Message',
  addMessage: 'Add a message',
  sendEmailNotificationToRecipients: 'Send email notification to recipients',
  advanced: 'Advanced',
  keepManuallyAssignedRolesOnSubFoldersFiles:
    'Keep already assigned roles on sub folders/files',
  assignRoleToAllSubFoldersFiles: 'Assign role to all sub folders/files',
  assignRoleOnFilesOnly: 'Assign role on files only',
  noUserOrUserGroupHasAccessToResource:
    'No User or User group has access to the Resource.',
  noMatchingUsersOrUserGroupsFound: 'No matching users or user groups found',
  controllerRoleAssignmentToRegularUserAtWorkspace:
    'Selected role can not be assigned to Regular Users at workspaces.',
  regularUserAssignmentToWorkspace:
    'Regular users can not be made a workspace controller. Promote account type from users page.',
  contollerAssignmentError:
    'Not authorised to invite users as controllers on workspaces.',
  authorizedToRemoveLowTierAccountTypesOnly:
    'Authorized to remove assignments for lower-tier account type only.',
  containsCollection: 'Contains: {{count}} Collections',
  containsItems: 'Contains: {{count}} Items',
  createPermissionDenied: 'Permission to create not found',
  uploadPermissionDenied: 'Permission to upload not found',
  createCollection: 'Create a Collection',
  collectionPlaceholder: 'Add documents within a collection to chat with them',
  createFolder: 'Create a Folder',
  folderPlaceholder: 'Add content to build up your knowledge domain',
  assignViewerSubtitle: 'Query and read the content.',
  assignControllerSubtitle: 'Query, edit and manage the access to the content.',
  assignContributorSubtitle: 'Query, read and add to the content.',
  assignAssistantViewer: 'Chat with the assistant',
  assignAssignController: 'Chat and control the assistant.',
  emptyWorkspace: 'No Workspace available',
  emptyCollection: 'No Collection available',
  workspaces: 'Workspaces',
  browseWorkspaceDescription:
    'Browse your workspace and choose the content you want to add.',
  collections: 'Collections',
  url: 'Url',
  webLink: 'Web Link',
  limitationUrl: 'Max 5 web links can be added',
  urlLong: 'Web link is too long',
  inValidUrl: 'Must be a valid web link',
  restrictionUrl: 'Web link not allowed (login, captcha, auth etc)',
  urlRequired: 'Web link is required',
  duplicateUrls: 'Duplicate web links cannot be added',
  extensionNotAllowed: 'Files like "{{disallowedExt}}" are not allowed',
  folderName: 'Enter Name for Folder',
  licenseLimitReached: 'License limit reached',
  licenseExpired: 'License Expired!',
  licenseExpiredMessage:
    'Your License has expired. Please contact the Administrator for Extension or Renewal.',
  author: 'Author',
  importExternalDocs: 'Import from external application',
  documentDetailsDisclaimer: 'AI generated document overview may have errors.',
  disableImportMessage:
    'Importing from External Applications disabled in "{{workspaceName}}"',
  importNotAllowed: 'Import is not allowed in Public/Private Workspace',
  workspace: 'Workspace',
  file: 'File',
  collection: 'Collection',
  folder: 'Folder',
  folders: 'Folders',
  reasonNotAvailable: 'Reason not available',
  languageError:
    'Language is not supported for processing. German, English and Italian languages are currently supported for processing.',
  rateLimitError:
    'AI model rate limit reached. Please reprocess the document later.',
  permissionsError: 'You do not have full rights access to this resource.',
  unsupportedFiles: 'The collection contains Unsupported File',
  //contextLimitReached
  maxLengthError:
    'The AI models context limit has been reached while processing.',
  noTextFoundError:
    'The document appears to be corrupt. Please upload a valid document.',

  // Chat
  Chat: 'Chat',
  chat: 'chat',
  chats: 'Chats',
  chatsUntranslated: 'Chats',
  createNewChat: 'New Chat',
  send: 'Send',
  queryPlaceholder: 'Ask ',
  queryPlaceholderWorldKnowledge: ` Use '/' for helpful prompts.`,
  chatConfigurations: 'Chat configuration',
  parameterDialogTitle: 'Parameters',
  parameterDialogSubtitle:
    'Update chat parameters to search the documents efficiently',
  updateParameters: 'Update Parameters',
  cancel: 'Cancel',
  submit: 'Submit',
  save: 'Save',
  confirm: 'Confirm',
  parametersUpdateSuccess: 'Chat parameters updated successfully!',
  parametersUpdateError: 'Error updating chat parameters!',
  temperature: 'Temperature',
  tokens: 'Max length (tokens)',
  sequences: 'Stop sequences',
  probabilities: 'Top probabilities',
  frequency: 'Frequency penalty',
  presence: 'Presence penalty',
  chatRenameSuccess: 'Chat renamed successfully!',
  chatRenameFailed: 'Error renaming chat!',
  chatDeleteSuccess: 'Chat deleted successfully!',
  chatDeleteFailed: 'Error deleting chat!',
  generatingResponse: 'Generating response',
  executing: 'Executing',
  executingPlan: 'Executing plan',
  errorGeneratingResponse: 'Could not generate response! Please try again!',
  messagesLoadingFailed: 'Error fetching messages. Please try again!',
  responseFailedMessage: 'There was an error generating a response.',
  responseStreamingFailedMessage:
    'There was an error in streaming response. Please refresh the page.',
  regenerateResponse: 'Regenerate Response',
  errorAddingReaction: 'Error adding reaction.',
  errorUpdatingChatContext: 'Error updating chat context.',
  chatDeleteConfirmation: 'Are you sure you want to delete the chat?',
  chatGptSlogan:
    'Assist with writing, coding, and researching world knowledge.',
  empowerGptSlogan: 'Ask answers in light of accessible knowledge base.',
  empowerGptKnowledgeSwitchSlogan: 'Search across all your enterprise data',
  chatGptKnowledgeSwitchSlogan:
    'Search across the entire internet or write with LLM-trained data',
  samplePrompt1:
    'What checks should I carry out before installing the Etaprime L pump?',
  samplePrompt2:
    'What is the allowable range of viscosity of Crude oil for L27/38S power plant?',
  samplePrompt4: 'Guidelines for creating pivot table in Microsoft Excel.',
  samplePrompt5: 'Remote team collaboration & communication tips.',
  samplePrompt7: 'Suggest supply chain optimization strategies.',
  samplePrompt8: 'Best practices for identifying corporate risks.',
  capabilities1:
    ' Get answers for your queries solely based on the uploaded documents.',
  capabilities2:
    'Remembers the context of the previous questions within a chat.',
  limitations1: ' May fail to compare attributes spread across the database.',
  limitations2: 'Knowledge confined to the scope of the uploaded documents.',
  includeChatHistory: "Click to reconnect with last query's context.",
  excludeChatHisory: 'Click to disconnect from chat context',
  stickToDocs: 'Limits search to documents open in viewer.',
  resourceUnavailable: 'Resource Unavailable',
  referenceDocumentDeleted: 'Reference document deleted',
  modelBeingUsed: 'This model is being used in the app',
  disclaimerChatgpt:
    'AI Model can make mistakes, please consider verifying important information.',
  copy: 'Copy',
  copied: 'Copied',
  errorCopyingResponse: 'Error copying response',
  stickDocMessage:
    'Limits search to documents open in viewer. (No documents opened)',
  contentFilteringErrorMsg: `The response was filtered due to the prompt triggering Azure's content management policy. Please modify your prompt and retry.`,
  generalErrorMsg:
    'AI couldn’t generate a response in time. Try again, or simplify your request.',
  shareChatTitle: 'Share this chat',
  shareChatText: 'EmpowerGPT users with the link',
  shareChatDisclaimer: 'Any messages you add after sharing will stay private',
  copyLink: 'Copy Link',
  errorCopyingLink: 'Error copying link',
  sharedBy: 'Shared By: ',
  chatInitiationError:
    'Could not initiate a request, Please check if model configuration is correct.',
  rateLimit:
    'Your organization has reached the rate limit for requests per minute. Please try again later.',
  unsupportedLanguage: `Input language detected as {{detectedLanguage}} is currently not supported for Enterprise Knowledge chat. Please switch to a supported language, which currently includes English, German, and Italian.\nIf you believe this detection is incorrect, please enter a longer phrase or rephrase your input.`,
  chatContextLengthExceed:
    'The message you entered exceeds the allowable length for the selected AI model. Kindly shorten it and try again.',
  contentPolicyViolation:
    "The image that you're trying to generate is against our content policy, please try again.",
  webSearchTooltip: 'Searches the web to answer',
  webSearchDescription: 'Search the web for results',
  canvasDescription: 'Write and collaborate',
  searchPlusDescription: 'Advanced AI for smart answers',
  searchPlusLimitReached:
    'You have reached your Search+ query limit for your plan.',
  tools: 'Tools',
  beta: 'Beta',

  stickToDoc: 'Stick to Docs',
  webSearch: 'Web search',
  imageGeneration: 'Image generation',
  imageGenerationDescription: 'Generate images from text descriptions',
  nanoBananaDescription: 'fast and lightweight image generation',
  generatingImage: 'Generating image',
  imageGenerated: 'Image generated successfully',
  generatedImage: 'Generated image',
  failedToLoadImage: 'Failed to load image',
  imageCopied: 'Image copied',
  failedToCopyImage: 'Failed to copy image',
  failedToDownloadImage: 'Failed to download image',
  clickToZoomIn: 'Click to zoom in',
  clickToZoomOut: 'Click to zoom out',
  copyImage: 'Copy',
  downloadImage: 'Download',
  maximizeImage: 'Maximize',
  noAuthorizedFilesForChat:
    'Sorry, No documents against the selected resource are available for chat. Please ensure the it is not empty, and contains processed documents accessible to you.',
  addFilesDescription: 'Add Files for Focused Responses',
  selectFile: 'Select File',
  documentsInFocus: 'Documents in focus:',
  resourcesInFocus: 'Resources in focus',
  resourcesInFocusDescription:
    'Documents in focus from the enterprise knowledge base.',
  oneResourceInFocus: '1 resource',
  resourcesInFocusCount: '{{count}} resources',
  addMoreDocuments: 'Add more documents',
  advancedSearchButtonText: 'Switch to Advanced Search',
  showInFolder: 'Show in Folder',
  findDocumentsText: 'Type to find documents in Workspaces',
  noResultsFound: 'No results found',
  inputLimitReachedError:
    'Search phrase can not be longer than {{inputLimit}} characters',
  startChatOnSelectedFiles: 'Start chat on selected files',
  addSelectedFilesToChat: 'Add Selected Files to Chat',
  addSelectedFilesToAssistant: 'Add Selected Files to Assistant',
  addSelectedFilesToMiniExpertDataset: 'Add selected files to your dataset',
  noResultsTitle: 'No Results for',
  noResultsDescription:
    'Try a different search phrase, check for typos, or modify any active filters.',
  advancedSearch: 'Advanced Search',
  advancedSearchDefaultDescription:
    'Easily add files and folders by searching for any keyword you recall from the document.',
  addedFileAndSelectedMoreToAddInSearch:
    'You\'ve added {{addedCount}} file or folder and it is marked as "previously added", and selected {{newCount}} more to add.',
  addedFilesAndSelectedMoreToAddInSearch:
    'You\'ve added {{addedCount}} files and folders and they are marked as "previously added", and selected {{newCount}} more to add.',
  advancedSearchTitle: 'AI-Powered search on your Enterprise Knowledge',
  advancedSearchDescription:
    'Find relevant documents and information within accessible content in Workspaces.',
  useSearchBarAndFilters:
    'Use the search bar and filters to find any file or document.',
  tryAdjustingFilters:
    'No items match the selected filters. Try adjusting or resetting them.',
  recentUploads: 'Recent Uploads',
  noRecentUploads: 'You have no recently uploaded files.',
  uploadRecentFilesPrompt:
    'Upload files to your workspace, or use the search bar and filters to find any file or document.',
  readMore: 'Read more',
  readLess: 'Read less',
  foundResults: 'Found {{count}} results',
  filterByConnector: 'Filter by connector',
  allSources: 'All sources',
  assistantDeletedError: 'Assistant has been deleted',
  fileDeletedOrInaccessibleDesc:
    'has been deleted or is no longer accessible to you',
  fileDeletedOrInaccessibleLabel: 'Inaccessible',
  imageAnalysisNotSupported:
    'Selected model does not support images. Please switch to a model that supports image analysis.',
  chatResponseTimeoutError:
    'AI Model took too long to respond to your query. Please try again shortly.',
  chatModelUsageLimitReachedMessage:
    'You have reached the usage limit for AI models in {{modelTier}} tier. Switch to another model until usage limit for this model tier resets after {{availableAt}}.',
  chatStopGenerating: 'Stop generating',
  chatStopping: 'Stopping response',
  chatResponseTerminated: 'This response has been terminated by user.',
  source: 'Source',
  type: 'Type',

  // Speech-to-text err
  microphoneAccessError:
    'Microphone access is required. Please allow it in your browser.',
  noSpeechRecognized: 'No speech recognized.',
  creditUsageError: 'Error in calculating credits usage',
  exemptedTokens: 'You are exempt from token consumption tracking.',
  maxRecordingTimeExceeded: 'Maximum recording time exceeded.',
  stopMicError: 'Error stopping microphone.',
  tooLongSilence: 'Too Long Silence Detected',
  inputLanguageMsg: 'Understanding input language',

  //Chat Steps
  understandingInput: 'Understanding input',
  thinking: 'Thinking',
  searchingContent: 'Searching workspaces',
  searchingEnterpriseKnowledge:
    'Searching Enterprise Knowledge for relevant information',
  listingRelevantDocuments: 'Listing relevant documents',
  retrievingWebpageContent: 'Retrieving webpage content',
  searchingWeb: 'Searching web',
  searchingAttachments: 'Searching within attachment(s)',
  attachedDocuments: 'document(s)',
  link: 'link',
  generatingResponseUsingReceivedExcerpts:
    'Generating response from retrieved excerpts',
  excerptsFrom: 'excerpts from',
  contentSearched: 'Searched Enterprise Knowledge',
  webSearched: 'Searched Web',
  searchedAttachments: 'Searched within attachment(s)',
  joiningResponseFromPreviousTasks: 'Joining response from previous tasks',

  // Chat feedback ...
  feedbackTitle: 'Provide additional feedback',
  feedback1: 'Response cites wrong document.',
  feedback2: 'Response out of scope of documents.',
  feedback3: 'Response is harmful/unsafe.',
  feedback4: 'Response is not helpful.',
  submitFeedback: 'Submit feedback.',
  sources: 'Sources',
  feedbackCommentPlaceholder:
    'What went wrong with the answer? How can it be imporved?',
  feedbackValidationError: 'Please select atleast 1 option.',

  // Context window and usage
  contextWindowMenuTitle: 'Context window and usage',
  contextWindow: 'Context window',
  usageThisMonth: 'Usage this month',
  freeSpace: 'Free space',
  contextWindowSummary: '{{used}} / {{total}} tokens on {{model}}',
  tokensWithPercentage: '{{tokens}} tok \u00b7 {{percentage}}',
  labelWithCount: '{{label}} ({{count}})',
  contextWindowTooltipContext:
    'Context: {{percentage}} \u00b7 {{used}} / {{total}}',
  systemPrompt: 'System prompt',
  workspaceFileRetrieval: 'Workspace file retrieval',
  memory: 'Memory',
  systemTools: 'System tools',
  tokensUsedOfTotal: '{{used}} / {{total}} tokens',

  // User/Roles/Permissions
  rolesTitle: 'Roles',
  role: 'Role',
  permissions: 'Permissions',
  users: 'Users',
  contentRole: 'Resource Role',
  userRole: 'User Role',
  userRoles: 'User Roles',
  userRolesDescription:
    'Reusable feature access sets you can assign to users and user groups',
  noOfEnabledFeature: 'No. of enabled permissions',
  assignedTo: 'Assigned to',
  createUserRole: 'Create a user role',
  userRoleNamePlaceholder: 'e.g. Standard permissions',
  userRoleDescriptionPlaceholder: 'Provide description',
  userRoleCreateRequirementsTooltip:
    'Name and at least One Permission is required to create User Role',
  corePermissions: 'Core permissions.',
  corePermissionsDescription: 'Enable these first features depend on them',
  enabledCountBadge: '{{enabled}}/{{total}} enabled',
  editUserRole: 'Edit a user role',
  viewUserRole: 'View user role',
  assignedToRoleTitle: 'Assigned to "{{name}}"',
  deleteUserRoleConfirmation:
    'This will permanently delete the "{{name}}" user role. This action cannot be undone.',
  assignedUsersCountLabel: '{{count}} user assigned',
  assignedUserGroupsCountLabel: '{{count}} user group assigned',
  members: 'Members',
  searchUsersOrGroupsPlaceholder: 'Search users or groups...',
  assignUsersRowTitle: 'Assign users',
  assignUsersRowDescription: 'You will be redirected to Users screen',
  assignUserGroupsRowTitle: 'Assign user groups',
  assignUserGroupsRowDescription:
    'You will be redirected to User Groups screen',
  expandAll: 'Expand all',
  collapseAll: 'Collapse all',
  searchPermissionsPlaceholder: 'Search sections, features, permissions',
  discardChanges: 'Discard changes',
  saveChanges: 'Save changes',
  needsCapabilityPrefix: 'Needs',
  coreCapabilityLabelPrefix: 'Core',

  // User Role Template - capability control labels (capability_controls.permissions[].name/description)
  localFileUploads: 'Local File Uploads',
  attachmentsCapability: 'Attachments',
  enterpriseKnowledgeCapabilityDescription:
    'Enterprise Knowledge container — required by Chat-EK, Smart Meet, Doc Analyst, and EK capabilities everywhere — tightly coupled with Workspace.',
  localFileUploadsCapabilityDescription:
    'Local file upload is a capability that lets users upload files directly from their device.',
  attachmentsCapabilityDescription:
    'Attachments is a capability that lets users upload files in Chat directly from their device.',
  worldKnowledgeCapabilityDescription:
    'Conversational AI using live web knowledge. Fully independent of Workspaces.',

  // User Role Template - feature/sub-feature labels (features[].name, sub_features[].name)
  integrationsFeature: 'Integrations',
  assistantChatSubFeature: 'Assistant Chat',
  buildAssistantsSubFeature: 'Build Assistants',
  manageAssistantsSubFeature: 'Manage Assistants',
  projectChatSubFeature: 'Project Chat',
  manageProjectSubFeature: 'Manage Project',
  manageWorkflowSubFeature: 'Manage Workflow',
  sharePointSubFeature: 'SharePoint',
  oneDriveSubFeature: 'OneDrive',
  confluenceSubFeature: 'Confluence',
  googleDriveSubFeature: 'Google Drive',

  // User Role Template - permission labels (enable_permission.permission, sub_features[].permissions[].permission)
  enableFeaturePermission: 'Enable Feature',
  enableSubfeaturePermission: 'Enable Subfeature',
  uploadLocalFilesPermission: 'Upload Local Files',
  modelComparisonPermission: 'Model Comparison',
  manageProjectsPermission: 'Manage Projects',
  manageWorkflowsPermission: 'Manage Workflows',
  runWorkflowsPermission: 'Run Workflows',
  versionControlPermission: 'Version Control',
  shareWorkflowsPermission: 'Share Workflows',
  codeExecutionPermission: 'Code Execution',
  attachmentsPermission: 'Attachments',
  attachmentsPermissionDescription:
    'Browse and attach existing enterprise content.',
  projectSourcePermission: 'Project Source',
  disableAllPermissions: 'Disable all',
  create: 'Create',
  update: 'Update',
  add: 'Add',
  previouslyAdded: 'Previously added',
  new: 'New',
  edit: 'Edit',
  editName: 'Edit Name',
  delete: 'Delete',
  tag: 'Tag',
  upload: 'Upload',
  createRole: 'Create Role',
  updateRole: 'Update Role',
  createUser: 'Create User',
  updateUser: 'Update User',
  searchRole: 'Search User Role',
  availableRole: 'Available User Role',
  assignedRole: 'Assigned User Role',
  confirmDeleteRole: 'Are you sure you want to delete this role?',
  confirmDeleteUser: 'Are you sure, you want to delete this user?',
  confirmDeleteYourAccount: 'Are you sure, you want to delete your account?',
  confirmDeleteMultipleUsers: 'Are you sure, you want to delete these users?',
  roleDeleteSuccess: 'Role deleted successfully!',
  deleteRow: 'Delete row',
  deleteChat: 'Delete chat',
  confirmDeleteChat: 'Are you sure you want to delete the chat?',
  yesDeleteIt: 'Yes, delete it',
  randomError: 'Some Error Occurred!',
  errorDeletingRole: 'Error Deleting Role.',
  noRecordFound: 'No Record Found!',
  roleUpdateSuccess: 'Role Updated Successfully!',
  roleUpdateError: 'Error updating role!',
  roleCreateSuccess: 'Role Created Successfully!',
  roleCreateError: 'Error creating role!',
  userRoleTemplateFetchError: 'Error fetching user role template!',
  userRolesFetchError: 'Error fetching user roles!',
  userRoleCreateSuccess: 'User Role Created Successfully!',
  userRoleCreateError: 'Error creating user role!',
  userRoleUpdateSuccess: 'User Role Updated Successfully!',
  userRoleUpdateError: 'Error updating user role!',
  userRoleDeleteSuccess: 'User Role Deleted Successfully!',
  userRoleDeleteError: 'Error deleting user role!',
  userRoleAssignedCannotDelete:
    'This role is assigned to one or more users or groups. Please unassign the role before deleting it.',
  userRoleAlreadyExists: 'A user role with this name already exists.',
  userInviteSuccess: 'An email invite has been sent to invited users.',
  userInviteError: 'Error while inviting users.',
  userUpdateSuccess: 'User updated successfully!',
  userUpdateFailed: 'Error while updating user!',
  userDeleteSuccess: 'User deleted successfully!',
  usersDeleteSuccess: 'Users deleted successfully!',
  userDeleteError: "Couldn't delete user, Please try again!",
  duplicateUserError: 'Email is already Taken',
  duplicateFolderError: 'File/Folder already exists!',
  duplicateCollectionError: 'Collection already exists!',
  duplicateWorkspaceError: 'Workspace already exists!',
  renameSuccess: 'Renamed successfully!',
  renameFailed: 'Error renaming!',
  emptySpaceError: 'Name cannot be empty!',
  rename: 'Rename',
  enterRoleName: 'Enter Role Name',
  fullName: 'Full Name',
  enterFullName: 'Enter Full name',
  enterEmailAddress: 'Enter Email Address',
  enterRoleDescription: 'Enter Role Description',
  roleName: 'Role Name',
  invalidRoleName: 'Invalid Role Name',
  userName: 'Username',
  enterUserName: 'Enter User name',
  moveSelectedRight: 'move selected right',
  moveSelectedLeft: 'move selected left',
  applyTags: 'Apply Tags',
  language: 'Language',
  dataLibrary: 'Data Library',
  dataLibraryResourceNotFoundTitle: "We can't show you this content",
  dataLibraryResourceNotFoundDescription:
    "You don't have the permission to view it. Contact your admin to request access.",
  dataLibraryBackToWorkspace: 'Back to Workspace',
  documentsStatus: 'Uploaded Documents Status',
  statusFailedText: 'Status : Failed',
  statusUploadedText: 'Status : Uploaded',
  startDate: 'Start Date',
  endDate: 'End Date',
  selectStatus: 'Select Status',
  pages: 'pages',
  addARole: 'Add a Role',
  editRole: 'Edit Role',
  tagHelperText:
    "Press the 'Enter' key to create a new tag or to select one from the list",
  organizationAdminSubtitle:
    'Can create and assign workspaces, invite admins/users, add custom roles.',
  organizationOwnerSubtitle:
    'Full access to all workspaces in addition to organization admin privileges.',
  workspaceAdminSubtitle:
    'Can manage complete workspace(s), user groups, and add regular users.',
  regularUserSubtitle:
    'Can chat accessible documents, upload and share content with other users.',
  maxChatFileSize:
    'The file "{{ name }}" is too large. The maximum size for {{type}} files is "{{ size }}mb".',
  maxUploadedFileSize: "Some files exceed their format's size limit.",
  maxUploadFile:
    'The limit for maximum number of attached files is "{{ files }}".',
  unSupportedFile:
    'The File "{{ name }}" is not uploaded due to unsupported format.',
  webSearchOnMsg: 'Disable web search to enable file attachment functionality',
  chatFileName: ' {{ status }} {{ name }}',
  uploading: 'Uploading',
  preparing: 'Preparing',
  processing: 'Processing',
  processed: 'Processed',
  Unprocessed: 'Unprocessed',
  unsupportedFile: 'Unsupported {{ name }}',
  uploadFailed: 'UPLOAD_FAILED',
  retryMsg: 'Error uploading {{ name }}. Please retry.',
  documentRemoved: 'Document removed successfully',
  unsupportedModelForImage:
    'Selected model does not support images, switch to a model that supports image analysis.',
  modelUnavailableForChat:
    'Selected model has been disabled by the organization administrator. Please switch to other available models to continue chat.',
  uploadFailedText: 'Upload failed. Retry',
  modelStatusDeprecated: 'Model Deprecated successfully',
  modelStatusDeprecatedError: 'Error deprecating model',
  // workspace
  workspaceName: 'Workspace Name',
  collectionName: 'Collection Name',
  workspaceColor: 'Workspace Color',
  workspaceController: 'Workspace Controllers',
  createWorkspace: 'Create Workspace',
  updateWorkspace: 'Update Workspace',
  updateName: 'Update Name',
  newWorkspace: 'New Workspace',
  newCollection: 'New Collection',
  newFolder: 'New Folder',
  documentUpdateConfirmation: 'Rename workspace and update background color',
  backgroundColor: 'Background Color',
  updatesOn: 'Updates',
  updatedBy: 'Updated By',
  workspaceUpdateSuccess: 'Workspace updated successfully!',
  workspaceUpdateFailed: 'Error updating workspace!',
  sortBy: 'Sort By',
  sort: 'Sort',
  ascending: 'Ascending',
  descending: 'Descending',
  lastUpdated: 'Last Updated',
  ago: 'ago',
  day: 'day',
  days: 'Days',
  hour: 'hour',
  hours: 'hours',
  min: 'min',
  mins: 'mins',
  sec: 'sec',
  secs: 'secs',
  workSpaceDocumentsDropError:
    'Add a collection to upload the documents inside.',
  createAWorkspace: 'Create a Workspace',
  newWorkspaceDescription:
    'Create a separate knowledge base of each department',
  publicDisclaimer: 'Content in Public is shared with all users.',
  privateDisclaimer: 'Content in My Workspace is only accessible to you.',
  moreActions: 'More actions',

  // create collection
  createACollection: 'Create a Collection',
  //no_data_messages
  noDataNameSpaceMessage: 'Create a workspace to start uploading data within.',
  noDataWorkspaceMessage:
    'Upload a folder or create a collection to upload data within.',
  noDataCollectionMessage: 'Upload files/folders',
  noDataNoPermissionMessage: 'Request administrator for access to documents.',
  noData: 'No Data',
  noDataExists: 'No data exists.',
  documentGraphPlaceholder:
    'This graph would show chat engagement once responses come in',
  //no_content_msg
  noContentAvailable: 'No content available.',

  workSpaceInfoMessage:
    'New workspaces can only be created by organization administrators.',
  moveDialogInfo:
    'Moved content will maintain its original source permissions.',
  // File statuses
  F_S_UP: 'In progress',
  F_S_RE: 'Retrying',
  F_S_PR: 'Processed',
  F_S_US: 'Unsupported',
  F_S_LLR: 'License Limit Reached',
  F_S_WF: 'Waiting for file',

  // User Groups
  userGroupDeletedSuccessfully: 'User Group Deleted Successfully.',
  userGroupsDeletedSuccessfully: 'User Groups Deleted Successfully.',
  userGroupCreatedSuccessfully: 'User Group Created Successfully.',
  failedToCreateUserGroup: 'Failed To Create User Group.',
  failedToDeleteUserGroup: 'Failed To Delete User Group.',
  failedToDeleteUserGroups: 'Failed To Delete User Groups.',
  userGroupUpdatedSuccessfully: 'User Group Updated Successfully.',
  failedToUpdateUserGroup: 'Failed To Update User Group.',
  addUserGroup: 'Add a User Group',
  editUserGroup: 'Edit User Group',
  searchUsers: 'Search Users',
  createdBy: 'Created By',
  userGroupDeleteConfirmationMsg: 'Are you sure to delete user group(s)?',

  //validations
  maxLength: '{{name}} cannot be longer than {{length}} characters',
  required: '{{name}} is required',
  valueCannotBeZero: "{{name}} can't be Zero",
  enterPositiveValue: 'Enter a Positive Value',
  maxCompanyLength: '{{company}} cannot be longer than {{length}} characters',
  maxDepartmentLength:
    '{{department}} cannot be longer than {{length}} characters',
  maxJobLength: '{{jobRole}} cannot be longer than {{length}} characters',
  maxCountryength: '{{country}} cannot be longer than {{length}} characters',

  // Error Messages
  namespaceError: 'Namespace error occurred.',
  resourceNotFoundError: 'Resource not found.',
  userNotFoundError: "User(s) doesn't exist.",
  noPermissionsAgainstResourceError: 'No permissions against the resource.',
  appRoleTemplateNotFoundError: 'App role template not found.',
  insufficientPrivileges: 'Permission to perform the action not found.',
  invalidCredentialsError: 'Non-valid credentials.',
  uploadTypeError: 'Invalid upload type provided.',
  transactionIdError: 'Invalid Transaction ID provided.',
  uploadToRootError: 'Error uploading to root.',
  blobWriteError: 'Failed to upload file to storage.',
  uploadToFoundError:
    'You are not allowed to upload files and folders in FOUND folder.',
  uploadToFileError: 'Files can only be uploaded in valid folders.',
  fileUploadToWorkspaceError: 'Files cannot be uploaded on workspace level.',
  uploadSessionFileDirectToWorkspaceError:
    'Only folders can be uploaded directly to a Workspace. Please place your files inside a folder before uploading.',
  uploadSessionInvalidTransition: 'This session status change is not allowed.',
  uploadSessionTerminalState:
    'This upload session has already ended and cannot be modified.',
  uploadSessionStatusNotSupported:
    'The requested session status is not supported.',
  uploadSessionNotEditable: 'This upload session cannot be edited.',
  uploadSessionEmptyManifest:
    'The selected files have already been uploaded. To upload more, please select new files.',
  uploadSessionManifestInvalid:
    'The upload manifest is invalid. Please try again.',
  uploadSessionPathConflict:
    'A file conflict was detected in the upload path. Please resolve conflicts and try again.',
  uploadSessionNotFound: 'Upload session not found.',
  uploadSessionPermissionDenied:
    'You do not have permission to perform this action on the upload session.',
  uploadSessionInvalidClientHints: 'The client hints provided are not valid.',
  uploadSessionInvalidStatusFilter:
    'The status filter value is not recognised. Please use a valid status.',
  uploadSessionInvalidParent:
    'The destination folder does not exist. Please select a valid folder.',
  summaryDestinationLabel: 'Destination:',
  summarySourceLabel: 'Source (this device):',
  summaryProgressLabel: 'Progress:',
  summaryTotalSizeLabel: 'Total size:',
  summaryProgressText:
    '{{uploaded}} of {{total}} files uploaded - {{percent}}%',
  noFilesAttachedError: 'Select valid files to start uploading them.',
  fileStorageWriteError: 'File storage write error.',
  fileStorageReadError: 'File storage read error.',
  requestedResourceNotFile: 'Requested resource is not a file.',
  fileStorageDeleteError: 'File storage delete error.',
  publicFolderDeleteError: 'Public folder cannot be deleted.',
  internalServerError: 'Something went wrong.',
  serverNotReachable:
    'Server not reachable at the moment, please try again later',
  failedToSendVerificationEmail:
    'Failed to send verification email. Please try again.',
  invalidArgsError: 'Invalid arguments provided.',
  folderNotAllowedHere: 'You are not allowed to create folder here.',
  rolesInsufficientViewPrivileges: "You don't have right to view roles.",
  userGroupsInsufficientPrivileges: "You don't have right to view user groups.",
  waCreateUserRestriction: 'Workspace admin can only create regular users.',
  readOnlyResourceUpdate: 'You are not allowed to update readonly resource.',
  readOnlyResourceDelete: 'You are not allowed to delete readonly resource.',
  rolesUniqueVoilation: 'Role with the name already exists.',
  addPermissionsAgainstResourceError:
    'Failed to add permissions against resource.',
  permissionsUpdatingErrorForRole:
    'Failed to update permissions for the resource.',
  insufficientCreatePrivileges: "You don't have rights to create resource.",
  insufficientUpdatePrivileges: "You don't have rights to update resource.",
  insufficientDeletePrivileges: "You don't have rights to delete resource.",
  insufficientDeleteOneOrMorePrivileges:
    "You don't have rights to delete some resources.",
  userGroupUniqueVoilation: 'User group with the same name already exists.',
  usersUniqueVoilation: 'User already exists!',
  selfAssignmentOnResourceRestriction:
    'You cannot assign a resource to yourself.',
  ruAssignmentAsControllerRestriction:
    'Regular users cannot be assigned as controller.',
  oaRemovalFromResourceDenied:
    'Organization Administrator cannot be removed from resource.',
  insufficientAssignmentPrivileges:
    "You don't have enough rights to perform the operation.",
  peerAccountAssignmentRestriction:
    'You are not allowed to remove same or higher level accounts.',
  messageOnEmptyFolderOrUnavailableFile:
    'Chat cannot be initiated on empty or unavailable resources.',
  noSharedFilesExist:
    'Please upload documents to the workspaces or request admin for access to start using the questioning.',
  itemDetailsNotFoundError: 'Details for this resource could not be found.',
  chatCreditLimitExceededOA:
    'Monthly limit for AI credits reached. For immediate assistance, contact customer support at {{supportEmail}}',
  chatCreditLimitExceeded100Percent: 'Monthly limit for AI credits reached.',
  chatCreditLimitExceeded:
    'Monthly limit for AI credits reached. Please contact your administrator.',
  fileCreditLimitExceededOA:
    'Document processing halted, monthly limit for AI credits reached. For immediate assistance, contact customer support at “support@empowergpt.ai”. ',
  fileCreditLimitExceeded:
    'Document processing halted, monthly limit for AI credits reached. Please contact your administrator.',
  fileWordLimitExceededOA:
    'Document processing halted, word limit for processed documents stored has been reached. Please delete documents that are no longer required to free up space. For further assistance, contact customer support at “support@empowergpt.ai”.',
  fileWordLimitExceeded:
    'Document processing halted, word limit for processed documents stored has been reached. Please delete documents that are no longer required to free up space.',
  creditLimitExceeded90Percent: 'Over 90% of AI credits have been consumed.',
  wordLimitExceeded90Percent:
    'Over 90% of allocated word limit against processed documents stored has been reached',
  wordLimitReached100Percent:
    'Allocated word limit for processed documents stored has been reached. Please delete documents that are no longer required to free up space.',
  furtherAssistanceContactSupport:
    'For further assistance contact customer support at ',
  fileUploadLimitError:
    'You have reached the Trial plan limit of uploading 100 documents.',
  // resource provider errors
  operationNotPermitted: 'Permission to perform the action not found.',
  // Usage
  processedDocuments: 'Processed Documents',
  overallUsage: 'Overall Usage',
  aiUsage: 'AI Usage',
  monthlyUsage: 'Monthly Usage',
  dailyUsage: 'Daily Usage',
  processedDocumentsInfo:
    'Estimated number of words against processed documents stored in workspaces.',
  tokenUsageInfo:
    '{{consumed}} {{unit}} of processed documents stored in the workspaces out of the {{total}} {{unit}} limit',
  aiUsageInfo: 'AI usage for chat, and document processing',
  creditUsageInfo:
    '{{consumed}} {{unit}} used out of the {{total}} {{unit}} limit',
  credits: 'Credits',
  consumed: 'Consumed',
  date: 'Date',
  filesPermission: 'Files are not allowed here',
  noCreditsUsedThisMonth: 'No credits used this month',
  uniqueResourceNameError: 'Resource with same name already exists.',
  resourceNameUnchanged: 'Name must be different from the current name.',
  pleaseUpdateAtLeastOneField: 'Please update at least one field',
  noResourcesShared:
    'Authorized documents are allowed only. Please upload a document first.',
  // users invitations
  inviteUsers: 'Invite Users',
  emailAddress: 'Email Address',
  userGroup: 'User Group',
  active: 'Active',
  draft: 'Draft',
  invited: 'Invited',
  invitationExpired: 'Invitation Expired',
  inactive: 'Inactive',
  resendInvite: 'Resend Invite',
  deActivate: 'Deactivate',
  activate: 'Activate',
  inviteSentSuccessfully: 'Invite sent successfully!',
  inviteSentFailed: 'Error sending invite!',
  userActivated: 'User activated successfully!',
  userDeactivated: 'User deactivated successfully!',
  userActivationFailed: 'Error activating user!',
  userDeactivationFailed: 'Error deactivating user!',
  adUserNotFoundError: 'User not found in AD.',
  userInviteLimitReachedError: 'User invite limit reached.',
  invalidEmail: 'Please enter a valid email address.',
  specialCharNotAllowed: 'Special characters not allowed.',

  // SharePoint
  sharePointAuthError:
    'You might not be able to interact with SharePoint due to connectivity issue!',
  sharepoint: 'Import from SharePoint',
  sharepointModalTitle: 'Select a Folder / Library',
  sharepointModalSubtitle:
    'Navigate to the desired site, and select the target folder / library for importing',
  availableSites: 'Available Sites',
  selectSiteMsg: 'Select a site to view available site content',
  siteContent: 'Site Content',
  showSiteContent: 'Show Site Content',
  select: 'Select',
  resourceImportedSuccessfully: 'Resource imported successfully.',
  resourceImportFailed: 'Failed to import resource.',
  rootSite: 'Root Sites',
  sharePointSuccessModalTitle: 'Folder / Library Linked Successfully',
  externalImportSuccessModalLine1:
    'All set! Selected folder / library along with its contents shall be accessible to you as a Collection once the data sync completes.',
  externalImportSuccessModalLine2:
    'The Collection’s visibility is solely based on its permissions at {{ name }}.',
  noSubSiteAvailable: 'No Sub site available.',
  noFolderFileAvailable: 'No Folder / File available.',
  openInSharePoint: 'Open in SharePoint',
  collectionSharepointPlaceholder: 'Import from Sharepoint',
  collectionSharepointDescription:
    'Import content from Sharepoint to EmpowerGPT',

  // One Drive
  oneDriveMyFiles: 'My Files',
  oneDriveShared: 'Shared with you',
  oneDrive: 'Import from OneDrive',
  oneDriveModalTitle: 'Select a Folder / Library',
  oneDriveModalSubtitle:
    'Navigate within your OneDrive, and select the target content for importing',
  content: 'Content',
  blog: 'Blog',
  oneDriveSuccessModalTitle: 'Folder / Library Linked Successfully',
  oneDriveSuccessModalLine1:
    'All set! Selected folder / library along with its contents shall be accessible to you as a Collection once the data sync completes.',
  oneDriveSuccessModalLine2:
    'The Collection’s visibility is solely based on its permissions at OneDrive.',
  openInOneDrive: 'Open in OneDrive',
  collectionOneDrivePlaceholder: 'Import from OneDrive',
  collectionOneDriveDescription: 'Import content from OneDrive to EmpowerGPT',

  // common external resource provider
  collectionExternalResProvPlaceholder: 'Import from Sharepoint / OneDrive',
  collectionExternalResProvDescription:
    'Import content from Sharepoint or OneDrive to EmpowerGPT',
  externalResourceDisclaimer:
    "The content's visibility is solely based on its permissions at source except within “Public” or “My Workspace",

  // SSO configuration
  redirectUri: 'Redirect URI',
  signInWithMicrosoft: 'Sign in with Microsoft (SSO)',
  signInWithGoogle: 'Sign in with Google (SSO)',
  allowInvitingExternalUsers: 'Allow inviting external users',
  limitUserInvitation: 'Limit user invitation to specified email domain',
  limitUserInvitationPlaceholder: 'example1.com, example2.com',
  externalDriveIntegration: 'Allow Content Import from External Applications',
  syncFrequency: 'Sync Frequency (mins)',
  contentImportFromSharepoint: 'Microsoft Sharepoint',
  contentImportFromOneDrive: 'Microsoft OneDrive',
  contentImportFromConfluence: 'Atlassian Confluence',
  contentImportFromGoogleDrive: 'Google Drive',

  // steps to configure SSO
  letsStart: "Let's start",
  next: 'Next',
  done: 'Done',
  apply: 'Apply',
  welcomeScreenHeading1: 'Steps for SSO',
  welcomeScreenHeading2: 'Configuration',
  registrationStep: 'Register “EmpowerGPT” in Microsoft Entra ID',
  ssoRegistrationHeading: 'Creating a new project in Google Cloud Console',
  googleSSOConsentScreenHeading: 'Configuring OAuth Consent Screen',
  googlePermissionHeading: 'Adding APIs and Scopes',
  googleSecretsHeading: 'Copy Client ID and Client Secret',
  azureDetailsStep:
    'Enter details against the registered application on Microsoft Entra ID',
  configurePermissions:
    'Give required permissions against used APIs to the registered app in Microsoft Entra ID',

  // google SSO configuration
  googleSSOHeading: 'Steps for Google Single-Sign-On (SSO)',
  googleSSOSubHeading: 'Configuration',
  googleSSOStep1: 'Creating a new project in Google Cloud Console',
  googleSSOStep2: 'Configuring OAuth Consent Screen',
  googleSSOStep3: 'Adding APIs and Scopes',

  // SSO configuration RegistrationStep
  registrationPoint1: 'In another tab, sign in to',
  azurePortal: 'Azure Portal',
  roleAzurePortal: 'as an admin.',
  registrationPoint2:
    'Navigate to "Microsoft Entra ID" (Azure Active Directory) > "App registrations" as an admin.',
  registrationPoint3: 'Click on "+ New registration".',
  registrationPoint4:
    'Enter “EmpowerGPT” as the name of the application and select the required supported account types. (Recommended: “Accounts in this organizational directory only”).',
  registrationPoint5:
    'Under the “Redirect URI” section on the application registration form, select “Web” as the type and paste the following Redirect URI in the corresponding field.',
  confirmationStep1:
    'The above steps have been performed on the registered application in Microsoft Entra ID.',
  // Registration Step form validation
  redirectUriRequired: 'Redirect URI is required',

  // SSO configuration Azure Details Step
  azureDetailsPoint1:
    "Once the application is registered, you will be redirected to the registered application's “Overview” page.",
  azureDetailsPoint2:
    'Copy the “Application (client) ID” and “Directory (tenant) ID” from the “Overview” page and enter each it in the respective fields below.',
  azureDetailsPoint3:
    'Navigate to “Certificates and secrets” under the “Manage” section on the registered application in Microsoft Entra ID.',
  azureDetailsPoint4:
    ' Select the “Client secrets” tab and click “New client secret” button to create a new client secret. Enter “EmpowerGPT client secret” in description, set the expiry to 24 months (recommended) and click “add”.',
  azureDetailsPoint5:
    'Copy the secret "Value" and paste it in the field below. Client secret values cannot be viewed. except for immediately after creation. Be sure to save the secure value when created before leaving the page.',
  // Azure Details Step form validation
  clientIdRequired: 'Client Id is required',
  labelClientId: 'Application (client) Id: ',
  tenantIdRequired: 'Tenant Id is required',
  labelTenantId: 'Directory (tenant) Id:',
  secretValueRequired: 'Secret Value is required',
  labelSecret: 'Client Secret Value:',
  enter: 'Enter...',
  enterNote: 'Enter note...',
  failedToSendEmail: 'Email not found',
  // SSO configuration Permissions Step
  permissionsStep1:
    'Navigate to “API permissions” under the “Manage” section on the registered application in Microsoft Entra ID.',
  permissionsStep2:
    'Click "+ Add a permission" button and select "Microsoft Graph" under Microsoft APIs.',
  permissionsStep3:
    'Select "Application permissions" to give the following permissions and confirm by clicking "add permission" button below.',

  permissionsStep4: 'User.ReadBasic.All under User.',
  permissionsStep5: 'Group.Read.All under Group.',
  permissionsStep6: 'GroupMember.Read.All under GroupMember.',
  permissionsStep7:
    'Repeat step 2 and select "Delegated permissions" to give the "profile" permission. Confirm by clicking "add permission" button below.',
  permissionsStep8:
    'The above steps have been performed on the registered application in Microsoft Entra ID.',
  adUserSearchQuestion:
    'Do you want to enable searching for Active Directory users?',
  adUserSearchEnableOption: 'Yes, enable AD user search',
  adUserSearchEnableOptionDescription: 'Adds User.ReadBasic.All',
  adUserSearchDisableOption: 'No, do not enable AD user search',
  adUserSearchDisableOptionDescription: 'Invite people by email instead',
  adUserSearchDisclaimer:
    'The system will not be able to search Active Directory users. You can still invite people to EmpowerGPT by email address.',

  successDialogTitle: 'SSO Configured Successfully',
  successDialogDescription:
    'SS0 has been successfully configured against users within the linked directory.',
  clickHere: 'Click here',
  toLogout: ' to logout and test the configuration.',

  // Realm and Tenant configuration
  continue: 'Continue',
  discoverTenant: 'Login',
  tenants: 'Tenants',
  modelConfiguration: 'Model Configurations',
  defaultChatModel: 'Default Chat Model',
  defaultChatModelMoto:
    'Choose the default model for all new chats. Members can change this by selecting\ntheir own default model in account settings.',
  modelConfigurationMoto:
    'Choose which models are permitted in your workspace.',
  searchModelsPlaceholder: 'Search models',
  regionHostedEu: 'Hosted in the EU',
  regionHostedUs: 'Hosted in the US',
  regionHostedGlobal: 'Hosted globally',
  regionHostedOther: 'Hosted in {{region}}',
  allModels: 'All Models',
  domain: 'Domain',
  subDomain: 'Sub Domain',
  newTenant: 'New Tenant',
  addNewModel: 'Add New Model',
  addModel: 'Add Model',
  editModel: 'Edit Model',
  updateModel: 'Update Model',
  models: 'Models',
  tenantCreatedSuccessfully:
    'Email invite sent to {{enteredEmail}}, Tenant created for {{parsedDomain}}',
  emailSendSuccessfully: 'Email invite sent to {{enteredEmail}}',
  tenantDeletedSuccessfully: 'Tenant deleted successfully',
  tenantCreationFailed: 'Error creating Tenant',
  tenantDeletionFailed: 'Error deleting Tenant',
  tenantUniqueViolation: 'Tenant already exists',
  invalidDomain: 'Not a registered email',
  selfSignupFailed: 'Self signup failed',
  workEmailRequired: 'Work email required.',
  selfSignupConfirmation1: 'Please wait, creating account',
  selfSignupConfirmation2: 'An invite has been sent at {{email}}',
  selfSignupConfirmation3:
    'Click on “click to proceed” button in the received email to setup up your account. The invitation link will expire after [7] days.',
  back: 'Back',
  confirmDeleteTenant: 'Are you sure, you want to delete tenant "{{name}}"?',
  confirmReprocessFilesTenant:
    'Are you sure, you want to reprocess all files for this tenant?',
  fileIdsToReprocess: 'Enter file IDs to reprocess (comma-separated):',
  onlyReprocessSelectedFiles: 'Only reprocess selected files',
  reprocessAllFiles: 'Reprocess All Files',
  reprocessAllFilesConfirmation:
    'Are you sure you want to reprocess all files for the tenants?',
  userDomainName: 'User domain name',
  firstSignedUpEmail: 'First signed up Email',
  totalUsers: 'Total users',
  dateLastSignedUsers: 'Date last user signed in',
  tenantReprocessFiles: 'Reprocess Tenant Files',
  tenantDelete: 'Delete Tenant',
  selectTenant: 'Select Tenant',
  tenantFileReprocessingFailed: 'Failed to reprocess files of tenant',
  tenantFileReprocessingTriggered:
    'File reprocessing of tenant started successfully',
  tenantNoFilesToProcess: 'No files found to reprocess of tenant',
  tenantPlanUpdatedSuccess: 'Tenant plan updated successfully',
  tenantPlanUpdateFail: 'Tenant plan update failed',

  // Resource Provider config
  resourceProviderWelcomeTitle: 'Steps to Configure Importing from SharePoint',
  oneDriveResourceProviderWelcomeTitle:
    'Steps to Configure Importing from OneDrive',
  googleDriveDriveResourceProviderWelcomeTitle:
    'Steps to Configure Importing from Google Drive',
  resourceProviderTitle1:
    'Upload generated certificate at registered application “EmpowerGPT” on Microsoft Entra ID',
  googleProviderTitle1:
    'Create Google Cloud Project and create a Service Account',
  resourceProviderStep1Instruction1:
    "Paste the base URL for your organization's SharePoint below. (The base URL for SharePoint Online is provisioned based off your input when setting up your Microsoft 365 subscription. For example, if your organization name is Contoso, the root site for SharePoint Online will be https://contoso.sharepoint.com.).",
  resourceProviderStep1Instruction2:
    'Click the button below to download the required certificate.',
  resourceProviderStep1Instruction3:
    'In another tab, sign in to Azure Portal as an admin.',
  resourceProviderStep1Instruction4:
    'Navigate to “Microsoft Entra ID” (Azure Active Directory) > “App registrations” > ”All applications” > ”EmpowerGPT”.',
  resourceProviderStep1Instruction5:
    'Select the application and navigate to “Certificates and secrets” under the Manage section.',
  resourceProviderStep1Instruction6:
    'Select the “Certificates” tab and click on upload certificate. Upload the above generated certificate, downloaded on your computer.',
  resourceProviderStep1Instruction7:
    'Enter suitable description and click the "Add" button to add the certificate.',
  resourceProviderTitle2:
    'Give required permissions against used APIs to the registered app in Microsoft Entra ID',
  googleProviderTitle2: 'Grant domain-wide access',
  googleProviderTitle3: 'Connect the service account with EmpowerGPT',
  resourceProviderStep0Instruction0Start: `In another tab, sign in to `,
  resourceProviderStep0Instruction0End: ` as an admin`,
  resourceProviderStep2Instruction1:
    'Navigate to “Microsoft Entra ID” (Azure Active Directory) > “App registrations” > ”All applications” > ”EmpowerGPT” > “API Permissions”.',
  resourceProviderStep2Instruction2:
    'Click “+ Add a permission” button and select “Microsoft Graph” under Microsoft APIs.',
  resourceProviderGraphPermissionsSectionTitle:
    'Microsoft Graph API permissions',
  resourceProviderSharePointPermissionsSectionTitle:
    'SharePoint API permissions',
  resourceProviderSitesSelectedAccessDisclaimer:
    "Granting Sites.Selected does not provide access on its own. An administrator must assign each required site to EmpowerGPT before it can import from them. See <guideLink>Microsoft's guide</guideLink>.",
  resourceProviderStep2Instruction3:
    'Select “Application permissions” to give the following permissions and confirm by clicking “add permission” button below.',
  resourceProviderStep2Instruction5: 'Sites.Read.All.',
  resourceProviderStep2Instruction5Selected: 'Sites.Selected.',
  resourceProviderSitesReadAllTitle: 'Give EmpowerGPT access to all sites',
  resourceProviderSitesReadAllDescription: 'Uses Sites.Read.All',
  resourceProviderSitesSelectedTitle:
    'Give EmpowerGPT access to only selected sites',
  resourceProviderSitesSelectedDescription: 'Uses Sites.Selected',
  resourceProviderStep2Instruction6: 'Files.Read.All.',
  resourceProviderStep2Instruction7:
    'Repeat step 2 and select "Delegated permissions" to give the following permissions. Confirm by clicking "add permission" button below.',
  resourceProviderStep2Instruction7OneDrive:
    'Select "Delegated permissions" to give the following permissions. Confirm by clicking "add permission" button below.',
  resourceProviderStep2Instruction8:
    'Click "+ Add a permission" button and select "SharePoint" under Microsoft APIs to give the following "Application permission". Click "add permission" to confirm.',
  sharepointConfigurationSuccessTitle: 'Importing from SharePoint Configured',
  sharepointConfigurationSuccessDescription1:
    'Content can now be imported from SharePoint sites in EmpowerGPT as collections.',
  sharepointConfigurationSuccessDescription2:
    "Imported content's visibility will be based on its permissions at SharePoint.",

  oneDriveConfigurationSuccessTitle: 'Importing from OneDrive Configured',
  oneDriveConfigurationSuccessDescription1:
    'Content can now be imported from OneDrive in EmpowerGPT as collections.',
  oneDriveConfigurationSuccessDescription2:
    "Imported content's visibility will be based on its permissions at OneDrive.",
  Navigate: 'Navigate',
  downloadCertificate: 'Download Certificate',
  invalidSharePointUrl: 'Invalid SharePoint URL provided.',
  identityProviderEnabledSuccessfully: '{{name}} (SSO) enabled successfully.',
  identityProviderDisabledSuccessfully: '{{name}} (SSO) disabled successfully.',
  identityProviderUpdateFailed: 'Error updating {{name}} (SSO).',
  resourceProviderUpdateFailed: 'Error updating SharePoint.',
  identityProviderCreationFailed: 'Error enabling {{name}} (SSO).',
  disabledToolTipMicrosoftSSO: 'Configure Microsoft SSO to enable.',
  disabledToolTipGoogleSSO: 'Configure Google SSO to enable.',
  requiredCheckbox: 'This field is required.',
  adminConsent:
    'Make sure admin consent is provided for permissions that require it, indicated by a “Yes” in the “Admin consent required” column of the “Configured permissions” table.',

  resourceProviderSharePointEnabledSuccessfully:
    'SharePoint enabled successfully.',
  resourceProviderOneDriveEnabledSuccessfully: 'OneDrive enabled successfully.',
  resourceProviderSharePointDisabledSuccessfully:
    'SharePoint disabled successfully.',
  resourceProviderOneDriveDisabledSuccessfully:
    'OneDrive disabled successfully.',
  resourceProviderSharePointCreationFailed: 'Error enabling SharePoint.',
  resourceProviderOneDriveCreationFailed: 'Error enabling OneDrive.',

  //Internal Analytics
  analytics: 'Analytics',
  overview: 'Overview',
  words: 'words',
  currentMonth: 'This Month',
  chatAnalyticsHeading: 'Feature Engagement',
  dislikes: 'Dislikes',
  AF_DAC: 'Analysis',
  AF_DAQNC: 'Questionnaires',
  AF_DAQC: 'Questions',
  AF_ASQ: 'Searches',
  conversations: 'Chats',
  messageSuccessRate: 'Message Success Rate',
  currentMonthTooltip:
    'Compares performance of the current month against the previous month.',
  lastMonthTooltip:
    'Compares performance of last month against the month before it.',
  ytdTooltip:
    'Compares performance from the start of the year to date against the same period last year.',
  lastWeekTooltip:
    'Compares performance of last 7 days with the previous week.',
  lastDayTooltip:
    'Compares performance of the last 24 hours with the previous day.',
  conversationVsQueries: 'Conversations vs Queries Asked',
  processDocTooltip:
    'Words processed across all documents\n during the selected time period compared\n to your total limit.',
  creditsTooltip:
    'Shows in-plan credit usage only.\n PAYG usage appears in the PAYG dashboard.',
  conversationTooltip:
    'Chats are conversations started; Messages are individual queries within them. A busy day can have few chats but many queries.',
  questions: 'Questions',
  documentsUploaded: 'Documents uploaded',
  assistantsCreated: 'Assistants Created',
  time: 'Time',
  userOrGroups: 'Users',
  fetchResourceCountError: 'Failed to fetch resource counts',
  chatEngagement: 'Chat Engagement',
  lastDay: 'Last 24 Hours',
  lastWeek: 'Last 7 Days',
  lastMonth: 'Last Month',
  selectDate: 'Pick a date range',
  allTime: 'All Time',
  thisQuarter: 'This Quarter',
  lastQuarter: 'Last Quarter',
  thisYear: 'This Year',
  lastYear: 'Last Year',
  yearToDate: 'Year to date',
  startDateError: 'Start date cannot be after end date',
  resetToCurrentMonth: 'Current Month',
  creditSpent: 'Credit Spent',
  dateRange: 'Date Range',
  conversation: 'Conversations',
  queriesAsked: 'Queries Asked',
  messages: 'Messages',
  documentAnalyst: 'Document Analyst (Analysis)',
  smartMeetAnalyst: 'Smart Meet (No. of Meetings)',
  dataAnalysis: 'Data Analyst (Analysis)',
  questionnairesCreated: 'Questionnaires Created',
  topAssistants: 'Top Assistants',
  creditsSpentDetail: 'Credits Spent Detail',
  creditConsumption: 'Credit Consumption',
  user: 'User',
  feature: 'Feature',
  creditsUsed: 'Credits Used',
  modelUsed: 'Model Used',
  total: 'Total',
  Unsupported: 'Unsupported',
  Processed: 'Processed',

  // User Favourites
  favourites: 'Favourites',
  markFavourite: 'Mark as favourite',
  unmarkFavourite: 'Unmark as favourite',
  markedFavourite: 'Marked as favourite',
  unmarkedFavourite: 'Unmarked as favourite',
  markFavouriteError: 'Error marking as favourite',
  unmarkFavouriteError: 'Error unmarking as favourite',
  favouriteLimitReached: 'User favourites limit reached',
  // user onboard
  welcomeText: 'Welcome to',
  welcomeText1:
    'EmpowerGPT is an AI Platform made for Enterprises. Chat securely with state-of-the-art LLMs incorporating your enterprise and world knowledge.',
  welcomeText2: `Expand your enterprise’s knowledge base by uploading, or importing data from integrated applications.`,
  welcomeText3: 'Start your EmpowerGPT trial',
  // User Onboarding
  //Chat
  gotIt: 'Got it',
  chatBranched: 'Chat Branched',
  chatBranchedFrom: 'Branched from',
  chatBranchedFromFallback: 'a previous chat',
  onNext: 'Click Next to continue.',
  chatStep1Title: 'Chat: Select the required knowledge domain.',
  chatStep1Description: `Choose how you want EmpowerGPT to respond. Stick to enterprise knowledge for answers in light of accessible enterprise documents. Or switch to world knowledge for assistance in content creation, coding, research and access to world knowledge.`,
  chatStep2Title: 'Chat: Type in your query.',
  chatStep2Description: `Use the input field below to enter your queries, and hit the send button on the right. Context against prior queries and responses is limited within a chat`,
  chatStep3Title: 'Chat: Review the facts.',
  chatStep3Description: `Chat responses in enterprise knowledge have references cited at the end. It is recommended to validate the authenticity of the response by viewing the references.`,
  chatQuery:
    'Write an email to congratulate the marketing department on achieving a 15% increase in revenue for Q3 2025.',
  today: 'Today',
  yesterday: 'Yesterday',
  thisWeek: 'This week',
  thisMonth: 'This month and older',
  chatHistory: 'Chat History',
  noChatHistory: 'No chat history',
  chatDeleted: `Can't continue conversation on a deleted chat`,
  imageGenerationLimitReached: 'Image generation limit reached',
  modelCoolDownTooltip: 'Usage limit reached. Retry after sometime',
  assistantResourceNotFound:
    'Unable to generate a response. Updates have been made to the assistant. Please refresh the page to apply the changes.',

  // Data Library
  documentStep1Title: 'Upload: Navigate to the Workspaces',
  documentStep1Description:
    'Workspaces categorize documents within an organization.',
  documentStep2Title: 'Upload: Select the required Workspace.',
  documentStep2Description: `Actions available on a workspace are based on the role you have been assigned on them. “My Workspace” is a personal workspace, you can add documents and chat with.`,
  documentStep3Title: 'Upload: Create a collection.',
  documentStep3Description: `Collections further classify documents within each workspace. Create your collection within the My workspace to upload documents inside.`,
  documentStep4Title: 'Upload: Select documents to upload',
  documentStep4Description: `EmpowerGPT supports a wide variety of document formats for users to add to the knowledge base, including PDFs (scanned documents as well), Word documents, Powerpoint slides, and Excel files.`,
  documentStep5Title: 'Upload: Understanding document status',
  documentStep5Description: `Documents once uploaded are queued for AI processing. Once marked as “Processed”,  users who have access to these documents can chat with them.`,

  // Projects
  projects: 'Projects',
  projectsHeaderText:
    'Use projects to set common instructions, attach files, and organize chats.',
  projectsMoto: 'Use projects to combine and organize chats.',
  newProject: 'New Project',
  createProjectPlaceholder: 'Get started by creating a new project',
  projectDescription:
    'Projects help you set common instructions and attach files for conversations.',
  createProject: 'Create a new Project',
  updateProject: 'Update Project',
  createNewProject: 'Create New Project',
  createProjectDescription:
    'Create a separate project to organize conversation.',
  projectName: 'Project Name',
  projectDescriptionPlaceholder: 'Add a description for your project',
  removeFromProject: 'Remove from Project',
  addSources: 'Add sources',
  noSharedProjectsTitle: 'No shared projects yet',
  noSharedProjectsDescription: 'Projects shared with you will appear here.',
  noProjectChatsTitle: 'You don’t have any chats',
  noProjectChatsDescription:
    'Start a new chat to begin your conversation. No chats yet!',
  noProjectSourcesTitle: 'You don’t have any sources',
  noProjectSourcesDescription: 'Request access to view project sources.',
  noExistingProject: 'No existing project found.',
  noExistingProjectDescription:
    'Create a project to organize your conversations.',
  failedFetchingProject: 'Failed to fetch project.',
  failedFetchingProjects: 'Failed to fetch projects.',
  failedDeletingProjects: 'Failed to delete projects.',
  deleteProject: 'Delete the project!',
  projectDeleteConfirmation: 'Are you sure you want to delete this project?',
  projectDeleteSuccess: 'Project deleted successfully.',
  projectUpdateSuccess: 'Project updated successfully.',
  projectCreationSuccess: 'Project created successfully.',
  projectShareSuccess: 'Project shared successfully.',
  projectForkDisclaimerText:
    'This conversation is between EmpowerGPT and {{username}}. Replying will start a new branch.',
  projectChatViewerReadOnly:
    'This chat is read-only — you have viewer access to this project.',
  projectNameAlreadyExists: 'Project with the same name already exists.',

  // Invite User
  inviteUserStep1Title: 'Invite: Open up the menu',
  inviteUserStep1Description:
    'Menu buttons contains links to pages required to setup, manage the application, and your account.',
  inviteUserStep2Title: 'Invite: Navigate to the users page',
  inviteUserStep2Description:
    'Users page contains list of all people currently on the empowerGPT platform. Admins can invite users from this page.',
  inviteUserStep3Title: `Invite: Type in the invitee’s email`,
  inviteUserStep3Description:
    'Type the emails for the invitees, select their account type, and user groups if any, before sending them the invite.',

  // Chat models comments and descriptions
  mistralLargeComment: 'Alternate',
  mistralLargeDescription: 'Hosted on Microsoft Azure in the EU',
  llama370BInstructComment: 'Open Source',
  llama370BInstructDescription: 'Hosted on Microsoft Azure in the EU',
  llama38BInstructComment: 'Open Source',
  llama38BInstructDescription: 'Hosted on Microsoft Azure in the EU',
  gpt4TurboComment: 'Accurate',
  gpt4TurboDescription: 'Hosted on Microsoft Azure in the EU',
  gpt432kComment: 'Best',
  gpt432kDescription: 'Hosted on Microsoft Azure in the EU',
  gpt4oComment: 'Fast & Accurate',
  gpt4oDescription: 'Hosted on Microsoft Azure in the EU',
  cohereComment: 'Enterprise Optimized',
  cohereDescription: 'Hosted on Microsoft Azure in the EU',
  gpt35Turbo16kComment: 'Fast',
  gpt35Turbo16kDescription: 'Hosted on Microsoft Azure in the EU',
  deepseekV3Comment: 'Fast',
  deepseekV3Description: 'Hosted on Microsoft Azure in the EU',

  accuracy: 'Accuracy',
  speed: 'Speed',
  price: 'Price',
  tokenLimit: 'Token Limit',
  imageAnalysis: 'Image Analysis',
  knowledgeCutoff: 'Knowledge Cutoff',
  default: 'Default',
  markAsDefault: 'Mark as Default',
  defaultModelFallback:
    'Default model {{prevModel}} is no longer available. {{newModel}} has been made default model for new chats instead.',
  defaultModelAlreadySelected:
    '{{modelName}} is already selected as default model.',
  defaultModelUpdated: 'Default model set successfully!',
  defaultModelSetError: 'Error updating default model!',
  defaultModelUpdateError: 'Error, in updating default model',
  errorGettingModel: 'Error getting model details',
  errorConfiguringModel: 'Error configuring model',
  errorConfiguringChatModel: 'Error configuring default chat model',
  errorConfiguringModelProperties: 'Error configuring model properties',

  // Prompts
  promptTitle1: 'Make shorter',
  promptText1:
    'Condense the following text to [insert_word_count] words, ensuring all important information is retained: [insert_text_here].',
  promptTitle2: 'Make longer',
  promptText2:
    'Expand the following text to [insert_word_count] words, ensuring no irrelevant details are added: [insert_text_here].',
  promptTitle3: 'Change tone',
  promptText3:
    'Rewrite the following text in a [specified_tone] tone, ensuring the message remains clear and effective: [insert_text_here].',
  promptTitle4: 'Fix grammar & spellings',
  promptText4:
    'Correct the grammar and spelling in the following text, highlighting all changes by making the corrected words bold: [insert_text_here].',
  promptTitle5: 'Translate',
  promptText5:
    'Translate the following text into [specified_language], ensuring that all named entities, abbreviations, and acronyms are accurately preserved: [insert_text_here].',
  promptTitle6: 'Summarize',
  promptText6:
    'Summarize the following text to [word_count] words, ensuring all important information is retained and the overall message remains unchanged: [insert_text_here].',
  promptTitle7: 'Give feedback',
  promptText7:
    'Provide feedback on the following text, focusing on the specified areas: [technical, tone, grammar, format]. Ensure your feedback is constructive and helps improve the text: [insert_text_here].',
  promptTitle8: 'Brainstorm ideas',
  promptText8:
    'Brainstorm [number_of_ideas] creative and practical ideas for the following task: [task+optional_examples]',
  promptTitle9: 'Write an email',
  promptText9:
    'Write an email based on the convey the following message: [message]. Ensure the tone is [specified_tone] and length of the email is [specified_length].',
  promptTitle10: 'Write a social media post',
  promptText10:
    'Write a social media post for [specified_platform] keeping a [specified_tone] tone, targeted at [target_audience]. Include engaging and platform-appropriate content.',

  // Mini Experts - Doc Analyst
  miniExperts: 'Apps',
  docAnalyst: 'Document Analyst',
  docAnalystDescription: `Analyze enterprise documents to quickly extract key information against a list of questions.`,
  docClassifierDescription:
    'Categorize and label documents based on their content against a list of labels.',
  smartMeetDescription:
    'Summarize meetings to quickly capture key takeaways against a defined format.',
  dataAnalystSummary:
    'Analyze Excel files to uncover trends, patterns, and insights.',
  analysis: 'Analysis',
  documentClassification: 'Document Classifier',
  comingSoon: 'Coming Soon',
  summaryGenerator: 'Summary Generator',
  dataCollections: 'Data Collections',
  initiate: 'Initiate',
  newAnalysis: 'New Analysis',
  initiateAnalysis: 'Initiate Analysis',
  confirmationDialog: 'Confirmation Dialog',
  dataset: 'Dataset',
  inProcessFiles: 'Following files are in progress.',
  questionnaire: 'Questionnaire',
  runAnalysis: 'Run Analysis',
  runAnalysisPlaceholder:
    'To initiate Analysis, enter Analysis Name.\nSelect Dataset and Questionnaire, then click on “',
  importFromApp: 'Import from App',
  regenerateAnalysis: 'Regenerate Analysis',
  saveAnalysis: 'Save Analysis',
  clone: 'Clone',
  numberOfFiles: 'No. of files',
  numberOfQuestions: 'Ques. count',
  filesImportSuccess: 'Files/Folder imported successfully',
  filesImportFailure: 'Files/Folder import failed',
  spSitePermissionDenied:
    "This SharePoint site isn't enabled for import. Contact your administrator to request access.",
  import: 'Import',
  analysisTitle: 'Analysis Title',
  datasetTitle: 'Dataset Title',
  enterAnalysisTitle: 'Enter analysis title',
  analysisDeleteConfirmation: 'Are you sure you want to delete the Analysis?',
  analysisDeleteSuccess: 'Analysis deleted successfully!',
  analysisCancelSuccess: 'Analysis cancelled successfully!',
  analysisDeleteFailed: 'Analysis deletion failed. Try again later!',
  datasetDeleteConfirmation: 'Are you sure you want to delete the Dataset?',
  datasetDeleteSuccess: 'Dataset deleted successfully!',
  datasetDeleteFailed: 'Dataset deletion failed. Try again later!',
  questionnaireDeleteConfirmation:
    'Are you sure you want to delete the Questionnaire?',
  questionnaireDeleteSuccess: 'Questionnaire deleted successfully!',
  questionnaireDeleteFailed: 'Questionnaire deletion failed. Try again later!',
  addQuestionnaire: 'New Questionnaire',
  addQuestion: 'Add question',
  title: 'Title',
  questionnaireTitlePlaceholder: 'Enter questionnaire title',
  questionnaireQuestionPlaceholder: 'Enter question',
  questionnaireWebLinkPlaceholder: 'Enter web link',
  questionnaireCreationSuccess: 'Questionnaire created successfully.',
  questionnaireUpdatedSuccess: 'Questionnaire updated successfully.',
  questionnaireCreationFailure: 'Questionnaire creation failed.',
  questionnaireUpdateFailure: 'Questionnaire update failed.',
  questionUpdatedSuccess: 'Questionnaire updated successfully.',
  datasetCorrupted: 'Source file deleted',
  selectItemsToImport: 'Select items to import',
  importFilesDisclaimer: 'You can select 10 items',
  maximumDatasetSize: 'Maximum 10 files allowed in a dataset',
  minimumDatasetSize: 'Atleast 1 file is required to create a dataset',
  questionnaireBlocked: 'Questionnaire can not be edited due to association.',
  analysisFailed: 'Document Analysis Failed',
  analysisResourceFailure: "Error! Dataset resource(s) doesn't exist",
  analysisLimit:
    'Running Analyses limit reached! Please wait since another analysis is in-progress.',
  analysisEditingBlocked:
    'Analysis editing blocked. Please wait while in-progress analysis is completed.',
  closeAnalysisTitle: 'Cancel response/ Run in background',
  cancelAnalysis: 'Cancel Analysis',
  runInBackground: 'Run in background',
  newQuestionnaire: 'New Questionnaire',
  continueAnalysis: 'Continue Analysis',
  newDataset: 'New Dataset',
  analysisDescription:
    'Analyze document datasets with purpose-specific questionnaires.',
  skeletonTitle: 'Ready to run your first analysis?',
  skeletonDescription:
    'Create questions, pick datasets, and uncover insights. Transform your enterprise data into precise, actionable answers',
  analysisPlaceHolderTitle: 'You haven’t performed any analysis!',
  datasetPlaceHolderTitle: 'You don’t have any dataset available!',
  createDataset: 'Create Dataset',
  questionnairePlaceHolderTitle: 'You don’t have any questionnaire available!',
  createQuestionnaire: 'Create Questionnaire',
  startAnalysis: 'Start Analysis',
  noAnalysisFound: 'No analysis found',
  datasetDescription: 'Create Datasets for documents to be analyzed',
  questionnaireDescription:
    'Create list of questions to analyze your documents against',
  inProgressAnalysis: 'Cancel Analysis',
  inProgressAnalysisDescription:
    'Responses to the remaining question will not be generated by cancelling the analysis?',

  regeneratingResponse: 'Regenerating response',
  updateQuestionnaire: 'Update Questionnaire',
  updateAssociatedQuestionnaireDescription:
    'Questionnaire with previous association can not be updated.',
  newQuestionnaireDescription: 'Save a new copy of questionnaire.',
  saveNew: 'Save New',
  analysisQuestionnaireUpdateLimit:
    'Questionnaire associated with other Analyses can not be updated.',
  newAnalysisTooltip: 'Analysis is already in-progress',
  analysisDetail: 'Analysis Detail',
  selectDataset: 'Select Dataset',
  selectQuestionnaire: 'Select Questionnaire',
  docAnalystDuplicationError: 'An item with the same title already exists.',
  generating: 'Generating',
  edited: 'Edited',
  updateQuestionnairePending: 'Update Questionnaire Pending',
  updateQuestionnairePendingDescription:
    'Please update questionnaire before exiting.',
  dateCreated: 'Date Created',
  clearAll: 'Clear All',
  questionnaireAssociationMsg: ` You can't edit the questionnaire due to its association with analysis.`,
  questionnaireName: 'Questionnaire Name',
  enterQuestionnaireName: 'Enter Questionnaire Name',
  updateQuestionnaireDescription:
    'Questionnaire is Updated. Click ‘Update’ to save changes.',
  updateQuestionnaireDialogTitle: 'Save Changes in Questionnaire',
  createdOn: 'Created On',
  datasetDeletedTooltip:
    'Original Dataset has been deleted / modified by owner.',
  mainFeatures: 'Main Features',
  model: 'Model',
  modelName: 'Model Name',
  addDate: 'Added Date',
  providedBy: 'Provided By',
  knowledgeCutoffDate: 'Knowledge Cutoff Date',
  modelProvidedBy: 'Model Provided By',
  modelDeploymentProvider: 'Model Deployment Provider',
  modelUpdate: 'Model {{modelName}} {{status}} successfully',
  enabled: 'enabled',
  disabled: 'disabled',
  modelUpdateFailed: 'Error Updating model',
  modelCreate: 'Model created successfully',
  modelCode: 'Model Code',
  modelPriority: 'Model Priority',
  ragCost: 'Rag Cost',
  ctFactor: 'CT Factor',
  ptFactor: 'PT Factor',
  modelRegion: 'Region',
  modelAvailabilityInFeature: 'Model Availability in Features',
  deprecate: 'Deprecate',
  fromDate: 'From Date',
  confirmDeprecateModelMessage:
    'Are you sure you want to deprecate this model?',
  confirmDeprecateModelTitle: 'Deprecate Model',
  sendQuestionnaire: 'Send Questionnaire',
  sentTo: 'Sent To',
  questionnaireSendSuccess: 'Questionnaire sent successfully',
  receivedFrom: 'Received From',
  questionnaireNotSharedYet: 'Not shared with anyone yet.',
  sentHistory: 'Sent History',
  byMe: 'By Me',
  all: 'All',
  filesDeletedInDatasetDisclaimer: 'Some files have been deleted.',
  allFilesDeletedInDatasetDisclaimer:
    'All files in the dataset have been deleted.',
  resourceName: 'Resource Name',
  received: 'Received',
  usageLimitReached: 'Usage limit reached. Retry at {{availableAt}}',
  docAnalystUsageLimitReached:
    'Usage limit reached. Please try again after some time.',
  uploadFilesText: 'You can upload documents, audios, and videos. (max. 100MB)',
  processingFiles: 'Uploaded files are being processed',
  simpleAnalysis: 'Simple Analysis',
  scoringAnalysis: 'Scoring Analysis',
  statistics: 'Statistics',
  responseRanges: 'Responses ranges between',
  goodResponse: '81% - 100% for good',
  averageResponse: '51% - 80% for average',
  badResponse: '0% - 50% for bad',
  goodResponses: 'Good Responses',
  averageResponses: 'Average Responses',
  badResponses: 'Bad Responses',

  //Smart Meet
  regenerate: 'Regenerate',
  short: 'Short',
  medium: 'Medium',
  detailed: 'Detailed',
  playRecording: 'Play Recording',
  resumeRecording: 'Resume Recording',
  maxTwoHours: '(Max 2 hours)',
  uploadRecording: 'Upload Recording',
  askAboutConversation: 'Ask Empower about this conversation',
  deleteMeetingSuccess: 'Meeting deleted successfully!',
  deleteMeetingError: 'Failed to delete meeting.',
  smartMeet: 'Smart Meet',
  newRecording: 'New Recording',
  processRecording: 'Process Recording',
  notesParsingError: 'Failed to parse notes.',
  genericNameError: 'Failed to update name.',
  stopRecordingError: 'Failed to stop recording.',
  storageUnavailableError:
    'Browser storage is unavailable. Please check your browser settings and storage.',
  transcriptionGenerationError: 'Failed to generate transcription.',
  summaryRegenerationAlert:
    'Are you sure you want to continue? This will regenerate your meeting data.',
  transcriptRegenerationAlert:
    'Are you sure you want to continue? This will reprocess meeting audio and data.',
  askEmpowerNoDataAlert: 'Chat is unavailable for shared meetings.',
  meetingDeleteConfirmation: 'Are you sure you want to delete this meeting?',
  discard: 'Discard',
  discardMeetingAlert:
    'Are you sure you want to discard this meeting? All data will be lost.',
  failedFetchingMeetings: 'Failed to fetch meetings.',
  fileProcessingRequestSubmitted: 'Your file has been queued for processing.',
  fileProcessingStarted: 'Processing your file.',
  fileProcessingCompleted: 'File processing completed.',
  embeddingsDeletionRequestSubmitted: 'Meeting data cleanup requested.',
  embeddingsDeletionStarted: 'Clearing previous processing results.',
  embeddingsDeletionCompleted: 'Previous meeting data removed.',
  smJobInitiationError:
    'Unable to start smart meet data generation. Please click Retry to try again.',
  transcriptionNotFoundError: 'Failed to find transcription for the meeting.',
  processingMeetingGenericError:
    'Something went wrong while executing this step. Please click Retry to try again.',
  meetingProcessingFailed:
    'Meeting processing failed. Please click Retry to try again.',

  //Data Analyst
  dataAnalyst: 'Data Analyst',
  dataAnalystInfo: 'Analyze your data with AI-powered insights',
  dataAnalystDescription:
    'Your all in one Gen AI expert for analyzing enterprise data with custom queries.',
  noExistingAnalysis: 'No existing analysis found.',
  noExistingAnalysisDescription:
    'Start a new analysis and chat with your enterprise data!',
  dataAnalystWelcomeTitle: `Upload your Excel file and let's start analyzing!`,
  enterTitle: 'Enter title',
  resume: 'Resume',
  pause: 'Pause',
  summaryDescription:
    'Here is a concise overview of our meeting highlights, crafted with the help of Smart Meet AI.',
  summaryMeeting: 'Summarize meetings and create action items in seconds.',
  exportToPdf: 'Export to PDF',
  exportToExcel: 'Export to Excel',
  meetings: ' Meetings',
  thisMeet: 'This Meet',
  thisMeetTooltip:
    'Ask questions, get summaries, and find information from this meeting. ',
  askSmartMeet: 'Smart Meet',
  askSmartMeetTooltip:
    'Ask questions, get summaries, and find information from all meetings. ',
  record: 'Record',
  notes: 'Notes',
  stop: 'Stop',
  addNotes: 'Add Notes',
  summary: 'Summary',
  transcript: 'Transcript',
  actionItems: 'Action Items',
  renameSpeakers: 'Rename Speakers',
  nameYourAttendees: 'Name your Attendees',
  speakerDescription:
    'There were {{count}} speakers in your recording. Name your speakers for easy identification.',
  tagSpeakers: 'Tag Speakers',
  browseToSelectAudioFiles: 'Browse to select audio files',
  onlyMP3FilesAllowed: 'Only mp3 Files are allowed',
  meetingPurpose: 'Meeting Purpose',
  keyTakeaways: 'Key Takeaways',
  addTakeAway: 'Add Takeaway',
  topics: 'Topics',
  nextSteps: 'Next Steps',
  addSteps: ' Add Steps',
  noActionItemsFound: 'No action items found.',
  noTranscriptionAvailable: 'No transcription available.',
  noSummaryAvailable: 'No summary available.',
  inProgressRecordingHeader: 'Double click to set title',
  maxRecordingAllowed: 'Recording in Progress (Max 2 hours)',
  meetingSummary: 'Meeting Summary',
  noMeetingPurpose: 'No meeting purpose provided.',
  noKeyTakeaways: 'No key takeaways available.',
  topicsDiscussed: 'Topics Discussed',
  noTopicsListed: 'No topics listed.',
  noTextAvailable: 'No text available.',
  noActionItemsRecorded: 'No action items recorded.',
  noNotesRecorded: 'No notes recorded.',
  noThoughtProcessRecorded: 'No thought process recorded.',
  failedToCreate: 'Failed to create ',
  failedToUpdate: 'Failed to update',
  updatingMeeting: 'Updating Meeting',
  regeneratingMeeting: 'Regenerating Meeting',
  meetingBeingProcessed: 'Meeting is being processed',
  stoppingRecording: 'Stopping Recording',
  stoppedRecording: 'Stopped Recording',
  generatingTranscript: 'Generating Transcript',
  generatedTranscript: 'Generated Transcript',
  uploadingAudio: 'Uploading Audio',
  uploadedAudio: 'Uploaded Audio',
  processingAudio: 'Processing Audio',
  processedAudio: 'Processed Audio',
  generatingData: 'Generating Data',
  generatingMeetingData: 'Generating Meeting Data',
  generatedMeetingData: 'Generated Meeting Data',
  meetingCreated: 'Meeting Created',
  meetingCreatedDone: 'Meeting Created',
  meetingSharedSuccessfully: 'Meeting Shared Successfully',
  recording: 'Recording...',
  fileNotProcessed: 'Failed to process file',
  draftMeetingTooltip: 'This meeting is saved as a draft and cannot be opened.',
  noExistingMeeting: 'No existing meeting found.',
  noExistingMeetingDescription:
    'Import a file or record a new meeting to start your next SmartMeet.',
  restrictedLimitSmartMeetUpload: 'You can upload only one file at a time.',
  askAnything: 'Ask anything',
  actionItemsQuery:
    'What action items or next steps were identified during the meeting?',
  participantsQuery:
    'How can the participants follow up on the issues raised in the meeting?',
  mainTopicsQuery: 'What were the main topics discussed in the meeting?',
  mainTopicsQueryMultiple:
    'What were the main topics discussed across the meetings?',
  summarizeMeetingQuery: 'Can you summarize the meeting in a few sentences?',
  askAboutYourMeeting: 'Ask EGPT anything about this conversation!',
  askAboutYourMeetings: 'Ask EGPT anything about your meetings!',
  uploadInProgressWarning:
    'You have an upload in progress. Are you sure you want to leave?',
  transcriptInProgressWarning:
    'You have a transcript generation in progress. Are you sure you want to leave?',

  // Document Analysis statuses
  L_DA_CM: 'Completed',
  L_DA_IP: 'Inprogress',
  L_DA_CN: 'Cancelled',
  L_DA_FL: 'Failed',
  L_DA_PC: 'Partially Completed',
  L_DA_RGR: 'Regenerating',
  L_DA_DR: 'Draft',

  // Assistant Documentation
  assistants: 'Assistants',
  allAssistant: 'All',
  createdByMe: 'Created By Me',
  creator: 'Creator',
  createAssistant: 'Create Assistant',
  updateAssistant: 'Update Assistant',
  assistantName: 'Assistant Name',
  assistantDescription: 'Assistant Description',
  assistantInstructions: 'Assistant Instructions',
  assistantModal: 'Assistant Modal',
  assistantCreatedSuccessfully: 'Assistant Created Successfully',
  assistantUpdatedSuccessfully: 'Assistant Updated Successfully',
  assistantDeletedSuccessfully: 'Assistant Deleted Successfully',
  deleteAssistantTitle: 'Delete assistant',
  deleteAssistantConfirmation: 'Are you sure you want to delete the assistant?',
  deleteAssistantConfirmButton: 'Yes, delete it',
  noDescriptionAvailable: 'No description available',
  assistantNotReadyDisclaimer:
    'This assistant can’t start a chat yet — it needs a knowledge source and an enabled AI model.',
  noFilePermissionDisclaimer:
    'You don’t have permission to some of this assistant’s knowledge resources, so they won’t be used.',
  iconUploadedSuccessfully: 'Icon Uploaded Successfully',
  namePlaceholder: 'Name your assistant',
  descriptionPlaceholder: 'Add a short description about this assistant. ',
  instructions: 'Instructions',
  customInstructions: 'Custom Instructions',
  externalAPI: 'External API',
  instructionsPlaceholder:
    'What does this assistant do? How should it behave? What should it avoid doing?',
  conversationStarters: 'Conversation Starters',
  conversationStartersErrorMessage: 'Conversation starters should not be empty',
  conversationStartersPlaceholder:
    'Example prompts for the user to start the conversation.',
  aiModels: 'AI Models',
  aiModelsPlaceholder: 'Select any AI model',
  personaPlaceholder: 'Select Persona',
  aiModelErrorMessage: 'Please select an AI Model',
  aiModelDisabledTooltip: 'Model does not support images as attachments.',
  editAvailableModels: 'Edit available models',
  thinkingEffort: 'Thinking effort',
  chooseThinkingEfforts: 'Choose thinking efforts',
  thinkingEffortDescription:
    'Higher effort means more thorough responses, but takes longer and use your limits faster.',
  off: 'Off',
  minimal: 'Minimal',
  low: 'Low',
  high: 'High',
  xhigh: 'Extra',
  max: 'Max',
  capabilities: 'Capabilities',
  knowledgeAddFiles: 'Enterprise Knowledge (Add Files)',
  addFiles: 'Add Files',
  knowledgeAddFilesUploaded: '{{totalFiles}}/{{filesLimit}} Files',
  enterpriseKnowledge: 'Enterprise Knowledge',
  worldKnowledgeWithWebSearch: 'World Knowledge with Web Search',
  knowledge: 'Knowledge',
  addAllWorkspaceContent: 'Add all workspace content',
  addKnowledge: 'Add knowledge',
  addKnowledgeDescription:
    'Upload documents, text, code, or browse and add meetings and existing files',
  defaultEnabled: 'Default enabled',
  worldKnowledgeDescription:
    'Let the assistant use world knowledge to answer your queries.',
  enterpriseKnowledgeDescription:
    'Let the assistant use all shared integrations, files, and other assets in the workspace.',
  conversationStartersCount: '{{totalCon}}/6 Added',
  // AssistantNew feature
  getStartedByCreatingNewAssistant: 'Get started by creating a new assistant',
  noAssistantsEmptyStateDescription:
    'You have no assistant. Create assistants powered by instructions, knowledge, and multi-task workflows.',
  loadingAssistants: 'Loading assistants...',
  loadingAssistant: 'Loading assistant...',
  newAssistant: 'New assistant',
  selectPersona: 'Select persona',
  none: 'None',
  selectPersonaDescription:
    'Choose a predefined persona to prefill the instructions.',
  purposeInstructions: 'Purpose (Instructions)',
  writePurposeInstructionsPlaceholder:
    'Write purpose like what does this assistant do? How should it behave? What should it avoid doing?',
  describeYourAssistantOptional: 'Describe your assistant (optional)',
  configureTabLabel: 'Configure',
  knowledgeTabLabel: 'Knowledge',
  accessTabLabel: 'Access',
  assistantPageTitle: 'Assistant',
  assistantPageDescription:
    "Streamline your workflow. Let AI assistants handle onboarding, compliance, and more—so you don't have to.",
  assistantNameRequired: 'Assistant name is required',
  noChangesToSave: 'No changes to save',
  savingInProgress: 'Saving in progress...',
  nameMinLengthError: 'Name must be at least 3 characters',
  nameMaxLengthError: 'Name must not exceed 100 characters',
  descriptionMaxLengthError: 'Description must not exceed 500 characters',
  instructionsMaxLengthError: 'Instructions must not exceed 12000 characters',
  starterMaxLengthError: 'Starter must not exceed 200 characters',
  maxConversationStartersError: 'Maximum 6 conversation starters allowed',
  preview: 'Preview',
  chooseEmojis: 'Select Image',
  keepItPrivate: 'Keep it Private',
  emojiDisclaimer: 'To Upload an Emoji it should be less than 500Kbs',
  assistantFilesPermission: 'You don’t have access to the following files',
  assistantNoFiles: 'Assistant’s enterprise knowledge files have been deleted',
  assistantPreviewNoFiles: `Please add files to the assistant's enterprise knowledge base to start a chat with it.`,
  noFilesDisclaimer: `Files added to the Assistant's knowledge have been deleted from the workspaces. Assistant controllers can add new files or change the Assistant’s capabilities to start a new chat with it.`,
  addFileDisclaimer:
    'Ensure files added in knowledge are accessible to users it is shared with',
  createUpdateConfirmationDialogTitle: 'Unsaved Changes',
  stayOnThisPage: 'Stay on this page',
  leaveWithoutSaving: 'Leave without saving',
  errorConfirmationDialog: 'Please resolve below errors before continuing',
  createUpdateConfirmationDisclaimer:
    'You are about to leave this page with unsaved changes.',
  discardChangesTitle: 'Discard the changes?',
  discardChangesDisclaimer:
    "You're leaving this page with unsaved changes. Any progress will be lost.",
  assistantDeletedDisclaimer:
    'You cannot continue chatting with a deleted assistant.',
  outdatedVersionText: `You cannot continue chatting with an outdated version of this assistant. Start `,
  revokedVersionText: `Access on assistant’s knowledge files revoked. You cannot continue chatting. Click `,
  revokedAssistantPermission: `Access on assistant’s revoked. You cannot continue chatting. `,
  customizeAssistant:
    'Customize AI model responses for your specific use cases',
  newChat: 'new chat',
  here: 'here',
  revokedAssistant: ` to view the files.`,
  updatedAssistant: ` with the updated assistant.`,
  assistantUniqueViolationError: 'Assistant with the same name already exists',
  noAiModelDisclaimer: `The assistant's AI model has been disabled by the admin. Assistant controllers can either assign it a new model or request admin access to the disabled model to start a new chat.`,
  noAiModelTitle: 'Configured AI model disabled',
  addImage: 'Add Image',
  changeImage: 'Change Image',
  uploadOrChooseAnImage: 'Upload or choose an image',
  close: 'Close',
  assistantDeleted: 'Assistant Deleted',
  conversationStarterErrorMessage:
    'Assistant Starter cannot be longer than 300 characters',
  viewMore: 'View More',
  viewLess: 'View Less',
  assistantSelfAssignmentError:
    'Self Assignment/Unassignment on a resource is not allowed!',
  signup: 'Sign up',
  signupInfo:
    'Enterprise AI for text, voice, images & knowledge — secure and ready to use',
  signupInfo2: 'Get your 7-days free trial now!',
  emailNotValid: 'Please enter a valid email address',
  emailRequired: 'Email is Required',
  domainNameLength: 'Domain name should be within 20 characters',
  domainNameRequired: 'Domain name is Required',
  domainName: 'Login URL',
  domainDisclaimer: 'This domain will be used to login to the application',
  marketingConsentDisclaimer:
    'I agree to receive email updates about onboarding guide, products, services, and news from INTECH Automation & Intelligence GmbH.',
  signupDisclaimer: 'No credit card • No sales contact • Cancel anytime',
  sendInvite: 'Send Invite',
  login: 'Log in',
  alreadyHaveAccount: 'Already have an account? ',
  userAlreadyExists: 'This user already exists.',
  signupConfirmation1: 'An invite has been sent to your email address',
  needHelpContactUs: 'Need Help? Contact us at ',
  privacySettings: 'Privacy Settings',
  signupConfirmation2:
    'Click on “Click to Proceed” button in the received email to setup up your account. The invitation link will expire after 14 days.',
  workEmail: 'Work Email',
  getInvite: 'Get Invite',
  chatUnavailable: 'Chat Unavailable',
  shareUsingLink: 'Share using link',
  linkCopied: 'Link copied',
  shareAssistantInviteDescription:
    'Invite your teammates and build shared responsibility for this agent.',
  roleDescription: 'Role for EmpowerGPT users with the link',
  errorGeneratingLink: 'Error generating link',
  browseToSelect: 'Browse to Select',
  browseToSelectDocs: 'Browse to Select Documents',
  viewDocuments: 'View Documents',
  selectAllFiles: 'Complete Workspaces',
  allEnterpriseKnowledgeInfo:
    'This assistant will have access to all the content in your workspaces',
  selectFromWorkspace: 'Select from Workspace',
  selectFromWorkspaces: 'Select from workspaces',
  uploadUpToFiles: 'Upload (up to {{ files }} files)',
  uploadFilesProgress: 'Upload ({{ uploaded }}/{{ limit }} files)',
  uploadLimitReached: 'Upload limit reached',
  uploadNew: 'Upload New',
  filesInProcessTitle: 'Assistant knowledge files are being processed.',
  filesInProcessDesc:
    'Chat is unavailable for a moment, until all assistant knowledge documents are successfully processed. Following files are being processed:',
  customLicense: 'Custom License',
  creditsPerMonth: 'Credits Per Month',
  autoExpiry: 'Auto Expiry', //REMOVE
  filesUploadLimit: 'Files Upload Limit/Import Limit at once',
  userLimit: 'User Limit',
  maxSearchPlus: 'Search+ limit (per month)',
  maxDocAnalystAnalysis: 'Doc analyst analyses (per month)',
  maxDocAnalystQuestionPerAnalysis: 'Doc analyst questions per analysis',
  maxOcrFiles: 'OCR files (per month)',
  maxSmartMeetDurationSecs: 'Smart meet duration (seconds, per month)',
  maxDataAnalystQuery: 'Data analyst queries (per month)',
  workflowRuns: 'Workflow runs (per month)',
  workflowCredits: 'Workflow credits (%)',
  workflowRunsRequired: 'Workflow runs is required',
  percentageRange: 'Enter a value between 0 and 100',
  unlimitedAccess: 'Unlimited',
  createTenants: 'Create Tenant',
  maxExpiryDateError:
    'Expiry date should be less than or equal to 1 month from today',
  tenantPlan: 'Tenant Plan',
  expiryDays: 'Expiry days required',
  fileUploadLimit: 'File upload limit is required',
  userLimitRequired: 'User limit is required',
  expiryDate: 'Expires on',
  expiryDateRequired: 'Expire Date is required',
  trialExpiryMaxOneMonth: 'Trial expiry can be at most one month from today',
  license: 'License',
  block: 'Block',
  numberGreaterThanZero: 'Enter a number greater than 0',
  minimumValueShouldBeOne: 'Minimum value should be 1',
  updateTenant: 'Update Tenants',
  [PERSONA_TYPE.PROJECT_MANAGER_ASSISTANT]: 'Project Manager Assistant',
  [PERSONA_TYPE.DEVELOPER_COMPANION]: 'Developer Companion',
  [PERSONA_TYPE.STUDENT_STUDY_BUDDY]: 'Student Study Buddy',
  [PERSONA_TYPE.SALES_CRM_STRATEGIST]: 'Sales & CRM Strategist',
  [PERSONA_TYPE.KNOWLEDGE_OPS_ANALYST]: 'Knowledge Ops Analyst',
  [PERSONA_TYPE.EXECUTIVE_ASSISTANT]: 'Executive Assistant',
  [PERSONA_TYPE.CUSTOMER_SUPPORT_AGENT_TRAINER]:
    'Customer Support Agent Trainer',

  [`${PERSONA_TYPE.PROJECT_MANAGER_ASSISTANT}-desc`]:
    'I am the Project Manager. I want to stay on top of deadlines, track deliverables, and ensure smooth collaboration across teams. I help you manage complex projects effortlessly by organizing tasks, summarizing meetings, and keeping everyone aligned.',

  [`${PERSONA_TYPE.DEVELOPER_COMPANION}-desc`]:
    'I am the Developer Companion. I want to write cleaner code, fix bugs faster, and never get blocked. I assist you by explaining code, generating reusable snippets, and helping you navigate your tech stack and documentation efficiently.',

  [`${PERSONA_TYPE.STUDENT_STUDY_BUDDY}-desc`]:
    'I am the Study Buddy. I want to understand difficult topics, prepare well for exams, and stay organized in my learning. I help you break down complex concepts, summarize class notes, and create personalized study materials that work for you.',

  [`${PERSONA_TYPE.SALES_CRM_STRATEGIST}-desc`]:
    'I am the Sales Strategist. I want to build strong client relationships and close deals faster. I help you by summarizing CRM data, drafting persuasive outreach messages, and providing insights that sharpen your sales game.',

  [`${PERSONA_TYPE.KNOWLEDGE_OPS_ANALYST}-desc`]:
    'I am the Knowledge Analyst. I want to keep internal knowledge clean, accessible, and useful for the whole team. I help you find answers faster, maintain clear documentation, and structure your knowledge base for optimal use.',

  [`${PERSONA_TYPE.EXECUTIVE_ASSISTANT}-desc`]:
    'I am the Executive Assistant. I want to make sure nothing is missed, from critical meetings to strategic decisions. I help you by drafting communications, summarizing key reports, and managing your schedule so you can stay focused on leading.',

  [`${PERSONA_TYPE.CUSTOMER_SUPPORT_AGENT_TRAINER}-desc`]:
    'I am the Support Trainer. I want to provide fast, accurate, and consistent customer support. I help you by analyzing support tickets, drafting clear responses, and preparing onboarding materials for your support team to succeed.',

  // Confluence
  confluenceModalTitle: 'Import content from Confluence',
  confluenceModalSubtitle:
    'Navigate within your Confluence, and select required content for importing.',
  confluenceMySpaces: 'My Spaces',
  confluenceSharedSpaces: 'Shared Spaces',
  openInConfluence: 'Open in Confluence',
  confluenceResourceProviderWelcomeTitle:
    'Steps to Configure Importing from Confluence',
  confluenceWelcomeInstruction1:
    'Atlassian organization admin’s account details.',
  confluenceWelcomeInstruction2:
    'Create and configure an OAuth 2.0 App in Atlassian Developer.',
  confluenceWelcomeInstruction3:
    'Enter details against the created application.',
  confluenceWelcomeInstruction4:
    'Add required permissions to the created application’s API scope.',
  googleDriveWelcomeInstruction2:
    'Create Google Cloud Project and create a Service Account',
  googleDriveWelcomeInstruction3: 'Grant domain-wide access',
  googleDriveWelcomeInstruction4: 'Connect the service account with EmpowerGPT',
  confluenceConfigurationSuccessTitle: 'Importing from Confluence Configured',
  confluenceConfigurationSuccessDescription1:
    'Content can now be imported from Confluence in EmpowerGPT as collections.',
  confluenceConfigurationSuccessDescription2:
    "Imported content's visibility will be based on its permissions at Confluence.",
  googleDriveConfigurationSuccessTitle:
    'Importing from Google Drive Configured',
  googleDriveConfigurationSuccessDescription1:
    'Content can now be imported from Google Drive in EmpowerGPT as collections.',
  googleDriveConfigurationSuccessDescription2:
    "Imported content's visibility will be based on its permissions at Google Drive.",
  confluenceAdminConfigurationStep1Start: 'In a new tab, navigate to the ',
  atlassianManagementText: 'Atlassian account’s API token management page.',
  confluenceAdminConfigurationStep1End:
    ' Make sure to sign in with Atlassian’s organization admin account.',
  confluenceAdminConfigurationStep2:
    'Click on the “Create API token” button, and enter a suitable name such as “EmpowerGPT - [Company Name]”.',
  confluenceAdminConfigurationStep3:
    'After clicking on create, you shall be able to copy the API token. Paste the API token, along with the email address of the signed in organization admin.',
  apiTokenRequired: 'API token is required',
  apiToken: 'API TOKEN',
  confluenceAdminConfigurationStep4:
    'Paste the base URL for your organization’s Atlassian applications below. (For example, if your organization name is Contoso, the base URL for your organization’s Atlassian applications will be https://contoso.atlassian.net/wiki)',
  invalidConfluenceUrl: 'Invalid Confluence Base URL provided.',
  confluenceStep1Title: 'Atlassian organization admin’s account details',
  atlassianBaseUrl: 'Atlassian base URL',
  confluenceStep2Title:
    'Create and configure an OAuth 2.0 App in Atlassian Developer',
  confluenceStep2Instruction1Start: 'In a new tab, sign in to ',
  confluenceStep2Instruction1End: 'Atlassian Developer.',
  confluenceStep2Instruction2:
    'Once signed in, click on the “User Menu” on top right to select the “Developer Console” button from the drop-down. ',
  confluenceStep2Instruction3:
    'Click on the “Create” button under “My apps” section and select “OAuth 2.0 integration” from the drop-down.',
  confluenceStep2Instruction4:
    'Enter a suitable name for the application such as “EmpowerGPT - [Company Name]”. Check the box below to agree to Atlassian’s developer terms, and click on “Create”. ',
  confluenceStep2Instruction5:
    'You will land to the application’s “Overview” page after the application is successfully created. Navigate to the “Authorization” page, and click on the “Add” button against “OAuth 2.0 (3LO)” to enable user authorization from Atlassian.',
  confluenceStep2Instruction6:
    'Paste the following URL in the “Callback URL” field and click on “Save changes”.',
  callBackUrl: 'Callback URL',
  confluenceStep2Instruction7:
    'Now navigate to the “Distribution” page and click on “Edit” in front of the “Distribution controls” section. Change the distribution status to “Sharing”.',
  confluenceStep2Instruction8:
    'Add your company name as the vendor name and paste the following link under the privacy policy field.',
  privacyPolicy: 'Privacy Policy',
  privacyPolicyRequired: 'Privacy Policy is required',
  confluenceStep2Instruction9:
    'Select “No” against the “does your app store personal data?” drop down and click on save changes button at the end.',
  appCreationStepsPerformed:
    'All of the above steps have been performed in Atlassian Developer.',
  confluenceStep3Title: 'Enter details against the created application',
  confluenceStep3Instruction1: 'Navigate to the “Settings” page. ',
  confluenceStep3Instruction2:
    'Copy the “Client ID” and “Secret ID” and enter each in the respective field below.',
  clientId: 'Client ID',
  wpsUrl: 'WPS Connection URL',
  clientSecret: 'Secret',
  confluenceStep4Title:
    'Add required permissions to the created application’s API scope',
  confluenceStep4Instruction1:
    'Navigate to the “Permissions” page and click on the “Add” button against the “Confluence API” row. ”Add” button should update to “Configure”.',
  confluenceStep4Instruction2:
    'Click on the “Configure” button, and click on “Edit Scopes” under the “Classic scopes” tab',
  confluenceStep4Instruction3:
    'Select the following permissions by check the box under the “Select” column.',
  confluenceStep4Instruction3a: 'Read Confluence space summary',
  confluenceStep4Instruction3b: 'Read Confluence content summary',
  confluenceStep4Instruction3c: 'Read Confluence detailed content',
  confluenceStep4Instruction4:
    'The above steps have been performed on the created application in Atlassian Developer.',
  resourceProviderConfluenceEnabledSuccessfully:
    'Confluence enabled successfully.',
  resourceProviderGoogleDriveEnabledSuccessfully:
    'Google Drive enabled successfully.',
  resourceProviderConfluenceDisabledSuccessfully:
    'Confluence disabled successfully.',
  resourceProviderGoogleDriveDisabledSuccessfully:
    'Google Drive disabled successfully.',
  errorUpdatingConfluence: 'Error updating Confluence',
  errorUpdatingGoogleDrive: 'Error updating Google Drive',
  resourceProviderConfluenceCreationFailed: 'Error enabling Confluence.',
  resourceProviderGoogleDriveCreationFailed: 'Error enabling Google Drive.',
  viewDetails: 'View Details',
  hideDetails: 'Hide Details',
  authWindowClosed: 'Authentication window was closed.',
  tokenExchangeFailed: 'Token exchange failed',
  failedRefreshToken: 'Failed to refresh access token',
  errorDecodingToken: 'Error decoding token: ',
  noWhitespaceAllowed: 'Please remove white spaces',
  controller: 'Controller',

  // Settings
  systemSettings: 'System Settings',
  security: 'Security',
  enableForNewChats: 'Enable for new chats',
  aboutYou: 'About You',
  aboutYouSubtitle:
    'This information will be used to personalise your experience',
  aboutYouLabel:
    'Tell EmpowerGPT about yourself to get more personalized responses.',
  companyName: 'Company Name',
  department: 'Department',
  jobRole: 'Job Role',
  country: 'Country',
  deleteAccount: 'Delete Account',
  deleteAccountInfo:
    'Permanently delete your entire account, documents upload in My Workspace, and your chats. This is irreversible.',
  aboutYouPlaceholder:
    '- What do you primarily do at work?\n- What are your key responsibilities?',
  giveInstructionsLabel: 'How would you like EmpowerGPT to respond?',
  giveInstructionsPlaceholder:
    '- What tone should EmpowerGPT use: formal or casual?\n- Preferred length of EmpowerGPT responses: short or detailed?',
  changePasswordLabel:
    "Your password is the key to your account. Ensure it's strong and secure.",
  settingsSavedSuccessfully: 'Settings saved successfully',
  profileUpdatedSuccessfully: 'Profile updated successfully',
  uploadingOrProcessingText: '{{status}} attachments',
  failedOrUnsupportedText:
    'Error {{status}} attachments. Remove attachment(s) with an error to send message.',

  switchToListView: 'Switch to List View',
  switchToGridView: 'Switch to Grid View',
  perUserLimits: 'Per-User Limits',
  noLimit: 'No Limit',
  modelUsageInChat: 'Model usage in chat',
  maximumQueriesLimit: 'Maximum Queries Limit in 3 hrs',
  maximumAnalysisLimit: 'Maximum analysis in 3hrs',
  resetToDefault: 'Reset to default',
  fieldValidationMessage: 'Please enter a valid number greater than 0',
  userLimitsUpdateSuccessMsg: 'Per-User Limits updated successfully',

  //PAYG
  paygTitle: 'Pay As You Go',
  paygDescription:
    'Prepaid Pay As You Go credits keep your team going once they hit their usage limit. Turn this off to stop all overage usage immediately.',
  paygCapReachedTitle: 'Cap reached — AI features are blocked.',
  paygCapReachedDescription:
    'Your team has lost access of AI features. No extra charges apply. Update the cap to restore feature access.',
  paygApproachingCapTitle: 'Approaching your balance limit — Top up.',
  paygApproachingCapDescription:
    "You're {{currency}}{{amount}} away from your cap. At current usage, your team will run out. Consider raising it now.",
  // Pool-aware variants — the plan pool runs in parallel with the PAYG cap.
  paygCapReachedPlanAvailableTitle:
    'Cap reached — Pay As You Go credits are used up.',
  paygCapReachedPlanAvailableDescription:
    'Raise the cap to keep Pay As You Go available to your team.',
  paygApproachingCapPlanLowTitle:
    'Approaching your cap — in-plan credits are low too.',
  paygApproachingCapPlanLowDescription:
    "You're {{currency}}{{amount}} away from your cap and in-plan credits are also running out. Raise the cap to avoid a block.",
  paygTopUpButton: 'Top up',
  paygBalance: 'Pay As You Go balance',
  paygCreditsLimitExceedTooltip:
    '{{excess}} additional Pay As You Go credit usage has occurred, which will be automatically adjusted against any purchases made within the same month.',
  paygInPlanCreditLimitReachedTooltip:
    '{{excess}} additional in-plan credit usage has occurred. Over consumed in-plan credits will be adjusted from Pay As You Go balance.',
  paygNoCapSetTitle: 'No cap set',
  paygNoCapSetDescription:
    'Enable Pay As You Go to set a credit cap and cover usage automatically',
  paygEnablePayAsYouGo: 'Enable Pay As You Go',
  paygEnableTitle: 'Enable Pay As You Go',
  paygEnableDescription:
    'When your in-plan credit runs out, AI features keep running by drawing from your prepaid Pay As You Go balance.',
  paygTopUp: 'Top up',
  paygTopUpAmount: 'Top-up amount',
  paygTopUpAmountHint: 'This amount is exclusive of tax.',
  paygTopUpCredits: 'Credits: {{credits}}',
  paygTopUpCreditsTooltip:
    'Unused credits will remain available and can be used next month.',
  paygMaxTopUpAmount: 'Maximum top-up amount is €{{max}}.',
  paygPremiumFeaturesCap: 'Premium features usage cap',
  paygWorkflowLabel: 'Workflow',
  paygEditPremiumTitle: 'Edit premium usage cap',
  paygEditPremiumDescription:
    'Set cap of how much Pay As You Go balance use for premium feature.',
  paygEditPremiumSuccess: 'Premium features usage cap updated successfully.',
  paygEditPremiumFailed: 'Failed to update premium features usage cap.',
  paygMonthlyCap: 'Monthly cap',
  paygCheckoutFailed: 'Failed to start checkout. Please try again.',
  paygBillingInfo:
    'This amount is charged upfront to activate your Pay As You Go balance. You can disable or change it anytime from Settings → Pay As You Go.',
  paygUpdateCap: 'Update',
  paygEnableButton: 'Enable Pay As You Go',
  paygConsumedPercent: 'Pay As You Go consumed in %',
  paygClearFilters: 'Clear filters',
  paygCreditsLabel: 'PAYG Credits',
  paygPlanCreditsLabel: 'In-plan Credits',
  // PAYG individual limits
  paygIndividualLimitColumn: 'Individual limit',
  paygIndividualLimitSharedPool: 'Shared Pool',
  paygIndividualLimitCustom: 'Custom limit',
  paygIndividualLimitCustomValue: 'Custom: {{amount}}',
  paygIndividualLimitUnlimited: 'Unlimited',
  paygIndividualLimitSharedPoolDesc: 'Get an equal share of the team pool.',
  paygIndividualLimitCustomDesc: 'Set a specific monthly amount.',
  paygIndividualLimitUnlimitedDesc: 'No spend cap, billed for all usage.',
  paygEditIndividualLimit: 'Edit individual limit',
  paygIndividualLimitSuccess: 'Individual limit has been updated.',
  paygIndividualLimitFailed:
    'Failed to update the individual limit. Please try again.',
  paygEnableSuccess: 'Pay As You Go has been enabled successfully.',
  paygDisableSuccess: 'Pay As You Go has been disabled.',
  paygEnableFailed: 'Failed to enable Pay As You Go. Please try again.',
  paygDisableFailed: 'Failed to disable Pay As You Go. Please try again.',
  paygAlreadyExists: 'Pay As You Go with same monthly cap is already enabled.',
  paygInvalidLimit: 'Monthly cap cannot be reduced.',
  paygNotEnabled:
    'Pay As You Go is not active. Please enable the feature to proceed.',
  paygDisableConfirmDescription:
    'Disabling Pay As You Go will stop Pay As You Go credit usage. You can re-enable it anytime.',
  paygEnableConfirmDescription:
    'Enabling Pay As You Go will resume Pay As You Go credit usage. Do you want to continue?',
  // PAYG licence status badge (header) — locked `status_code` values only
  paygStatusCancelled: 'Cancelled',
  paygStatusPastDue: 'Past due',
  paygStatusBlocked: 'Blocked',
  paygStatusExpired: 'Expired',
  paygStatusRenewed: 'Renewed',
  paygStatusUnavailable: 'Unavailable',
  paygFetchUsageFailed: 'Failed to load usage data. Please try again.',
  paygFetchHistoryFailed: 'Failed to load history data. Please try again.',
  // License disclaimer — standard licence (PAYG not offered)
  licenseDisclaimerStandard90Owner:
    'Over 90% of your organization’s AI credits have been consumed.',
  licenseDisclaimerStandard90User:
    'Over 90% of your organization’s AI credits have been consumed. Please contact your administrator.',
  licenseDisclaimerStandard100Owner:
    'Your organization’s monthly limit for AI credits has been reached. For immediate assistance, contact customer support.',
  licenseDisclaimerStandard100User:
    'Your organization’s monthly limit for AI credits has been reached. Please contact your administrator.',
  // License disclaimer — PAYG offered but switched off
  licenseDisclaimerPaygAvailable90Owner:
    'Over 90% of your organization’s in-plan credit limit has been used. Enable Pay As You Go to avoid a block.',
  licenseDisclaimerPaygAvailable90User:
    'Over 90% of your organization’s in-plan credit limit has been used. Please contact your administrator to enable Pay As You Go.',
  licenseDisclaimerPaygAvailable100Owner:
    'Your organization’s in-plan credit limit has been reached — AI features are blocked. Enable Pay As You Go to continue.',
  licenseDisclaimerPaygAvailable100User:
    'Your organization’s in-plan credit limit has been reached. Please contact your administrator.',
  licenseDisclaimerEnablePayg: 'Enable Pay As You Go',
  // License disclaimer — PAYG active (is_payg_active); owner copy leaves the
  licenseDisclaimerPayg90Owner:
    'Over 90% of your organization’s Pay As You Go credits have been used.',
  licenseDisclaimerPayg90User:
    'Over 90% of your organization’s Pay As You Go credits have been used. Contact your administrator.',
  licenseDisclaimerBoth90Owner:
    'Over 90% of your organization’s Pay As You Go and in-plan credits have been used.',
  licenseDisclaimerBoth90User:
    'Over 90% of your organization’s Pay As You Go and in-plan credits have been used. Contact your administrator.',
  licenseDisclaimerPayg100Owner:
    'All of your organization’s Pay As You Go credits have been used.',
  licenseDisclaimerPayg100User:
    'All of your organization’s Pay As You Go credits have been used. Contact your administrator.',
  licenseDisclaimerPaygCovering:
    'Pay As You Go is covering your organization’s usage as in-plan credits run out.',
  licenseDisclaimerBoth100Owner:
    'Your organization’s in-plan and Pay As You Go credits are exhausted — AI features are blocked.',
  licenseDisclaimerBoth100User:
    'Your organization’s in-plan and Pay As You Go credits are exhausted — AI features are blocked. Contact your administrator.',
  licenseDisclaimerRaiseCap: 'Top up',
  licenseDisclaimerRestoreAccess: 'Restore access',

  // help and Support
  helpSupport: 'Support',
  subject: 'Subject',
  chooseOptions: 'Choose one of the options below for help and Feedback',
  contactSupport: 'Contact Support',
  contactCustomerSupport: 'Contact customer support',
  ReportIssue: 'Report an Issue',
  suggestedImprovements: 'Suggest Improvements',
  attachFile: 'Attach File',
  uploadFile: 'Upload File',
  duplicateFileError: 'File(s) with the same name already attached.',
  maxAttachFiles:
    'A maximum of 5 file attachments is allowed, with a total size not exceeding 7MB.',
  // TODO: Move email to env
  supportTicketError:
    'Error sending message to support. Please try again, or contact support directly at {{supportEmail}}',
  fileSizeError: `The limit for maximum number of attached files is 5`,
  sizeExceedError: 'Exceeds the max file size of 7MB.',
  reportIssueSubject: 'Summarize the issue you’re facing',
  reportIssueDescription:
    'Describe the issue in detail, and steps to reproduce if possible',
  suggestedImprovemnt:
    'Describe your suggested improvement or new feature requests',
  issueText: `Your suggestions have been shared with the team. We may get
                  back to you for further information if required on`,
  supportText:
    'The team will get back to you shortly on this. You will get replies on ',
  successMsg: 'Message sent successfully',
  issueReported: 'Issue reported',
  fileUploadingInProgress: 'File uploading is in progress...',
  accountTypeUpdateMsg:
    'Account type updated; Reloading application in 3 seconds.',
  realmDeletedMsg: 'Your Tenant has been deleted. Redirecting to Login page.',
  invalidToken: 'Invalid/Expired token. Redirecting to login page.',
  userDeletedMsg: 'Your account has been removed from the organization.',
  proSearchTooltip:
    'Route your query through advanced AI planning for smarter answers.',
  deepseekModelDisclaimer:
    'DeepSeek works best with English prompts for optimal results.',
  createClient: 'Create Service Client',
  createClientDescription:
    'Click on the button to create a ClientId, ClientSecret & Realm for service client',
  configurationDescription:
    'This information will be used to personalise your experience',
  clientIdPlaceholder: 'Please enter Client ID',
  tokenRefreshRate: 'Token Refresh Rate',
  tokenRefreshRatePlaceholder: 'Please enter Token Refresh Rate in hrs',
  configurationDisclaimer:
    '** Token refresh rate is set to 1 hour by default and refresh token will be provided! **',
  clientIdAndRefreshRate: 'Client ID & Token refresh rate',
  urlAndSecretId: 'Get URLs & Secret ID',
  externalApiWelcomeTitle: 'Steps to Configure API Integrations',
  externalApiWelcomeInstruction1: 'Client ID & Token refresh rate',
  externalApiWelcomeInstruction2: 'Get URLs & Secret ID',
  externalApiConfigured: 'External API configured successfully',
  externalApiConfigurationDescription:
    'Use generated credentials to communicate with EmpowerGPT apis',
  tokenRefreshRateRequired: 'Token Refresh Rate is required',
  secretId: 'Client Secret',
  authorizeUrl: 'Authorize URL',
  authenticateUrl: 'Authenticate URL',
  authenticationType: 'Authentication Type',
  headerName: 'Header Name',
  algorithm: 'Algorithm',
  authenticateUrlPlaceholder: 'Please enter Authenticate URL',
  secretToken: 'Secret Token',
  includeSecretId: 'Include secret id token.',
  headerNameRequired: 'Header Name is required',
  algorithmRequired: 'Algorithm is required',
  authTypePlaceholder: 'Please enter Authentication Type',
  algorithmPlaceholder: 'Please enter Algorithm',
  chatCompletion: 'Chat Completion',
  chatStreaming: 'Chat Streaming',
  externalApiConfiguredSuccessfully: 'External API configured successfully',
  externalApiDisabledSuccessfully: 'External API disabled successfully',
  secretTokenUpdateSuccess: 'Secret token updated successfully',
  secretTokenUpdateError: 'Error updating secret token',
  logoutUrl: 'Logout URL',
  regenerateSecret: 'Regenerate Secret',
  step: 'Step',

  bookmark: 'Bookmarks',
  bookmarkDescription: 'Empower GPT Documentation',
  // Organization Logo
  logoDeletedSuccess: 'Logo deleted successfully',
  logoDeletedError: 'Error deleting logo',
  logoUpdatedSuccess: 'Logo updated successfully',
  logoUpdatedError: 'Error updating logo',
  orgLogoSize: 'Logo size must not exceed 5MB',
  logo: 'Logo',
  orgLogo: 'Organization Logo',
  logoTabDesc:
    'Customize your account by adding your organization’s logo around the product. Your logo will appear like the Intech logo is appearing in the below examples.',
  switchText: 'Use one logo for all places',
  squareLogoSignin: 'Square Logo for sign in/ sign up',
  rectangleLogoSideNav: 'Rectangle Logo for side nav',
  squareLogoSideNav: 'Square Logo for side nav',
  maxSize: 'Maximum size should be 5 mb',

  //Canvas:
  errorUpdatingCanvas: 'Error updating canvas',
  writeSomethingPlaceholder: 'Write something …',
  editOrExplainPlaceholder: 'Edit or Explain...',
  canvasFooterMsg1: 'You are viewing a previous version',
  canvasFooterMsg2: 'Restore this version to make edits',
  canvasRestoreVersion: 'Restore this version',
  canvasBackToLatestVersion: 'Back to latest version',
  canvas: 'Canvas',
  createNewCanvasChat: 'Create New Canvas Chat',
  canvasDisclaimer: `We're excited to introduce our Canvas feature in beta. Please note
              that it may have some quirks as we refine it.`,
  noCanvasModels: `No AI models available for canvas chats. Please contact your admin.`,
  canvasResponseTooLong: 'Error while streaming canvas. Response too long.',

  //AV files translations
  duration: 'Duration',
  speaker: 'Speaker',
  //Actions
  [ACTIONS_CATEGORIES.OUTLOOK_EMAIL]: 'Outlook Email',
  [ACTIONS_CATEGORIES.OUTLOOK_CALENDAR]: 'Outlook Calendar',
  [ACTIONS_CATEGORIES.GMAIL]: 'Gmail',
  [ACTIONS_CATEGORIES.GOOGLE_CALENDAR]: 'Google Calendar',
  [ACTIONS_CATEGORIES.SLACK]: 'Slack',
  [ACTIONS_CATEGORIES.GOOGLE_DRIVE]: 'Google Drive',
  [ACTIONS_CATEGORIES.GOOGLE_SHEETS]: 'Google Sheets',
  [ACTIONS_CATEGORIES.HUBSPOT]: 'Hubspot',
  [ACTIONS_CATEGORIES.JIRA]: 'Jira',
  [ACTIONS_CATEGORIES.CONFLUENCE]: 'Confluence',
  [ACTIONS_CATEGORIES.GOOGLE_DOCS]: 'Google Docs',
  [ACTIONS_CATEGORIES.MICROSOFT_TEAMS]: 'Microsoft Teams',
  [ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT]: 'Microsoft SharePoint',
  [ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE]: 'Microsoft OneDrive',
  [`${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-desc`]:
    'Chat with your outlook emails, create drafts, and send emails.',
  [`${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-desc`]:
    'View and manage your outlook calendar events.',
  [`${ACTIONS_CATEGORIES.GMAIL}-desc`]:
    'Chat with your emails, create drafts, and send emails.',
  [`${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-desc`]:
    'View and manage your calendar events.',
  [`${ACTIONS_CATEGORIES.SLACK}-desc`]:
    'One platform. All your go-to-market teams. Aligned.',
  [`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-desc`]:
    'Chat with your emails, create drafts, and send emails.',
  [`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-desc`]: `Manage and analyze data in Google's spreadsheets.`,
  [`${ACTIONS_CATEGORIES.HUBSPOT}-desc`]:
    'Manage your contacts, deals, and campaigns directly from chat.',
  [`${ACTIONS_CATEGORIES.JIRA}-desc`]:
    'Search, create, and update Jira issues directly from chat.',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-desc`]:
    'Search, read, and manage Confluence pages and comments directly from chat.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-desc`]:
    'communicate with your team members directly from chat.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-desc`]:
    'Contextual access to documents, lists, and pages across your SharePoint sites.',
  [`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-desc`]:
    'Read, search, and draft documents using natural language, without switching tools.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-desc`]:
    'read, manage, and generate files across your one drive using natural language',

  [ACTIONS_CATEGORIES.SQL_DATABASE]: 'SQL Database',
  [`${ACTIONS_CATEGORIES.SQL_DATABASE}-desc`]:
    'Query and explore your SQL database using natural language. Supports PostgreSQL, MySQL, MariaDB, and SQL Server.',
  [`${ACTIONS_CATEGORIES.SQL_DATABASE}-${SQL_DATABASE.EXECUTE_SQL}`]:
    'Execute SQL',
  [`${ACTIONS_CATEGORIES.SQL_DATABASE}-${SQL_DATABASE.EXECUTE_SQL}-desc`]:
    'Run SELECT queries on your connected database and get results in natural language.',
  [`${ACTIONS_CATEGORIES.SQL_DATABASE}-${SQL_DATABASE.SEARCH_OBJECTS}`]:
    'Search Objects',
  [`${ACTIONS_CATEGORIES.SQL_DATABASE}-${SQL_DATABASE.SEARCH_OBJECTS}-desc`]:
    'Discover schemas, tables, columns, and other database objects using pattern matching.',

  [ACTIONS_CATEGORIES.SAP_S4HANA]: 'SAP S/4HANA',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-desc`]:
    'Read-only access to SAP maintenance orders, notifications, material stock, and material documents.',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MAINTENANCE_ORDERS}`]:
    'List Maintenance Orders',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MAINTENANCE_ORDERS}-desc`]:
    'List maintenance orders with type, priority, plant, and schedule details.',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_ORDER}`]:
    'Get Maintenance Order',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_ORDER}-desc`]:
    'Get all details of a single maintenance order.',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_ORDER_OPERATIONS}`]:
    'Get Maintenance Order Operations',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_ORDER_OPERATIONS}-desc`]:
    'Get the operations of a maintenance order including work centers and plants.',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MAINTENANCE_NOTIFICATIONS}`]:
    'List Maintenance Notifications',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MAINTENANCE_NOTIFICATIONS}-desc`]:
    'List maintenance notifications with priority, equipment, and malfunction dates.',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_NOTIFICATION}`]:
    'Get Maintenance Notification',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_NOTIFICATION}-desc`]:
    'Get all details of a single maintenance notification.',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_NOTIFICATION_ITEMS}`]:
    'Get Notification Items',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_NOTIFICATION_ITEMS}-desc`]:
    'Get the items of a maintenance notification including object part and damage codes.',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_NOTIFICATION_TASKS}`]:
    'Get Notification Tasks',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_NOTIFICATION_TASKS}-desc`]:
    'Get the tasks of a maintenance notification including status and responsible person.',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MATERIAL_STOCK}`]:
    'List Material Stock',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MATERIAL_STOCK}-desc`]:
    'List materials with their base units of measure.',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MATERIAL_STOCK}`]:
    'Get Material Stock',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MATERIAL_STOCK}-desc`]:
    'Get stock details of a material including the account-model breakdown.',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MATERIAL_STOCK_QUANTITIES}`]:
    'Get Stock Quantities',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MATERIAL_STOCK_QUANTITIES}-desc`]:
    'Get material stock quantities by plant, storage location, batch, and stock type.',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MATERIAL_DOCUMENTS}`]:
    'List Material Documents',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MATERIAL_DOCUMENTS}-desc`]:
    'List material document headers with posting dates and goods movement codes.',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MATERIAL_DOCUMENT}`]:
    'Get Material Document',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MATERIAL_DOCUMENT}-desc`]:
    'Get a material document with all of its items.',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MATERIAL_DOCUMENT_ITEMS}`]:
    'List Material Document Items',
  [`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MATERIAL_DOCUMENT_ITEMS}-desc`]:
    'List material document items with quantities, movement types, and storage locations.',

  [`${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.CREATE_DRAFT}`]:
    'Create Draft',
  [`${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.SEND_EMAIL}`]:
    'Send Email',
  [`${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.SEARCH_EMAIL_BY_CONTENT}`]:
    'Search email by content',
  [`${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.SEARCH_EMAIL_BY_CONTACT}`]:
    'Search email by contact',
  [`${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.CREATE_DRAFT}-desc`]:
    'Compose an email and save it as a draft in your Outlook account without sending it',
  [`${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.SEND_EMAIL}-desc`]:
    'Compose and send an email directly through your Outlook account using this assistant',
  [`${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.SEARCH_EMAIL_BY_CONTENT}-desc`]:
    'Find emails in your Outlook inbox by searching for specific words or phrases in the body or subject',
  [`${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.SEARCH_EMAIL_BY_CONTACT}-desc`]:
    'Locate emails in your Outlook inbox based on the sender’s name or email address',
  [`${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.CREATE_EVENT}`]:
    'Create Event',
  [`${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.DELETE_EVENTS}`]:
    'Delete Events',
  [`${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.GET_DATE_EVENTS}`]:
    'Get Events by Date',
  [`${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.GET_TODAY_EVENTS}`]:
    'Get Today Events',
  [`${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.LIST_CALENDARS}`]:
    'List Calendars',
  [`${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.LIST_CALENDAR_EVENTS}`]:
    'List Calendar Events',
  [`${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.UPDATE_EVENT}`]:
    'Update Event',
  [`${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.GET_EVENT}`]:
    'Get Event',
  [`${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.CREATE_EVENT}-desc`]:
    'Schedule a new event or meeting in your Outlook Calendar',
  [`${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.DELETE_EVENTS}-desc`]:
    'Remove a specific event from your Outlook Calendar.',
  [`${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.GET_DATE_EVENTS}-desc`]:
    '	Retrieve all events for a specific date from your Outlook Calendar',
  [`${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.GET_TODAY_EVENTS}-desc`]:
    'Retrieve all events scheduled for today from your Outlook Calendar',
  [`${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.LIST_CALENDARS}-desc`]:
    '	Display all calendars linked to your Outlook account',
  [`${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.LIST_CALENDAR_EVENTS}-desc`]:
    'Show all events from a selected calendar in your Outlook account',
  [`${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.UPDATE_EVENT}-desc`]:
    'Modify the details of an existing event in your Outlook Calendar',
  [`${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.GET_EVENT}-desc`]:
    'Retrieve the details of a specific event by its ID from your Outlook Calendar',
  [`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.SEND_EMAIL}`]: 'Send Email',
  [`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.SEARCH_EMAILS}`]:
    'Search Emails',
  [`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.REPLY_EMAIL}`]: 'Reply to Email',
  [`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.CREATE_DRAFT}`]: 'Create Draft',
  [`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.CREATE_DRAFT_REPLY}`]:
    'Create Draft Reply',
  [`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.GET_EMAIL_ATTACHMENTS}`]:
    'Get Email Attachments',
  [`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.SEARCH_PEOPLE}`]:
    'Search People',
  [`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.SEND_EMAIL}-desc`]:
    'Compose and send an email directly through your Gmail account',
  [`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.SEARCH_EMAILS}-desc`]:
    'Search and find emails in your Gmail inbox using keywords and filters',
  [`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.REPLY_EMAIL}-desc`]:
    'Reply to an existing email thread in your Gmail account',
  [`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.CREATE_DRAFT}-desc`]:
    'Create and save an email draft in your Gmail account without sending it',
  [`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.CREATE_DRAFT_REPLY}-desc`]:
    'Create a draft reply to an existing email thread without sending it',
  [`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.GET_EMAIL_ATTACHMENTS}-desc`]:
    'Retrieve emails along with their attachments from your Gmail account',
  [`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.SEARCH_PEOPLE}-desc`]:
    'Search for people in your Gmail contacts and domain directory',

  // Google Calendar
  [`${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.LIST_CALENDARS}`]:
    'List Calendars',
  [`${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.VIEW_EVENTS}`]:
    'View Events',
  [`${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.CREATE_EVENT}`]:
    'Create Event',
  [`${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.UPDATE_EVENT}`]:
    'Update Event',
  [`${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.DELETE_EVENT}`]:
    'Delete Event',
  [`${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.SEARCH_PEOPLE}`]:
    'Search People',
  [`${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.LIST_CALENDARS}-desc`]:
    'Display all calendars available in your Google Calendar account',
  [`${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.VIEW_EVENTS}-desc`]:
    'View and retrieve events from a specific calendar in your Google Calendar',
  [`${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.CREATE_EVENT}-desc`]:
    'Schedule a new event or meeting in your Google Calendar',
  [`${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.UPDATE_EVENT}-desc`]:
    'Modify the details of an existing event in your Google Calendar',
  [`${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.DELETE_EVENT}-desc`]:
    'Remove a specific event from your Google Calendar',
  [`${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.SEARCH_PEOPLE}-desc`]:
    'Search for people in your Google contacts and domain directory',

  // Google Drive
  [`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-${GOOGLE_DRIVE.GET_SHARED_DRIVES}`]:
    'Get Shared Drives',
  [`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-${GOOGLE_DRIVE.GET_FOLDERS}`]:
    'Get Folders',
  [`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-${GOOGLE_DRIVE.SEARCH_FILES}`]:
    'Search Files',
  [`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-${GOOGLE_DRIVE.DOWNLOAD_FILE}`]:
    'Download File',
  [`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-${GOOGLE_DRIVE.SEARCH_PEOPLE}`]:
    'Search People',
  [`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-${GOOGLE_DRIVE.GET_SHARED_DRIVES}-desc`]:
    'List all shared drives available in your Google Drive account',
  [`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-${GOOGLE_DRIVE.GET_FOLDERS}-desc`]:
    'Retrieve and display folders from your Google Drive',
  [`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-${GOOGLE_DRIVE.SEARCH_FILES}-desc`]:
    'Search for files and documents in your Google Drive using keywords',
  [`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-${GOOGLE_DRIVE.DOWNLOAD_FILE}-desc`]:
    'Download a specific file from your Google Drive',
  [`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-${GOOGLE_DRIVE.SEARCH_PEOPLE}-desc`]:
    'Search for people in your Google contacts and domain directory',

  // Slack
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.SEARCH_MESSAGES}`]: 'Search Messages',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_PEOPLE}`]: 'Get People',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_USER_BY_EMAIL}`]:
    'Get User by Email',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_USER_INFO}`]: 'Get User Info',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.LIST_USER_CONVERSATIONS}`]:
    'List User Conversations',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_MY_CHANNELS}`]: 'Get My Channels',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_CHANNEL_INFO}`]: 'Get Channel Info',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_CHANNEL_MESSAGES}`]:
    'Get Channel Messages',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_THREAD_REPLIES}`]:
    'Get Thread Replies',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.REPLY_TO_MESSAGE}`]: 'Reply to Message',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.SEND_MESSAGE}`]: 'Send Message',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.SEARCH_MESSAGES}-desc`]:
    'Search for messages across your Slack workspace using keywords',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_PEOPLE}-desc`]:
    'Retrieve a list of all users in your Slack workspace',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_USER_BY_EMAIL}-desc`]:
    'Find a specific Slack user by their email address',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_USER_INFO}-desc`]:
    'Get information about the currently authenticated user',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.LIST_USER_CONVERSATIONS}-desc`]:
    'List all conversations for a specific user in Slack',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_MY_CHANNELS}-desc`]:
    'Retrieve all channels you are a member of in Slack',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_CHANNEL_INFO}-desc`]:
    'Get detailed information about a specific Slack channel',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_CHANNEL_MESSAGES}-desc`]:
    'Retrieve messages from a specific Slack channel',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_THREAD_REPLIES}-desc`]:
    'Get all replies in a specific message thread',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.REPLY_TO_MESSAGE}-desc`]:
    'Reply to a specific message thread in Slack',
  [`${ACTIONS_CATEGORIES.SLACK}-${SLACK.SEND_MESSAGE}-desc`]:
    'Send a new message to a Slack channel',

  // HubSpot
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.FIND_COMPANIES}`]: 'Find Companies',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.CREATE_COMPANY}`]: 'Create Company',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.UPDATE_COMPANY}`]: 'Update Company',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.SEARCH_COMPANIES}`]:
    'Search Companies',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.SEARCH_COMPANIES_ADVANCED}`]:
    'Search Companies Advanced',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.GET_OWNERS}`]: 'Get Owners',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.GET_USER_INFO}`]: 'Get User Info',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.GET_CONTACTS}`]: 'Get Contacts',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.CREATE_CONTACT}`]: 'Create Contact',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.UPDATE_CONTACT}`]: 'Update Contact',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.CREATE_DEAL}`]: 'Create Deal',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.SEARCH_DEALS}`]: 'Search Deals',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.UPDATE_DEAL}`]: 'Update Deal',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.GET_COMPANY_RECENT_ACTIVITIES}`]:
    'Get Company Recent Activities',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.GET_CONTACT_RECENT_ACTIVITIES}`]:
    'Get Contact Recent Activities',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.CREATE_TASK}`]: 'Create Task',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.CREATE_NOTE}`]: 'Create Note',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.FIND_COMPANIES}-desc`]:
    'Search and find companies in your HubSpot CRM by various criteria',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.CREATE_COMPANY}-desc`]:
    'Create a new company record in your HubSpot CRM',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.UPDATE_COMPANY}-desc`]:
    'Update information for an existing company in HubSpot',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.SEARCH_COMPANIES}-desc`]:
    'Search for companies using filters and specific criteria',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.SEARCH_COMPANIES_ADVANCED}-desc`]:
    'Perform advanced searches for companies with complex filter combinations',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.GET_OWNERS}-desc`]:
    'Retrieve a list of all owners in your HubSpot account',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.GET_USER_INFO}-desc`]:
    'Get information about the currently authenticated HubSpot user',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.GET_CONTACTS}-desc`]:
    'Retrieve contacts from your HubSpot CRM with optional filtering',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.CREATE_CONTACT}-desc`]:
    'Create a new contact record in your HubSpot CRM',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.UPDATE_CONTACT}-desc`]:
    'Update information for an existing contact in HubSpot',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.CREATE_DEAL}-desc`]:
    'Create a new deal in your HubSpot sales pipeline',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.SEARCH_DEALS}-desc`]:
    'Search for deals in HubSpot using advanced filters and criteria',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.UPDATE_DEAL}-desc`]:
    'Update details of an existing deal in your HubSpot pipeline',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.GET_COMPANY_RECENT_ACTIVITIES}-desc`]:
    'Retrieve recent activities associated with a specific company',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.GET_CONTACT_RECENT_ACTIVITIES}-desc`]:
    'Retrieve recent activities associated with a specific contact',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.CREATE_TASK}-desc`]:
    'Create a new task for a contact or company in HubSpot',
  [`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.CREATE_NOTE}-desc`]:
    'Create a new note for a contact or company in HubSpot',

  // Jira
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ACCESSIBLE_RESOURCES}`]:
    'Get Accessible Resources',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_CURRENT_USER}`]: 'Get Current User',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE}`]: 'Get Issue',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE_REMOTE_LINKS}`]:
    'Get Issue Remote Links',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE_TYPE_FIELDS}`]:
    'Get Issue Type Fields',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_PROJECT_ISSUE_TYPES}`]:
    'Get Project Issue Types',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE_LINK_TYPES}`]:
    'Get Issue Link Types',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_TRANSITIONS}`]: 'Get Transitions',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_PROJECTS}`]: 'Get Projects',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.LOOKUP_ACCOUNT_ID}`]: 'Lookup Account ID',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.ADD_COMMENT}`]: 'Add Comment',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.ADD_WORKLOG}`]: 'Add Worklog',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.CREATE_ISSUE}`]: 'Create Issue',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.UPDATE_ISSUE}`]: 'Update Issue',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.TRANSITION_ISSUE}`]: 'Transition Issue',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.SEARCH_ISSUES}`]: 'Search Issues',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ACCESSIBLE_RESOURCES}-desc`]:
    'List the Atlassian sites your account can access',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_CURRENT_USER}-desc`]:
    'Get the current authenticated Atlassian user information',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE}-desc`]:
    'Fetch a specific Jira issue by its key or ID',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE_REMOTE_LINKS}-desc`]:
    'Get remote links (e.g. Confluence pages, external URLs) on a Jira issue',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE_TYPE_FIELDS}-desc`]:
    'Get the required and optional fields for an issue type in a project',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_PROJECT_ISSUE_TYPES}-desc`]:
    'Get the issue types available for a Jira project',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE_LINK_TYPES}-desc`]:
    'List the available issue link types, such as blocks or relates to',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_TRANSITIONS}-desc`]:
    'List the valid workflow transitions available for a Jira issue',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_PROJECTS}-desc`]:
    'List Jira projects visible to the current user',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.LOOKUP_ACCOUNT_ID}-desc`]: `Resolve a user's Atlassian account ID by name or email`,
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.ADD_COMMENT}-desc`]:
    'Add a comment to a Jira issue',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.ADD_WORKLOG}-desc`]:
    'Log work against a Jira issue',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.CREATE_ISSUE}-desc`]:
    'Create a new Jira issue in a project',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.UPDATE_ISSUE}-desc`]:
    'Update fields on an existing Jira issue',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.TRANSITION_ISSUE}-desc`]:
    'Move a Jira issue through its workflow',
  [`${ACTIONS_CATEGORIES.JIRA}-${JIRA.SEARCH_ISSUES}-desc`]:
    'Search Jira issues using JQL',

  // Confluence
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_ACCESSIBLE_RESOURCES}`]:
    'Get Accessible Resources',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_CURRENT_USER}`]:
    'Get Current User',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE}`]: 'Get Page',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE_DESCENDANTS}`]:
    'Get Page Descendants',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE_FOOTER_COMMENTS}`]:
    'Get Page Footer Comments',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE_INLINE_COMMENTS}`]:
    'Get Page Inline Comments',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_FOOTER_COMMENT_CHILDREN}`]:
    'Get Footer Comment Replies',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_SPACES}`]: 'Get Spaces',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGES_IN_SPACE}`]:
    'Get Pages in Space',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.CREATE_PAGE}`]: 'Create Page',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.UPDATE_PAGE}`]: 'Update Page',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.CREATE_FOOTER_COMMENT}`]:
    'Create Footer Comment',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.CREATE_INLINE_COMMENT}`]:
    'Create Inline Comment',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.SEARCH_CQL}`]:
    'Search Confluence',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_ACCESSIBLE_RESOURCES}-desc`]:
    'List the Atlassian sites your account can access',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_CURRENT_USER}-desc`]:
    'Get the current authenticated Atlassian user information',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE}-desc`]:
    'Get a Confluence page by its ID',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE_DESCENDANTS}-desc`]:
    'Get the descendant pages of a Confluence page',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE_FOOTER_COMMENTS}-desc`]:
    'Get footer comments on a Confluence page',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE_INLINE_COMMENTS}-desc`]:
    'Get inline comments on a Confluence page',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_FOOTER_COMMENT_CHILDREN}-desc`]:
    'Get replies to a Confluence footer comment',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_SPACES}-desc`]:
    'List Confluence spaces',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGES_IN_SPACE}-desc`]:
    'List pages in a Confluence space',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.CREATE_PAGE}-desc`]:
    'Create a new Confluence page',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.UPDATE_PAGE}-desc`]: `Update an existing Confluence page's body and optionally its title`,
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.CREATE_FOOTER_COMMENT}-desc`]:
    'Add a footer comment to a Confluence page',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.CREATE_INLINE_COMMENT}-desc`]:
    'Add an inline comment anchored to selected text on a Confluence page',
  [`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.SEARCH_CQL}-desc`]:
    'Search Confluence pages and content using CQL',

  // Microsoft Teams
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.SEARCH_MESSAGES}`]:
    'Search Messages',
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.LIST_CHANNELS}`]:
    'List Channels',
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_CHANNEL_MESSAGES}`]:
    'Get Channel Messages',
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_CHAT_MESSAGES}`]:
    'Get Chat Messages',
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.SEND_CHANNEL_MESSAGE}`]:
    'Send Channel Message',
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.SEND_CHAT_MESSAGE}`]:
    'Send Chat Message',
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.SEARCH_MESSAGES}-desc`]:
    'Search for messages across all your Teams chats using keywords',
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.LIST_CHANNELS}-desc`]:
    'List all channels from all teams you are a member of',
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_CHANNEL_MESSAGES}-desc`]:
    'Get messages from a specific Teams channel with optional date filtering',
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_CHAT_MESSAGES}-desc`]:
    'Get messages from a specific Teams chat with optional date filtering',
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.SEND_CHANNEL_MESSAGE}-desc`]:
    'Send a message to a specific Teams channel with text or HTML formatting',
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.SEND_CHAT_MESSAGE}-desc`]:
    'Send a message to a specific Teams chat with text or HTML formatting',
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.LIST_CHATS}`]:
    'List Chats',
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_CHAT_MEMBERS}`]:
    'Get Chat Members',
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.LIST_CHATS}-desc`]:
    'List all one-on-one chats, group chats, and meeting chats you are a member of',
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_CHAT_MEMBERS}-desc`]:
    'Get all members of a specific chat including their display names, email addresses, and roles',
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.LIST_MEETINGS}`]:
    'List Meetings',
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_TRANSCRIPT}`]:
    'Get Meeting Transcript',
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.LIST_MEETINGS}-desc`]:
    'List your Teams online meetings with their subjects, times, and join links',
  [`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_TRANSCRIPT}-desc`]:
    'Get the transcript of a specific Teams meeting',

  // Google Docs
  [`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.SEARCH_DOCS}`]:
    'Search Docs',
  [`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.CREATE_DOCUMENT}`]:
    'Create Document',
  [`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.FETCH_DOCUMENT_CONTENT}`]:
    'Fetch Document Content',
  [`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.INSERT_TEXT}`]:
    'Insert Text',
  [`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.REPLACE_TEXT}`]:
    'Replace Text',
  [`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.FORMAT_TEXT}`]:
    'Format Text',
  [`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.FIND_AND_REPLACE_ALL}`]:
    'Find and Replace All',
  [`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.SEARCH_DOCS}-desc`]:
    'Search for documents in your Google Docs using keywords and filters',
  [`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.CREATE_DOCUMENT}-desc`]:
    'Create a new Google Docs document with a specified title',
  [`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.FETCH_DOCUMENT_CONTENT}-desc`]:
    'Fetch the content and metadata of a specific Google Doc',
  [`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.INSERT_TEXT}-desc`]:
    'Insert text at specific locations in a Google Doc',
  [`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.REPLACE_TEXT}-desc`]:
    'Replace specific text passages in a Google Doc',
  [`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.FORMAT_TEXT}-desc`]:
    'Apply formatting styles to specific text in a Google Doc',
  [`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.FIND_AND_REPLACE_ALL}-desc`]:
    'Find and replace all occurrences of text in a Google Doc with optional case matching',

  // Google Sheets
  [`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.SEARCH_FILES}`]:
    'Search Files',
  [`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.CREATE_ROWS}`]:
    'Create Rows',
  [`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.UPDATE_ROWS}`]:
    'Update Rows',
  [`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.LIST_ROWS}`]:
    'List Rows',
  [`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.GET_METADATA}`]:
    'Get Metadata',
  [`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.ADD_SHEET}`]:
    'Add Sheet',
  [`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.SEARCH_FILES}-desc`]:
    'Search for spreadsheet files in your Google Sheets using keywords and filters',
  [`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.CREATE_ROWS}-desc`]:
    'Insert empty rows into a specific sheet at a specified position',
  [`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.UPDATE_ROWS}-desc`]:
    'Update existing rows in a sheet with new values',
  [`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.LIST_ROWS}-desc`]:
    'List rows from a sheet starting from a specific row number',
  [`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.GET_METADATA}-desc`]:
    'Get metadata information about a spreadsheet including sheet names and properties',
  [`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.ADD_SHEET}-desc`]:
    'Add a new sheet tab to an existing spreadsheet with specified dimensions',

  // Microsoft SharePoint
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_PROFILE}`]:
    'Get Profile',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_DRIVES}`]:
    'List Drives',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.SEARCH_SITES}`]:
    'Search Sites',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_SITE}`]:
    'Get Site',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SUBSITES}`]:
    'List Subsites',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_DRIVE_CHILDREN}`]:
    'List Drive Children',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_RECENT_FILES}`]:
    'List Recent Files',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SITE_USERS}`]:
    'List Site Users',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SITE_LISTS}`]:
    'List Site Lists',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_LIST}`]:
    'Get List',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_COLUMNS}`]:
    'List Columns',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_COLUMN}`]:
    'Get Column',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_LIST_ITEMS}`]:
    'List List Items',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_LIST_ITEM}`]:
    'Get List Item',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SITE_PAGES}`]:
    'List Site Pages',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_GROUPS}`]:
    'Get Groups',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_GROUP_MEMBERS}`]:
    'Get Group Members',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.ADD_GROUP_MEMBER}`]:
    'Add Group Member',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.REMOVE_GROUP_MEMBER}`]:
    'Remove Group Member',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.SEARCH_FILES}`]:
    'Search Files',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.UPLOAD_FILE}`]:
    'Upload File',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_FOLDER}`]:
    'Get Folder',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_PROFILE}-desc`]:
    'Get the profile information for the current user',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_DRIVES}-desc`]:
    'List drives in a site or drives accessible by the current user',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.SEARCH_SITES}-desc`]:
    'Search for SharePoint sites using keywords',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_SITE}-desc`]:
    'Get detailed information about a specific SharePoint site',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SUBSITES}-desc`]:
    'List all subsites within a SharePoint site',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_DRIVE_CHILDREN}-desc`]:
    'List files and folders in a drive at root or within a folder',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_RECENT_FILES}-desc`]:
    'List files recently accessed by the current user',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SITE_USERS}-desc`]:
    'List all users who have access to a SharePoint site',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SITE_LISTS}-desc`]:
    'List all SharePoint lists within a site',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_LIST}-desc`]:
    'Get metadata and details for a specific SharePoint list',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_COLUMNS}-desc`]:
    'List all column definitions in a SharePoint list',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_COLUMN}-desc`]:
    'Get the definition and metadata of a specific column',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_LIST_ITEMS}-desc`]:
    'List items from a SharePoint list with optional filtering',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_LIST_ITEM}-desc`]:
    'Get detailed data for a specific item in a SharePoint list',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SITE_PAGES}-desc`]:
    'List all site pages within a SharePoint site',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_GROUPS}-desc`]:
    'Get all groups for the current user or a specific user',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_GROUP_MEMBERS}-desc`]:
    'Get all members of a specific group',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.ADD_GROUP_MEMBER}-desc`]:
    'Add a user as a member to a group',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.REMOVE_GROUP_MEMBER}-desc`]:
    'Remove a user from a group',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.SEARCH_FILES}-desc`]:
    'Search for files by name within a drive',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.UPLOAD_FILE}-desc`]:
    'Upload a file to a SharePoint folder',
  [`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_FOLDER}-desc`]:
    'Resolve a folder path to get drive and folder IDs',

  // Microsoft OneDrive
  [`${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.LIST_AVAILABLE_DRIVES}`]:
    'List Available Drives',
  [`${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.GET_FOLDER_BY_PATH}`]:
    'Get Folder by Path',
  [`${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.SEARCH_FOLDERS_BY_NAME}`]:
    'Search Folders by Name',
  [`${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.SEARCH_FILES_BY_NAME}`]:
    'Search Files by Name',
  [`${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.CREATE_FOLDER}`]:
    'Create Folder',
  [`${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.LIST_FOLDER_CHILDREN}`]:
    'List Folder Children',
  [`${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.DOWNLOAD_FILE}`]:
    'Download File',
  [`${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.LIST_AVAILABLE_DRIVES}-desc`]:
    'List all accessible OneDrive locations for the current user',
  [`${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.GET_FOLDER_BY_PATH}-desc`]:
    'Retrieve a folder by its path relative to drive root',
  [`${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.SEARCH_FOLDERS_BY_NAME}-desc`]:
    'Search for folders by name across the drive',
  [`${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.SEARCH_FILES_BY_NAME}-desc`]:
    'Search for files by name across the drive',
  [`${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.CREATE_FOLDER}-desc`]:
    'Create a folder by path, creating missing parent folders as needed',
  [`${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.LIST_FOLDER_CHILDREN}-desc`]:
    'List all files and folders within a specific folder path',
  [`${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.DOWNLOAD_FILE}-desc`]:
    'Download a file from OneDrive by file ID',

  [ACTIONS_CATEGORIES.DATEV_ACCOUNTING]: 'DATEV Accounting',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-desc`]:
    'Access DATEV accounting — clients, fiscal years, ledger accounts, and document postings.',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.LIST_CLIENTS}`]:
    'List Clients',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.LIST_CLIENTS}-desc`]:
    'List all accessible DATEV accounting clients.',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_CLIENT}`]:
    'Get Client',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_CLIENT}-desc`]:
    'Get a single DATEV accounting client by UUID.',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_FISCAL_YEARS}`]:
    'Get Fiscal Years',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_FISCAL_YEARS}-desc`]:
    'Return all fiscal year IDs for a client.',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_FISCAL_YEAR}`]:
    'Get Fiscal Year',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_FISCAL_YEAR}-desc`]:
    'Return detail for a single fiscal year (account system, currency, date range).',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_GENERAL_LEDGER_ACCTS}`]:
    'Get General Ledger Accounts',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_GENERAL_LEDGER_ACCTS}-desc`]:
    'Return general ledger accounts for a fiscal year.',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_SUMS_AND_BALANCES}`]:
    'Get Sums and Balances',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_SUMS_AND_BALANCES}-desc`]:
    'Return monthly sums and balances for a fiscal year.',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_ACCOUNTING_SEQUENCES}`]:
    'Get Accounting Sequences',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_ACCOUNTING_SEQUENCES}-desc`]:
    'Return accounting sequences for a fiscal year.',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_TERMS_OF_PAYMENT}`]:
    'Get Terms of Payment',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_TERMS_OF_PAYMENT}-desc`]:
    'Return terms of payment (discounts, due dates) for a fiscal year.',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_DOCUMENT_TYPES}`]:
    'Get Document Types',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_DOCUMENT_TYPES}-desc`]:
    'Return all document types configured for a DATEV client.',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_DUO_VERSION}`]:
    'Get DUO Version',
  [`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_DUO_VERSION}-desc`]:
    "Return allowed file extensions and staple logic for a client's DUO version.",

  [ACTIONS_CATEGORIES.DATEV_HR]: 'DATEV HR',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-desc`]:
    'Access DATEV HR — payroll, employee data, social security, absences, and payslips.',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.LIST_HR_CLIENTS}`]:
    'List HR Clients',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.LIST_HR_CLIENTS}-desc`]:
    'List all HR clients accessible with the current token.',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_HR_CLIENT}`]: 'Get HR Client',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_HR_CLIENT}-desc`]:
    'Get a single HR client by ID.',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_MASTER_DATA}`]:
    'Get Employee Master Data',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_MASTER_DATA}-desc`]:
    'Return master data (personal info, employment details) for a single employee.',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_SALARY_DETAILS}`]:
    'Get Employee Salary Details',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_SALARY_DETAILS}-desc`]:
    'Return salary details for a single employee.',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_TAX_PAYMENTS}`]:
    'Get Employee Tax Payments',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_TAX_PAYMENTS}-desc`]:
    'Return wage tax and church tax payments for a single employee.',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_SOCIAL_SECURITY}`]:
    'Get Employee Social Security',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_SOCIAL_SECURITY}-desc`]:
    'Return social security payment data for a single employee.',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_ABSENCES}`]:
    'Get Employee Absences',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_ABSENCES}-desc`]:
    'Return absence data (vacation, sick leave, overtime) for a single employee.',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_ID_BY_PERSONNEL_NUM}`]:
    'Get Employee ID by Personnel Number',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_ID_BY_PERSONNEL_NUM}-desc`]:
    'Look up the DATEV employee ID using a company personnel number.',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_MASTER_DATA}`]:
    'Get All Employees Master Data',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_MASTER_DATA}-desc`]:
    'Return master data for all employees of a client.',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_SALARY_DETAILS}`]:
    'Get All Employees Salary Details',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_SALARY_DETAILS}-desc`]:
    'Return salary details for all employees of a client.',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_TAX_PAYMENTS}`]:
    'Get All Employees Tax Payments',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_TAX_PAYMENTS}-desc`]:
    'Return tax payments for all employees of a client.',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_SOCIAL_SECURITY}`]:
    'Get All Employees Social Security',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_SOCIAL_SECURITY}-desc`]:
    'Return social security payments for all employees of a client.',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_ABSENCES}`]:
    'Get All Employees Absences',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_ABSENCES}-desc`]:
    'Return absences for all employees of a client.',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_CLIENT}`]:
    'Get Payroll Client',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_CLIENT}-desc`]:
    'Return HR payroll client info including document type access rights.',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_REPORTS}`]:
    'Get Payroll Reports',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_REPORTS}-desc`]:
    'Return payroll documents for a client and period.',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_DOCUMENT_AVAILABILITY}`]:
    'Get Payroll Document Availability',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_DOCUMENT_AVAILABILITY}-desc`]:
    'Check if payroll documents are available for a client and period.',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_PAYSLIP_NUMBERS}`]:
    'Get Employee Payslip Numbers',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_PAYSLIP_NUMBERS}-desc`]:
    'Return employee numbers that have payslips for a given period.',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_REPORT_METADATA}`]:
    'Get Payroll Report Metadata',
  [`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_REPORT_METADATA}-desc`]:
    'Return metadata about available payroll reports across employees.',

  [ACTIONS_CATEGORIES.MICROSOFT_D365]: 'Dynamics 365',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-desc`]:
    'Query Dynamics 365 — customers, vendors, items, sales, purchasing, and general ledger reporting.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_CUSTOMERS}`]:
    'List Customers',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_CUSTOMERS}-desc`]:
    'Customer master data: contact details, addresses, payment terms, credit limits, balances.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_VENDORS}`]:
    'List Vendors',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_VENDORS}-desc`]:
    'Vendor master data: company details, addresses, payment terms, tax registration, balances.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_ITEMS}`]:
    'List Items',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_ITEMS}-desc`]:
    'Item master data: descriptions, pricing, unit costs, tax groups, inventory levels.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_EMPLOYEES}`]:
    'List Employees',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_EMPLOYEES}-desc`]:
    'Employee master data: personal details, employment status, job titles, banking info.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_COMPANY_INFORMATION}`]:
    'List Company Information',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_COMPANY_INFORMATION}-desc`]:
    'Company profile: name, address, contact details, tax registration numbers, banking info.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_BANK_ACCOUNTS}`]:
    'List Bank Accounts',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_BANK_ACCOUNTS}-desc`]:
    'Bank account records: account numbers, bank names, balances, IBAN/SWIFT codes.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_CURRENCIES}`]:
    'List Currencies',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_CURRENCIES}-desc`]:
    'Currency master data: codes, symbols, ISO codes, rounding settings.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_SALES_INVOICES}`]:
    'List Sales Invoices',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_SALES_INVOICES}-desc`]:
    'Open sales invoices: customer details, amounts, tax info, due dates, status.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_POSTED_SALES_INVOICES}`]:
    'List Posted Sales Invoices',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_POSTED_SALES_INVOICES}-desc`]:
    'Posted (finalized) sales invoices.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_SALES_CREDIT_MEMOS}`]:
    'List Sales Credit Memos',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_SALES_CREDIT_MEMOS}-desc`]:
    'Sales credit memos: customer details, amounts, tax info, related invoice references.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_SALES_ORDERS}`]:
    'List Sales Orders',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_SALES_ORDERS}-desc`]:
    'Sales orders: customer details, addresses, order status, delivery dates, totals.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_CUSTOMER_PAYMENTS}`]:
    'List Customer Payments',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_CUSTOMER_PAYMENTS}-desc`]:
    'Customer payment transactions: amounts, dates, methods, related invoices.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_PURCHASE_INVOICES}`]:
    'List Purchase Invoices',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_PURCHASE_INVOICES}-desc`]:
    'Open purchase invoices: vendor details, amounts, due dates, payment terms, status.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_POSTED_PURCHASE_INVOICES}`]:
    'List Posted Purchase Invoices',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_POSTED_PURCHASE_INVOICES}-desc`]:
    'Posted (finalized) purchase invoices.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_PURCHASE_CREDIT_MEMOS}`]:
    'List Purchase Credit Memos',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_PURCHASE_CREDIT_MEMOS}-desc`]:
    'Purchase credit memos: vendor details, amounts, currency, payment terms, status.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_PURCHASE_ORDERS}`]:
    'List Purchase Orders',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_PURCHASE_ORDERS}-desc`]:
    'Purchase orders: vendor details, order status, delivery/payment info, totals.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_VENDOR_PAYMENTS}`]:
    'List Vendor Payments',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_VENDOR_PAYMENTS}-desc`]:
    'Vendor payment transactions: amounts, dates, methods, invoice application details.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_GL_ACCOUNTS}`]:
    'List GL Accounts',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_GL_ACCOUNTS}-desc`]:
    'Chart of accounts: numbers, names, categories, balances, posting settings (read-only).',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_GENERAL_LEDGER_ENTRIES}`]:
    'List General Ledger Entries',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_GENERAL_LEDGER_ENTRIES}-desc`]:
    'Posted G/L entries: entry number, posting date, document type, account, debit/credit amounts.',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_TRIAL_BALANCES}`]:
    'List Trial Balances',
  [`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_TRIAL_BALANCES}-desc`]:
    'Trial balance data for all G/L accounts: account numbers, names, types, debit/credit balances.',

  addAction: 'Add actions for assistant',
  searchActions: 'Search Actions',
  commaSeparated: '(comma separated)',
  noParametersAction: 'Action has no parameters',
  commaSeparatedFieldPlaceholder: `Enter {{label}} separated by commas`,
  fieldPlaceholder: `Enter {{label}}`,
  removeAll: 'Remove All',
  addAll: 'Add All',
  noConnectorsFound: 'No Connections have been made yet.',
  connect: 'Connect',
  disconnect: 'Disconnect',
  connected: 'Connected',
  reconnect: 'Reauthorize',
  notConnected: 'Not connected',
  connectors: 'Connectors',
  manageConnectors: 'Manage connectors',
  addConnector: 'Add connector',
  addConnectors: 'Add connectors',
  connectorsModalDescription: 'Empower your productivity with connectors.',
  searchConnector: 'Search connector',
  noConnectorsConnectedYetTitle: 'No connectors are connected yet.',
  noConnectorsConnectedYetDescription:
    'Go to the All Connectors tab and connect any connector.\nYour connected connectors will appear here.',
  noRemainingConnectorsToConnectTitle:
    'No remaining connectors to connect now.',
  noRemainingConnectorsToConnectDescription:
    'All connectors are connected, and no more are available to connect.',
  noConnectorMatchTitle: 'No connector matches that name.',
  noConnectorMatchDescription:
    'Search for the connector by its exact name or browse the full list of connectors.',
  showAll: 'Show all',
  showLess: 'Show less',
  workflowsNavLabel: 'Workflows',
  connectorsDescription:
    'Connect your tools and use them directly inside Assistants to see real work happen in real time.',
  askForConfirmation: 'Ask for confirmation',
  askForConfirmationTooltip:
    "You'll be asked to confirm while using this action in the chat.",
  toolPermissions: 'Tool permissions',
  enableAll: 'Enable all',
  connectedActions: 'Connected actions',
  actionsLibrary: 'Actions library',
  addActionsDescription: 'Add actions that your assistant can perform.',
  noActionsConnectedYet: 'No actions connected yet',
  addConnections: 'Add connections',
  enabledCount: '{{count}}/{{total}} enabled',
  addActions: 'Add actions',
  connectorConfigDescription:
    'The selected configuration will be applied to all the action tasks in this integration.',
  connectorOwnConnectionQuestion:
    'Should users of this assistant use their own {{connector}} connection for this action?',
  connectorDefaultOption:
    'Yes, users will need to connect their {{connector}} account.',
  connectorAdvancedOption:
    'No, all users should use the same, preselected connection. (Advanced)',
  connectorAttentionDescription:
    'Choose your connection wisely. Everyone using this assistant can access it through this action, so ensure it complies with all access policies.',
  connectedSuccessfully: 'Connected Successfully',
  actionsLimitDescription: 'You can add up to 10 actions per assistant.',
  addConnectorDescription:
    'The selected configuration will be applied to all the action tasks in this integration.',
  addActionDisclaimer:
    'Should users of this assistant use their own {{action_category}} connection for this action?',
  defaultConnectionDisclaimer:
    'Yes, users will need to connect their {{action_category}} account.',
  preSelectedDisclaimer:
    'No, all users should use the same, preselected connection.',
  attention: 'Attention',
  rulesDisclaimer: `Be careful when selecting a connection. All users of this
  assistant will be able to use the connection when using this
  action. Make sure this does not violate any access rules.`,
  addConnection: 'Add Connection',
  addNewAction: 'Add Action',
  addNewActions: 'Add Actions',
  action: 'Actions',
  preBuildActionText:
    'Select a pre-build action or create a new custom action to connect with external tools.',
  noActionsAvailable: 'No actions available.',
  authenticationDisclaimer:
    'The user needs to authorize first in order to invoke this action.',
  authenticate: 'Authenticate',
  deny: 'Deny',
  advanceConnectionAuthenticationMsg:
    'Please ask the owner of this assistant to reauthorize',
  addAdvanceConnectionTooltip: 'Please add the connection to use this action',

  //Self Sign-up
  companyInfoDesc: `We'd love to know a bit more about you...`,
  enterCompanyName: 'What’s your company name?',
  firstName: 'First Name',
  lastName: 'Last Name',
  confirmPassword: 'Confirm Password',
  password: 'Password',
  emailVerification: 'Email Verification',
  emailSentText: `We sent an email to {{email}} to verify your email address.`,
  pleaseVerifyEmail: `Please click on the “Verify email” button to continue.`,
  contactUsText: 'For help, contact us at info@empowergpt.io',
  notSeeingEmail: 'Not seeing the email?',
  checkSpam: `Please check your spam folder or `,
  resendEmail: ' Resend Email',
  companyNameRequired: 'Company name is required',
  addCompanyName: 'Enter company name',
  companySize: `What’s your company size?`,
  companySizeRequired: 'Company size is required',
  companySizeKey: 'Company size',
  roleText: 'What’s your role?',
  roleRequired: 'Role is required',
  basedCountry: 'In which country your company based in?',
  countrySelectionRequired: 'Country is required',
  startFreeTrial: 'Start My Free Trial',
  billing: 'Billing',
  paymentMethod: 'Payment Methods',
  billingText: 'Manage your organization billing information.',
  upgradePlan: 'Upgrade Plan',
  paymentDesc:
    'The default method is used automatically for all your subscriptions',
  addPaymentMethod: 'Add Payment Method',
  noPaymentAdded: 'No payment method added yet.',
  trialLi1: 'Access to core chat and assistant features',
  trialLi2: 'Start with €5 credit for chats and file usage',
  trialLi3: 'Add up to 5 team members',
  trialLi4: 'Secure workspace with basic history',
  trialLi5: 'Limited access to Mini Experts',
  trialLi6: 'Perfect for testing and exploring EmpowerGPT',
  essentialFeaturesHeading: 'Monthly Usage Limits & Capabilities',
  essentialLi1: 'Chat with enterprise-grade AI with Fair-use policy',
  essentialLi2: 'File Processing: 7 million words / 150+ files',
  essentialLi3: 'Search Plus: 50 searches',
  essentialLi4: 'Use 1 pre-built app',
  essentialLi5: 'Doc Analyst: 3 analyses (up to 10 questions each)',
  essentialLi6: 'OCR: 50 Files',
  essentialTagline: 'Your Entry into Enterprise AI',
  perMonthPerUser: '/month per user',
  pricingUpgrade: 'Upgrade',
  yearly: 'Yearly',
  save20: 'Save 20%',
  monthly: 'Monthly',
  trial: 'Trial',
  essential: 'Essential',
  professional: 'Professional',
  freeTrial: '7 days free trial',
  trialCardText:
    'For anyone to experience the amazing features of EmpowerGPT products.',
  currentPlan: 'Current Plan',
  perMonth: 'per month',
  essentialCardText:
    'Start with 1 user – 7-day free trial, no credit card needed, EU-hosted SaaS Deployment, Digital Service Support.',
  upgrade: 'Upgrade',
  upgradeToPro: 'Upgrade to pro',
  billedAnnually: 'Billed annually',
  letsTalk: 'Let’s talk',
  contactSales: 'Contact Sales',
  billedMonthly: 'Billed monthly',
  selfSignUpFailed: 'Self signup failed',
  passwordValidateFailure: 'Must include uppercase, number & special char',
  passwordMatchFailed: 'Passwords do not match',
  firstNameRequired: 'First name is required',
  firstNameInvalid: 'Special characters or extra spaces are not allowed',
  lastNameInvalid: 'Special characters or extra spaces are not allowed',
  lastNameRequired: 'Last name is required',
  passwordRequired: 'Password is required',
  confirmPasswordRequired: 'Confirm password is required',
  recaptchaRequired: 'Please verify that you are human',
  emailSuccessfullySend:
    'Account created successfully! Please verify your account through the email we’ve sent you',
  emailVerificationSuccessfullySend:
    'Email verification link sent successfully! Please check your email for the verification link.',
  noAccount: `Don't have an account?  `,
  seatManagement: 'Seat Management',
  seatManagementDesc:
    'Enhance your experience by adding extra seats to your pricing plan',
  updateSeats: 'Update Seats',
  updatePlan: 'Update Plan',
  availableSeat: 'Available Seats',
  totalPrice: 'Total Price',
  updateSubscription: 'Update Subscription',
  seats: 'Seats',
  seatSelectorDescription:
    'Add more seats to enhance the members productivity and collaboration.',
  calculateTotal: 'Calculate Total',
  purchasedPlan: 'Purchased plan',
  orderSummary: 'Order summary',
  selectedPlan: '{{plan}} Plan',
  proceedToPayment: 'Proceed with payment',
  checkOutDesc:
    'Your subscription is scheduled to renew  on {{date}} for {{price}}',
  businessOwner: 'Business Owner',
  seniorExecutive: 'Senior Executive',
  manager: 'Manager',
  associate: 'Associate',
  other: 'Other',
  executive: 'Executive',
  signUpSuccess: 'Redirecting to the login page',
  trialEnds: 'Your free trial will end in {{days}} days on: ',
  trialEndsToday: 'Your free trial ends today: ',
  trialEndedTitle: 'Your free trial has ended on: ',
  trialEndingOn: 'Your free trial ending on:',
  endsOn: 'Ending on: ',
  viewPlan: 'View Plan',
  trialExpiredTitle: 'Your free trial has ended.',
  subscriptionExpiredTitle: 'Your subscription has ended.',
  subscriptionExpiredDesc:
    'To continue using Empower gpt, please upgrade your plan.',
  upgradeNow: 'Upgrade Now',
  excludingTax: '(Excluding Tax and VAT)',
  month: 'month',
  vat: 'VAT',
  toBeCalculated: 'To be calculated',
  addCard: 'Add a Payment Method',
  companyInfoFailure: 'Unable to save company info',
  checkoutSuccessfully: 'Plan upgraded successfully',
  subscriptionSuccessfullyUpdated: 'Subscription successfully updated',
  occupiedSeats: 'Occupied Seats',
  newSeats: 'New Seats',
  totalSeats: 'Total Number of Seats',
  currentAmount: 'Billing Adjustment: €{{amount}}',
  newChargeAmount: 'Total amount for next subscription cycle: €{{amount}}',
  discardChange: ' Discard Changes',
  userInvitePartialSuccess:
    'Some users were not invited. {{emails}} out of {{total}} failed.',
  errorCalculatingPreview: 'Error calculating Invoice',
  backTo: 'Back to ',
  seatsNotAvailable: 'Please buy more seats to add more users',
  domainBlocked:
    'Please provide a valid, permanent email address. Temporary or disposable email domains are not allowed.',
  userAlreadyExist: 'User already exist',
  updatePaymentMethod: 'Update Payment Method',
  errorGettingStripeDashboardUrl: 'Error getting stripe dashboard url',
  errorDiscoveringTenant: 'Error discovering tenant',
  bestAIModelSelected: 'Best AI model selected',
  essentials: 'Essentials',
  upgradeRestricted: '⚠️ Upgrade Restricted',
  upgradeRestrictedInfo:
    'Contact your Organization Owner to upgrade your plan.',
  confirmCheckout: 'Confirm Checkout',
  confirmCheckoutDesc: 'Do you want to proceed?',
  confirmPayment: 'Confirm Payment',
  amountDeduction: 'Amount {{amount}} will be deducted from your account.',
  confirmUpgrade: 'Confirm Update',
  updateSubscriptionDesc: 'Are you sure to upgrade your subscription',
  minusSeatsDesc:
    'Your subscription will update at the end of the current billing cycle.',
  minusSeatWarningDesc:
    'If you reduce the number of seats, the change will take effect immediately. You won’t be able to assign users to the removed seats, and the billing adjustment will be reflected from your next cycle.',
  minusSeatWarningTitle: 'Change will take effect immediately!',
  unableToPreviewInvoice: 'Unable to preview invoice',
  errorUpdatingSubscription: 'Error updating subscription',
  subscriptionSyncError: 'Subscription sync error',
  noSubscription: 'Unable to find subscription',
  invalidSubscription: 'Invalid Subscription',
  wrongAddress: 'Customer tax location is invalid or not recognized.',
  subscriptionCancelledText:
    'No upcoming invoice found, subscription may be set to cancel.',
  insufficientBalance: 'The card has insufficient funds to process payment',
  endTrialError: 'We are unable to proceed the payment, please try again later',
  scoringAnalysisDisclaimer:
    'Scoring Analysis released in Beta. You can expect some discrepancies',
  cardActionRequiredError:
    'Additional user action is required to complete the payment',
  cardExpiredError: 'The payment was declined by the provider.',
  analysisQuestionLimitReached: 'Analysis question limit reached',
  paymentFailedError: 'The payment attempt failed, please try again',
  stripeTenantNotFoundError: 'The tenant does not exist',
  tenantDomainAlreadyExistsError: 'Domain already exists.',
  searchTenantNotFoundError: 'Search tenant not found.',
  activeSubscriptionAlreadyExistsError:
    'You already have an active subscription',
  upgradeYearlyPlan: 'Upgrade to yearly plan',
  upgradeToYearly: 'Upgrade to yearly',
  upgradeToProfessional: 'Upgrade to Professional',
  upgradeToYearlyDesc: 'Upgrade to yearly and save up to 20%.',
  shiftToYearlyPlan: 'Shift to Yearly Plan',
  upgradeToYearlyPlanButton: 'Upgrade To Yearly Plan',
  totalAmountToPayLine: 'Total Amount to Pay: {{amount}}',
  confirmYearlyUpgrade: 'Confirm Yearly Upgrade',
  confirmYearlyUpgradeAmount:
    'Amount {{amount}} will be deducted from your account.',
  confirmYearlyUpgradeQuestion: 'Do you want to proceed?',
  cancelled: 'Cancelled',
  updatedSubscriptionRequired:
    'Your subscription is scheduled to be cancelled at the end of billing cycle. Please enable it from dashboard to perform action.',
  subscriptionUpgradedSuccessfully: 'Subscription upgraded successfully',
  subscriptionUpgradeFailed: 'Subscription upgrade failed',
  trialAlreadyExpired: 'Trial already expired',
  subscriptionUpdateNotAllowed:
    'Subscription is canceled and payments are not allowed.',
  minimumSeatsViolation: 'Minimum seats violation',
  maximumSeatsViolation:
    'Maximum seats on your plan is 250, please contact sales to proceed',
  subscriptionRenewalNotAllowed:
    'Subscription renewal is not allowed, subscription may be set to cancel',
  subscriptionUpdateError: 'Error updating subscription',
  proceedToUpgrade: 'Proceed to upgrade',
  upgradeConfirmDesc:
    'Are you sure you want to switch your subscription to a yearly plan?',
  expired: 'Expired',
  domainNotRecognized: 'Domain is not recognized!',
  domainInvalidFormat:
    'Enter a valid domain name (special chars and caps case not allowed).',
  domainNotRegistered: 'The domain {{domain}} is not registered.',
  validDomainRequired: 'Please use a valid domain link to login.',
  checkEmailForDomain:
    'You can find the registered domain in your email. For further assistance, contact us at info@empowergpt.ai',
  dontRememberDomain: 'Don’t remember the domain?',
  loginFromThisLink: 'Please login from this link:',
  linkPlaceholder: 'link',
  creatingTenant: 'Creating Tenant',
  settingUpWorkspaces: 'Setting up Workspaces',
  configuringPreferences: 'Configuring Preferences',
  finalizingAccountSettings: 'Finalizing Account Settings',
  welcome: 'Welcome',
  compareModelTitle: 'Compare Models',
  compareModelDescription: 'Side-by-side',
  chatHelperText:
    '<highlight>Hi,\u00A0</highlight> <span>How can I assist you today?</span>',
  welcomeAndSignIn: 'Welcome and Sign In',
  signIn: 'Sign In',
  verifyingUser: 'Verifying User...',
  credentialVerifying: 'Please wait while we verify your credentials.',
  setUpPassword: 'Set up your account password',
  passwordGuide:
    'A strong password helps prevent unauthorized access to your email account.',
  reEnterPassword: 'Re-enter Password',
  verificationFailed: 'Sorry verification failed!',
  verificationFailedDescription:
    'Verification has failed due to the email expiration!',
  returnToLogin: 'Return to login',
  passwordLength: 'Minimum 8 characters required',
  specialCaseWarning: 'Add at least one special character',
  passwordNotMatched: 'Passwords do not match',
  passwordRequirementSpecial: 'At least one special character',
  passwordRequirementUppercase: 'At least one uppercase character',
  passwordRequirementLowercase: 'At least one lowercase character',
  passwordRequirementNumber: 'At least one number',
  passwordRequirementMinLength: '8 minimum characters',
  passwordRequirementMatch: 'Password must match',
  organizationSubDomain: 'Organization Sub Domain',
  organizationSubDomainPlaceholder: 'your-organization',
  checkAvailability: 'Check Availability',
  domainAvailable: 'Domain is available',
  domainUnavailable: 'Domain is not available',
  verifyEmail: 'Verify your email',
  sentEmailMessage: 'We sent an email to ',
  verificationEmailMessage: `Just click on the link in that email to complete your signup. If you
        don’t see it, you may need to
        <span>check your spam</span> folder.`,
  resendVerificationEmail: 'Resend verification email',
  changeEmail: 'Change email',
  fillDetailMsg: 'Please fill in the details to get started.',
  continueWithGoogle: 'Continue with Google',
  continueWithMicrosoft: 'Continue with Microsoft',
  dedicatedLoginUrl: 'After signup, we’ll create your dedicated Login URL',
  marketingConsent: `I agree to receive email updates about the onboarding guide,
                    products, services, and news from INTECH Automation &
                    Intelligence GmbH.`,
  or: 'Or',
  example: 'example: ',
  enterEmail: 'Enter email',
  trialHeading: 'Start your 7-day EmpowerGPT trial!',
  trialDescription:
    'Enjoy full access with zero risk. You can cancel anytime, no commitments required.',
  trustedEnterprise:
    'Trusted for enterprise knowledge, compliance, and internal data privacy.',
  noCreditCard: 'No credit card required',
  secureKnowledge: 'Secure knowledge search (RAG)',
  teamReady: 'Team-ready environment with private AI workspace',
  teamReadyEnvironment: 'Team-ready environment',
  anyDocumentUpload: 'Upload and query any number of documents',
  easyUpgrade: 'Easy upgrade path when scaling to Enterprise',
  compliance: 'Compliance',
  freeTrial7DayHeading: 'Your 7-day free trial includes:',
  readyLoginUrl: 'Your Login URL is ready',
  yourLoginUrl: 'Your login URL is:',
  bookMarkUrl: 'Bookmark this Login URL — you’ll use it to sign in every time.',
  copyUrl: 'Copy URL',
  startOnboarding: 'Start onboarding',
  needHelp: 'Need help? Contact us at',

  requiredText: 'Required',
  manageConnectorAccess:
    'Manage who has access to this connector and what they can do.',
  sqlDatabaseConnectionString: 'Database Connection String (DSN)',
  sqlDatabaseConnectionStringInvalid:
    'Invalid DSN format. Supported: postgres://, mysql://, mariadb://, sqlserver://',
  sqlDatabaseSupportedFormats: 'Supported formats:',
  sapClientIdLabel: 'SAP Client ID',
  sapClientIdPlaceholder: 'Provide Sap client ID',
  sapClientIdRequired: 'OAuth Client ID is required',
  sapClientIdInvalid:
    'Invalid client ID format. Use letters only, with underscores allowed between words (e.g. my_client_id).',
  sapTenantIdLabel: 'SAP Tenant Subdomain',
  sapTenantIdPlaceholder: 'my300123',
  sapTenantIdHelperText: 'Used to build the Auth, Token & User-info URLs.',
  sapTenantIdRequired: 'SAP tenant subdomain is required',
  sapTenantIdInvalid:
    'Invalid tenant subdomain format. Use lowercase letters, numbers, and hyphens only, starting and ending with a letter or number (e.g. my300123).',
  gotToGoogleConsole: 'Go to Google Cloud Console',
  iAMAccountService:
    'From the left navigation menu select ‘IAM & Admin’ and ‘Service Accounts’.',
  serviceAccount: `Create a new ‘Service Account’ by entering ‘Service Account Name’
            (For example: EmpowerGPT Integration).`,
  createContinueClickDone: 'Select ‘Create and Continue’ and click ‘Done’.',
  newServiceAccount: 'Click on newly created ‘Service Account’.',
  advancedSettingClientId: 'Under ‘Advance Settings’ → Copy ‘Client ID’.',
  selectCreate: `Go to ‘Keys’ tab and click ‘Add key → Create New Key’ → JSON and
            select ‘Create’.`,
  jsonFileDownloaded: 'A ‘JSON’ file will be downloaded',
  viewGoogleWorkspace:
    'Click on ‘View Google Workspace Admin Console’ or go to',
  domainDelegation: `Under the admin console, go to Security → Access & Data Control →
            API Controls → Domain wide delegation.`,
  copyStep2: `Click ‘Add new’ and paste the Service Account Client ID copied from
            Step 2.`,
  underScope: 'Under the scopes, select',
  stepsDone: `The above steps have been performed on the registered
                  application in Google Drive Entra ID.`,
  uploadJsonFile: 'Upload the JSON file.',
  clickDone: 'Click ‘Done’',
  uploadJsonFileLabel: 'Upload the JSON downloaded from previous step',
  goTo: 'Go to ',
  adminCredential: 'and login with your organization’s admin credentials.',
  createNewApp: `Create a new project (or use existing one). To create a new
              project, on the top left click Projects → New Project.`,
  projectAndOrganization:
    'Enter Project Name and select Organization and click ‘Create’.',
  instructionRead: 'I have read and performed the above instructions',
  navigateToDataAccess: `Navigate to ‘Data Access’ from the menu and click ‘Add or remove
              scopes’.`,
  addFollowingScopes: 'Add the following scopes:',
  navigateToClients: 'Navigate to ‘Clients’ and create a new client.',
  selectApplicationType: 'Select ‘Application Type’ as ‘Web Application’.',
  enterName: 'Enter Name (for example: EmpowerGPT SSO)',
  addUrlAs: 'Add redirect URL as',
  clickToCreate: 'Click ‘Create’.',
  copyClientAndSecret: `Go to newly created client and copy ‘Client ID' and 'Client Secret’
            and paste below.`,
  selectOAuthConsentScreen: `Select the project and from the left navigation menu, navigate to
              APIs and Services → OAuth Consent Screen`,
  clickToGetStarted: 'Click ‘Get Started’.',
  viewGoogleWorkspaceAdminConsole: `Select the project and from the left navigation menu, navigate to
              APIs and Services → OAuth Consent Screen.`,
  appNameExample: `App Name (for example ‘EmpowerGPT SSO’)`,
  userSupportEmail: `User Support Email.`,
  audienceToInternal: 'Audience → Internal',
  contactInformation: 'Contact Information',
  paymentPlanCreationFailed: 'Plan should not be a payment plan',
  paymentPlanAlreadyExist: 'This plan is already active.',
  paymentPlanUpdateFailed: 'Failed to update payment plan',

  // Data Library
  failed: 'Failed',
  clickAndNameYourFolder: 'Click and name your folder',
  createNewFolder: 'Create new folder',
  viewOnlyAccessTitle: 'You have view-only access to the data.',
  viewOnlyAccessDescription:
    'This is read-only. You can only view its contents.',
  theFolderIsEmpty: 'The folder is empty',
  uploadAndImportNewFiles: 'Upload and Import new folder/ files',
  folderEmptyDescription: "This folder is empty. There's nothing to display.",
  dropFilesOrFolders: 'Drop your files or folders here',
  uploadSupportedFormatsDescription:
    'Upload your documents or folders in the following supported formats and limits!',
  nameCollection: 'Name collection',
  webLinks: 'Web Links',
  addedCountOf5: '{{count}}/5 Added',
  addWebLink: 'Add web link',
  uploadingEllipsis: 'Uploading...',

  documentsUploadedSuccessfully: '{{count}} documents uploaded successfully.',
  documentUploadFailed: '{{count}} document upload has failed.',
  uploadingFilesCount: 'Uploading {{count}} files...',
  scanningFilesCount: 'Reading {{processed}} of {{total}} files...',
  preparingFolderFiles: 'Preparing your files...',
  uploadedFileSingular: 'Uploaded {{count}} file',
  uploadedFilePlural: 'Uploaded {{count}} files',
  filesUploadedOfSingular: '{{successCount}} of {{fileCount}} file uploaded',
  filesUploadedOfPlural: '{{successCount}} of {{fileCount}} files uploaded',
  uploadingFileSingular: 'Uploading {{count}} file',
  uploadingFilePlural: 'Uploading {{count}} files',
  retryFailedDocument: 'Retry the failed document',
  abortUpload: 'Cancel the uploading?',
  abortUploadDescription:
    'Leaving this page will cancel your ongoing uploads. Are you sure you want to continue?',
  yesAbortAll: 'Yes, Cancel',
  noKeepUploading: 'No, Keep Uploading',
  supportedDocFormats: 'PDF, PPT, PPTX, DOC, DOCX, ODS, ODP, ODT, RTF (300 MB)',
  supportedMediaFormats: 'MP3, MP4, MPGA, MPEG, WAV, M4A, WEBM (400 MB)',
  supportedSpreadsheetFormats: 'XLS, XLSX, CSV, TXT (50 MB)',
  itemSelected: '{{count}} item selected',
  itemsSelected: '{{count}} items selected',
  selectAll: 'Select All',
  userOrUserGroups: 'User or User groups',
  searchByNameOrEmail: 'Search by name or email...',
  searchByExistingNameOrEmail: 'Search existing user name or email...',
  loadingMore: 'Loading more...',
  noMoreItemsToLoad: 'No more items to load',
  unsupportedFilesLabel: 'Unsupported Files',
  modifiedSyncBy: 'Modified/Sync by',
  modifiedOrSyncBy: 'Modified by or Sync by',
  modifiedSyncOn: 'Modified/Sync on',
  modifiedOrSyncOnTime: 'Modified on or Sync on time',
  statusOfResource: 'Status of resource',

  // Data Library Dialogs
  areYouSure: 'Are you sure?',
  actionCannotBeUndone:
    'This action cannot be undone. All current progress will be lost.',
  aiOverview: 'AI Overview',
  summaryNotAvailable: 'Summary is not available for this resource.',
  undetected: 'Undetected',
  resourceNameLabel: '{{resource}} name',
  nameYourResource: 'Name your {{resource}}',
  remove: 'Remove',
  searchSharedUsers: 'Search shared users...',
  whoHasAccess: 'Who has access',
  noMatchesFound: 'No matches found',
  noUsersHaveAccess: 'No users have access',
  permissionSettings: 'Permission Settings',
  selectDestinationFolder: 'Select Destination Folder',
  accessOnly: 'Access only',
  pastLocation: 'Past location: {{folder}} folder in {{workspace}} workspace',
  movePermissionTitle: 'Move permission',
  movePermissionDescription:
    'You can only move your files to the workspaces/ folders where you have the permission to move!',
  noResourceFoundHere: 'No Resource found here',
  importFromExternalApps: 'Import from external apps',
  integrationNotFound: 'Integration type "{{type}}" not found.',
  navigateSharePoint:
    'Navigate to the target folder or library to begin importing.',
  navigateOneDrive:
    'Navigate your OneDrive and select the target folder or file to import.',
  navigateConfluence: 'Navigate your Confluence spaces and pages.',
  failedToLoadSharePoint: 'Failed to load SharePoint data.',
  failedToLoadOneDrive: 'Failed to load OneDrive data.',
  failedToLoadConfluence: 'Failed to load Confluence data.',
  navigateGoogleDrive:
    'Navigate your Google Drive and select the target folder or file to import.',
  failedToLoadGoogleDrive: 'Failed to load Google Drive data.',
  googleDriveMyDrive: 'My Drive',
  googleDriveSharedDrives: 'Shared Drives',
  openInGoogleDrive: 'Open in Google Drive',
  noItemsFound: 'No items found.',
  noSpacesOrPagesFound: 'No spaces or pages found.',
  mySpaces: 'My Spaces',
  sharedSpaces: 'Shared Spaces',
  myDrive: 'My Drive',
  sharedWithMeLabel: 'Shared with Me',
  open: 'Open',
  viewer: 'Viewer',
  shareResourceTitle: 'Share - {{name}}',

  // Data Library Header, Hooks & Utils
  viewOnlyAccess: 'View only',
  noPermissionToCreateResources:
    'You do not have permission to create resources.',
  clearFilter: 'Clear Filter',
  inProgressStatus: 'In Progress',
  retryingStatus: 'Retrying',
  unsupportedStatus: 'Unsupported',
  openInLabel: 'Open In',
  synced: 'Synced',
  workspacesSecuredDescription:
    'Use secured and access-controlled workspaces for private collaboration.',
  myWorkspaceDescription: 'Content in My Workspace is only accessible to you.',
  publicWorkspaceDescription: 'Content in Public is shared with all users.',
  entityActionSuccess: '{{entity}} {{action}} successfully.',
  failedToActionEntity: 'Failed to {{action}} {{entity}}.',
  cannotImportIntoPublicWorkspace: 'Cannot import into a Public Workspace',
  cannotImportIntoPrivateWorkspace: 'Cannot import into a Private Workspace',
  noExternalIntegrations:
    "You can't import data from the third-party sources until you configure them from the settings.",
  keepExistingRolesOnSubItems: 'Keep existing roles on sub-items',
  applyToAllSubFoldersAndFiles: 'Apply to all sub-folders and files',
  applyToFilesOnly: 'Apply to files only',
  resourceNameIsRequired: 'Resource name is required',
  cannotAssignRegularUserAsController:
    'Can not assign regular user as controller of workspace',
  unauthorizedUsersNotAllowedAsController:
    'Unauthorized users are not allowed as controller of workspace',
  selectAtLeastOneUserOrGroup: 'Please select at least one user or group',
  pleaseSelectRole: 'Please select a role',
  pleaseSelectAssignmentStrategy: 'Please select an assignment strategy',
  collectionNameIsRequired: 'Collection name is required',
  collectionNameTooShort: 'Collection name is too short',
  invalidUrl: 'Invalid URL',
  atLeastOneLinkRequired: 'At least one valid link is required',
  sharedTab: 'Shared',
  updated: 'updated',
  created: 'created',
  modified: 'Modified',
  maxLimitExceeded: 'You have exceeded the maximum limit.',
  disableGoogleSSOToEnableThisOption:
    'Disable Google SSO to enable this option',
  disableMicrosoftSSOToEnableThisOption:
    'Disable Microsoft SSO to enable this option',
  resourceDeletionFailed: 'Failed to delete resource.',
  resourceDeleteSuccess: 'Resource deleted successfully.',
  cannotRemoveYourself: 'You cannot remove yourself from the shared with list',
  googleDriveDeepIntegrationStep1:
    'From the Left Navigation Menu. Go to APIs and Services → Enabled APIs and Services.',
  googleDriveDeepIntegrationStep2: 'Select ‘Enable APIs and Services’',
  googleDriveDeepIntegrationStep3:
    'Search ‘Google Drive API’ under Google Workspace Services.',
  googleDriveDeepIntegrationStep4: 'Select Google Drive API → Click ‘Enable’',
  googleDriveDeepIntegrationStepHeading:
    'Steps for the Google Drive Deep Integration - Admin Settings as follow:',
  adTokenExpired:
    'Connection to chat stream lost. Reloading the page in {{seconds}} seconds…',
  dataHostedByThirdPartiesComesWithSharingRestrictions:
    'Data hosted by third parties comes with sharing restrictions!',
  contentVisibilityDependsEntirelyOnItsSourcePermissionsExceptWhenItIsInPublicOrMyWorkspace:
    'Content visibility depends entirely on its source permissions, except when it\'s in "Public" or "My Workspace."',
  retry: 'Retry',
  retryAll: 'Retry all',
  cancelAll: 'Cancel all',
  syncingDescription:
    "Hang tight! We're syncing your data from your third-party provider.",
  syncingTitle: 'Your data is syncing right now.',
  syncFailedTitle: 'Data syncing failed.',
  syncFailedDescription:
    'Data syncing failed! Try syncing again with the import button.',
  generateExternalApiEndpoint: 'Get External API Endpoints',
  knowledge_chat_endpoint: 'Knowledge Chat',
  assistant_chat_endpoint: 'Assistant Chat',
  model_list_endpoint: 'Model List ',
  assistant_list_endpoint: 'Assistant List',
  file_download_endpoint: 'File Download',
  hostedInRegionByProvider: 'Hosted in the {{region}} by {{provider}}',
  hostedGloballyByProvider: 'Hosted globally by {{provider}}',
  model_Llama_3_1_405B_description:
    'Largest open-weights LLM. Best for multilingual tasks, RAG pipelines, and enterprise on-prem deployments at scale.',
  model_Llama_3_2_90B_description:
    'Efficient multimodal open-weights model with image understanding. Best for vision tasks and self-hosted inference.',
  model_deepseek_v3_description:
    "Google's most advanced reasoning model with 1M context and 2× ARC-AGI-2 improvement over Gemini 3 Pro. Best for complex research, agentic coding, and multimodal tasks.",
  model_gpt_5_description:
    "OpenAI's unified flagship. Best for complex reasoning, coding, and agentic knowledge work across 40+ professional domains",
  model_minio1_description:
    "Lightweight reasoning model. Best for fast, cost-efficient analytical tasks where full o-series compute isn't needed.",
  model_Mistral_large_description:
    'Strong multilingual model with EU data residency alignment. Best for European enterprise use cases, coding, and compliance-sensitive deployments.',
  model_gemini_3_1_pro_description:
    "Google's most advanced reasoning model with 1M context and 2× ARC-AGI-2 improvement over Gemini 3 Pro. Best for complex research, agentic coding, and multimodal tasks.",
  model_gemini_3_pro_preview_description:
    'Better thinking, improved token efficiency, and a more grounded, factually consistent experience.',
  model_gpt_5_2_description:
    'Strong all-purpose model with Instant, Thinking, and Pro modes. Best for general day-to-day knowledge work and multi-step agentic tasks.',
  model_gpt_5_3_chat_description:
    'Coding-focused successor built around autonomous software engineering. Best for professional developers and long-running coding agents.',
  model_claude_opus_4_6_description:
    "Anthropic's most capable model. Best for nuanced long-form reasoning, research synthesis, and deep document analysis.",
  model_claude_sonnet_4_6_description:
    'Fast and highly capable all-rounder. Best for coding, document analysis, and structured business tasks with high throughput.',
  model_gemini_2_0_flash_description:
    'Extremely fast and cost-efficient. Best for high-volume summarisation, Q&A, and latency-sensitive applications.',
  model_gemini_2_5_flash_description:
    'Faster and more accurate successor to Flash 2.0. Best for multimodal speed tasks with longer context requirements.',
  model_gpt_4o_description:
    'Fast multimodal model with native voice and vision. Best for real-time, conversational, and everyday multimodal use cases.',
  model_gpt_5_1_description:
    'Refined GPT-5 with automatic routing between Instant and Thinking modes. Best for personalised, controllable everyday tasks.',
  model_o1_description:
    'Deep reasoning model with explicit chain-of-thought. Best for mathematics, logic, and graduate-level STEM problems.',
  model_gpt_4_1_description:
    'Long-context specialist with 1M token window. Best for large codebases, legal documents, and multi-document RAG pipelines.',
  model_gpt_5_4_description:
    'Frontier model combining reasoning, coding, and agentic workflows. Best for complex, production-grade tasks requiring low hallucination.',
  model_gpt_4_32k_description:
    'GPT-4 with extended 32K context window. Best for long-document tasks requiring GPT-4 quality without newer model access.',
  model_Llama_3_70B_Instruct_description:
    'Previous-generation 70B instruction model. Best for general-purpose tasks in self-hosted environments on tighter budgets.',
  model_Mistral_large_02_description:
    'Updated Mistral Large with improved instruction following and coding performance. Best for European enterprise workloads requiring stronger code generation.',
  model_cohere_description:
    'Purpose-built for enterprise RAG and tool use. Best for retrieval-augmented generation, grounded Q&A, and structured data workflows.',
  model_Llama_3_1_8b_Instruct_description:
    'Lightweight open-weights model. Best for on-device or low-latency inference where compute resources are constrained.',
  model_Llama_3_1_70B_Instruct_description:
    'Mid-size open-weights model. Best for instruction-following, summarisation, and self-hosted deployments with balanced cost and quality.',
  model_gpt_3_5_turbo_description:
    'Fast and low-cost general-purpose model. Best for high-volume, latency-sensitive tasks where output quality is secondary.',
  model_gpt_3_5_turbo_16k_description:
    'GPT-3.5 Turbo with extended context window. Best for simple long-document tasks at minimal cost.',
  model_gpt_4_description:
    'Original GPT-4 release. Best for general reasoning and language tasks; largely superseded by newer models.',
  model_gpt_4_turbo_description:
    'Faster, cheaper GPT-4 variant with 128K context. Best for cost-sensitive tasks requiring GPT-4 quality.',
  model_grok_3_description:
    "xAI's flagship model with real-time X (Twitter) data access. Best for STEM reasoning, live trend analysis, and social intelligence tasks.",
  model_minio4_description:
    "Lightweight reasoning model. Best for fast, cost-efficient analytical tasks where full o-series compute isn't needed.",
  model_gpt_5_6_luna_description:
    'Fast, low-cost tier built for high-volume work. Best for latency-sensitive, budget-conscious tasks like classification and simple lookups.',
  model_gpt_5_6_terra_description:
    'Balanced everyday model with last-gen flagship-level performance at roughly half the price. Best for scoped implementation, first-pass review, and general production workloads.',
  model_gpt_5_6_sol_description:
    'Flagship reasoning model with OpenAI’s most robust safety stack to date. Best for high-stakes, multi-step problems where you need the highest capability ceiling.',
  model_claude_opus_5_description:
    'Strong flagship model that comes close to top-tier intelligence at half the cost. Best for demanding coding, knowledge work, and long-horizon agentic tasks.',
  model_claude_opus_4_7_description:
    'Flagship model with stronger software engineering, higher-resolution vision, and self-verification on long-running tasks. Best for complex coding work and long-horizon autonomous workflows.',
  model_claude_opus_4_8_description:
    'Sharper judgment and improved honesty, with dynamic workflows for large-scale codebase migrations. Best for agentic coding, reasoning, and knowledge work at scale.',
  model_gemini_3_5_flash_description:
    "Google's most intelligent Flash model, delivering frontier-level performance in agentic execution, coding, and long-horizon tasks at scale. Best for iterative coding, multi-step tool use, and rapid agentic loops.",

  //Notifications
  notifications: 'Notifications',
  closeNotifications: 'Close notifications',
  markAllAsRead: 'Mark all as read',
  unread: 'Unread',
  allCaughtUp: "You're all caught up",
  allCaughtUpDescription:
    "That's all your notifications from last {{NOTIFICATION_RETENTION_DAYS}} days",
  markAsRead: 'Mark as read',
  markAsUnread: 'Mark as unread',
  mute: 'Mute Notifications',
  dismiss: 'Dismiss',
  viewChanges: 'View Changes',
  retentionDays: 'Retention: {{NOTIFICATION_RETENTION_DAYS}} days',
  okay: 'Okay',
  category: 'Category',
  inApp: 'In app',
  mandatory: 'Mandatory',
  mandatoryDescription:
    "Your team can't enable or disable this notification category",
  optional: 'Optional',
  optionalDescription:
    'Your team can enable or disable this notification category',
  notificationsDescription:
    "Choose which notifications you'd like to receive from Empower GPT",
  organizationNotifications: 'Organization Notifications',
  organizationNotificationsDescription:
    'Manage notification preferences for your organization',
  notificationFetchError: 'Failed to fetch notifications',
  notificationMarkAllReadError: 'Failed to mark all notifications as read',
  notificationReadStatusUpdateError:
    'Failed to update notification read status',
  notificationDismissError: 'Failed to dismiss notification',
  notificationDismissAllError: 'Failed to dismiss all notifications',
  notificationPreferencesFetchError: 'Failed to fetch notification preferences',
  notificationPreferencesUpdateError:
    'Failed to update notification preferences',
  notificationMandatoryCategoryError:
    'This notification category is mandatory and cannot be changed',
  // Notification categories
  notifCatDocumentProcessing: 'Document Processing',
  notifCatContentSharing: 'Content Sharing',
  notifCatAssistantUpdates: 'Assistant Updates',
  notifCatWorkspaceChanges: 'Workspace Changes',
  notifCatConnectorSyncStatus: 'Connector Sync Status',
  notifCatSystemAnnouncements: 'System Announcements',
  notifCatWorkflowEvents: 'Workflow Events',
  notifCatTenantLifecycle: 'Tenant Lifecycle',
  notifCatSubscriptionAndBilling: 'Subscription and Billing',
  notifCatUserAndRoles: 'User and Roles',
  notifCatDocAnalyst: 'Doc Analyst',
  // Notification category descriptions
  notifCatDescDocumentProcessing:
    'Processing complete, failures, batch updates, error reports, and performance metrics.',
  notifCatDescContentSharing:
    'Documents, folders, or collections added, modified, deleted, or shared.',
  notifCatDescAssistantUpdates:
    'Shared assistants, updates to favorites, collaboration invites, and version changes.',
  notifCatDescWorkspaceChanges:
    'Membership updates, role changes, new invitations, and permission adjustments.',
  notifCatDescConnectorSyncStatus:
    'SharePoint, OneDrive, Google Drive syncs, access changes, and storage alerts.',
  notifCatDescSystemAnnouncements:
    'New AI models, maintenance windows, feature rollouts, and system upgrades.',
  notifCatDescWorkflowEvents:
    'Workflow runs, failures, approvals, rejections, and status updates.',
  notifCatDescTenantLifecycle:
    'Organization and workspace creation, deletion, permission changes, and access requests.',
  notifCatDescSubscriptionAndBilling:
    'Subscription updates, billing alerts, plan changes, renewals, and usage limit notifications.',
  notifCatDescUserAndRoles:
    'Notifications related to user account changes, role updates.',
  notifCatDescDocAnalyst:
    'Analysis complete, failures, batch updates, error reports, and performance metrics.',
  // Notification subcategories
  notifSubCatDocumentProcessed: 'Document processed',
  notifSubCatDocumentFailed: 'Document failed',
  notifSubCatBatchUploadComplete: 'Batch upload complete',
  notifSubCatDocumentShared: 'Document shared',
  notifSubCatAccessChanged: 'Access changed',
  notifSubCatConnectorSyncComplete: 'Connector sync complete',
  notifSubCatConnectorSyncFailed: 'Connector sync failed',
  notifSubCatTenantSettingChanged: 'Tenant setting changed',
  notifSubCatSubscriptionUpdated: 'Subscription updated',
  notifSubCatSubscriptionExpiryReminder: 'Subscription Expiry Reminder',
  notifSubCatAccountTypeChanged: 'Account type changed',
  notifSubCatUsageLimitWarning: 'Usage limit warning',
  notifSubCatSystemMaintenance: 'System maintenance',
  notifSubCatModelAdded: 'Model added',
  notifSubCatModelDeprecated: 'Model deprecated',
  notifSubCatWeeklyDigest: 'Weekly digest',
  notifSubCatNewTenantCreated: 'New tenant created',
  notifSubCatTenantDeactivationWarn: 'Tenant deactivation warn',
  notifSubCatAssistantShared: 'Assistant Shared',
  notifSubCatAssistantUpdated: 'Assistant Updated',
  notifSubCatAssistantRemoved: 'Assistant Removed',
  notifSubCatAnalysisCompleted: 'Analysis Completed',
  notifSubCatAnalysisPartial: 'Analysis Partial',
  notifSubCatAnalysisFailed: 'Analysis Failed',
  notifSubCatDatasetModified: 'Dataset Modified',
  notifSubCatWorkspaceDeleted: 'Workspace Deleted',
  notifSubCatWorkspaceCreated: 'Workspace Created',
  notifSubCatWorkspaceAssigned: 'Workspace Assigned',
  notifSubCatRoleChanged: 'Role Changed',
  notifSubCatUserAdded: 'User Added',
  notifSubCatUserRemoved: 'User Removed',
  notifSubCatWorkflowCompleted: 'Workflow Completed',
  notifSubCatWorkflowFailed: 'Workflow Failed',
  notifSubCatApprovalRequired: 'Approval Required',
  notifSubCatApprovalReminder: 'Approval Reminder',

  // Notification Subcategory Templates
  notifSummaryDocumentProcessed:
    '{{filename}} has been processed successfully.',
  notifSubCatDescDocumentProcessed:
    'Document {{filename}} has been processed successfully.',

  notifSummaryDocumentFailed: '{{filename}} failed to process. {{reason}}.',
  notifSubCatDescDocumentFailed:
    'Document {{filename}} failed to process. {{reason}}.',

  notifSummaryBatchUploadComplete:
    'Batch complete: {{X}} of {{Y}} documents processed, {{Z}} failed.',
  notifSubCatDescBatchUploadComplete:
    'Batch upload complete: {{X}} of {{Y}} documents processed successfully, {{Z}} failed.',

  notifSummaryDocumentShared:
    '{{sharer_name}} shared {{document_name}} with you.',
  notifSubCatDescDocumentShared:
    '{{sharer_name}} shared {{document_name}} with you.',

  notifSummaryAccessChanged:
    'Your access to {{document_name}} has been revoked to {{role}}.',
  notifSubCatDescAccessChanged:
    'User access of document {{document_name}} was revoked to {{role}}.',

  notifSummaryConnectorSyncComplete:
    '{{connector_name}} sync complete: {{X}} new, {{Y}} updated, {{Z}} removed.',
  notifSubCatDescConnectorSyncComplete:
    'Sync complete for {{connector_name}}: {{X}} new documents, {{Y}} updated, {{Z}} removed.',

  notifSummaryConnectorSyncFailed:
    '{{connector_name}} sync failed: {{error_summary}}.',
  notifSubCatDescConnectorSyncFailed:
    '{{connector_name}} sync failed: {{error_summary}}.',

  notifSummaryTenantSettingChanged:
    'Settings for {{org_name}} have been updated.',
  notifSubCatDescTenantSettingChanged:
    'Subscription plan for {{org_name}} has been updated to {{plan_name}}. New limits: {{summary}}.',

  notifSummarySubscriptionUpdated:
    'Subscription for {{org_name}} updated to {{plan_name}}.',
  notifSubCatDescSubscriptionUpdated:
    'Subscription plan for {{org_name}} has been updated to {{plan_name}}. New limits: {{summary}}.',

  notifSummaryAccountTypeChanged:
    'Your role has been changed from {{prev_role}} to {{new_role}}.',
  notifSubCatDescAccountTypeChanged:
    'User account type / role was changed from {{prev_role}} to {{new_role}}.',

  notifSummarySubscriptionExpiryReminder:
    'Your subscription expires on {{date}}. Renew to avoid interruption.',
  notifSubCatDescSubscriptionExpiryReminder:
    'Your EmpowerGPT subscription for {{org_name}} expires on {{date}}. Please renew to avoid service interruption.',

  notifSummaryUsageLimitWarning:
    'You are approaching or exceeding usage limits for {{exceed_limit}}.',
  notifSubCatDescUsageLimitWarning:
    'Exceeding usage limits for {{exceed_limit}}.',

  notifSummarySystemMaintenance:
    'Scheduled maintenance planned. Service may be temporarily unavailable.',
  notifSubCatDescSystemMaintenance: 'Scheduled maintenance or platform update.',

  notifSummaryModelAdded: 'AI model {{model_name}} is now available.',
  notifSubCatDescModelAdded: 'AI model {{model_name}} has been added.',

  notifSummaryModelDeprecated: 'AI model {{model_name}} has been deprecated.',
  notifSubCatDescModelDeprecated:
    'AI model {{model_name}} has been deprecated.',

  notifSummaryWeeklyDigest: 'Your weekly usage digest is ready.',
  notifSubCatDescWeeklyDigest: 'Here is the weekly digest {{weekly_usage}}.',

  notifSummaryNewTenantCreated: 'Organization {{org_name}} has been created.',
  notifSubCatDescNewTenantCreated: 'New organization {{org_name}} is created.',

  notifSummaryTenantDeactivationWarn:
    'Your organization subscription deactivates in 1 week.',
  notifSubCatDescTenantDeactivationWarn:
    'Tenant subscription is 1 week from deactivation.',

  notifSummaryAssistantShared:
    '{{sharer_name}} shared the assistant {{document_name}} with you.',
  notifSubCatDescAssistantShared:
    '{{sharer_name}} shared the assistant {{document_name}} with you.',

  notifSummaryAssistantUpdated:
    'Assistant {{name}} has been updated by {{editor_name}}.',
  notifSubCatDescAssistantUpdated:
    'Assistant {{name}} has been updated by {{editor_name}}.',

  notifSummaryAssistantRemoved: 'Assistant {{name}} has been removed.',
  notifSubCatDescAssistantRemoved: 'Assistant {{name}} has been removed.',

  notifSummaryAnalysisCompleted:
    '{{analysis_title}} completed — {{X}} of {{Y}} questions answered.',
  notifSubCatDescAnalysisCompleted:
    'Analysis {{analysis_title}} completed — {{X}} of {{Y}} questions answered.',

  notifSummaryAnalysisPartial:
    '{{analysis_title}} partially completed — {{Z}} questions unanswered.',
  notifSubCatDescAnalysisPartial:
    'Analysis {{analysis_title}} partially completed — {{Z}} questions unanswered.',

  notifSummaryAnalysisFailed: '{{analysis_title}} failed: {{reason}}.',
  notifSubCatDescAnalysisFailed:
    'Analysis {{analysis_title}} failed: {{reason}}.',

  notifSummaryDatasetModified:
    'Dataset {{name}} was modified — analysis {{title}} may be affected.',
  notifSubCatDescDatasetModified:
    'Dataset {{name}} has been modified — analysis {{title}} may be affected.',

  notifSummaryWorkspaceDeleted:
    'Workspace {{name}} and all its contents have been permanently deleted.',
  notifSubCatDescWorkspaceDeleted:
    'Workspace {{name}} and all its contents have been permanently deleted.',

  notifSummaryWorkspaceCreated:
    '{{creator_name}} created workspace {{workspace_name}}.',
  notifSubCatDescWorkspaceCreated:
    '{{creator_name}} created workspace {{workspace_name}}.',

  notifSummaryWorkspaceAssigned:
    'You have been added to {{workspace_name}} as {{role}}.',
  notifSubCatDescWorkspaceAssigned:
    'You have been added to new workspace {{workspace_name}} as {{role}}.',

  notifSummaryRoleChanged:
    'Your role in {{workspace_name}} has been changed to {{new_role}}.',
  notifSubCatDescRoleChanged:
    'Your role in workspace {{workspace_name}} has been changed to {{new_role}}.',

  notifSummaryUserAdded:
    'You have been added to {{workspace_name}} as {{role}}.',
  notifSubCatDescUserAdded:
    'You have been added to workspace {{workspace_name}} as {{role}}.',

  notifSummaryUserRemoved:
    'Your access to {{workspace_name}} has been revoked.',
  notifSubCatDescUserRemoved:
    'Your access to workspace {{workspace_name}} has been revoked.',

  notifSummaryWorkflowCompleted:
    'Workflow {{workspace_name}} completed: {{status_summary}}.',
  notifSubCatDescWorkflowCompleted:
    'Workflow completed with {{status_summary}}.',

  notifSummaryWorkflowFailed:
    'Workflow {{workspace_name}} failed at step {{N}}: {{error_summary}}.',
  notifSubCatDescWorkflowFailed:
    'Workflow {{workspace_name}} failed at step {{N}}: {{error_summary}}.',

  notifSummaryApprovalRequired:
    'Workflow {{workspace_name}} requires your approval at step {{step_name}}.',
  notifSubCatDescApprovalRequired:
    'Workflow {{workspace_name}} requires your approval at step {{step_name}}.',

  notifSummaryApprovalReminder:
    'Pending approval request for {{workflow_name}} requires action.',
  notifSubCatDescApprovalReminder: 'Approval request reminder or escalation.',

  // Workflows
  generateWithAiComingSoon: 'Generate with AI (Coming Soon)',
  createWithAi: 'Create(Coming Soon)',
  addCondition: 'Add Condition',
  ifElseConditionTitle: 'IF/Else Condition',
  branchExecution: 'Branch Execution',
  conditionsLabel: 'Conditions',
  executeThisBranchIf: 'Execute this branch if',
  elseIf: 'Else if',
  removeCondition: 'Remove condition',
  removingConditionsDisabled: 'Removing conditions is disabled',
  fieldLabel: 'Field',
  operatorLabel: 'Operator',
  matchText: 'Match Text',
  opEquals: 'Equals',
  opNotEquals: 'Not Equals',
  opContains: 'Contains',
  opLessThan: 'Less than',
  opLessThanOrEqual: 'Less than or equal',
  opGreaterThan: 'Greater than',
  opGreaterThanOrEqual: 'Greater than or equal',
  firstMatchWinsSequential: 'First Match Wins (Sequential)',
  allowMultipleConditions: 'Allow Multiple Conditions',
  wfIfElseLabel: 'IF/ELSE',
  wfNoBranchesConfigured: 'No branches configured',
  wfBranchCount: '{{count}} branch(es)',
  wfIfOneTitle: 'IF 1',
  wfElseIfNTitle: 'ELSE IF {{number}}',
  wfElseRowTitle: 'ELSE',
  wfElseSummary: 'Else',
  wfDetailsRequiredFor: 'Details required for {{title}}',
  wfErrorPathBadge: 'Error Path',
  wfAddIfElse: 'Add IF/ELSE',
  stopTheWorkflow: 'Stop the Workflow',
  continueUsingErrorMessage: 'Continue using the Error Message as output',
  continueOnNewErrorPath: 'Continue on the new Error Path',
  regenerateNoun: 'Regenerate {{noun}}?',
  regenerateWarning:
    'The current value will be invalidated. Anything using it will stop working until updated. This action cannot be undone.',
  regeneratingEllipsis: 'Regenerating…',
  secretNoun: 'Secret',
  passwordNoun: 'Password',
  workflowSaveFailed: 'Workflow save failed',
  wfStartOrder: 'Start order',
  wfOrderPlaced: 'Order placed',
  wfPreparingOrder: 'Preparing order',
  wfCancelOrder: 'Cancel order',
  wfOutForDelivery: 'Out for delivery',
  wfOrderDelivered: 'Order delivered',
  wfUntitledWorkflow: 'Untitled Workflow',
  wfCreatedSuccessfully: 'Workflow created successfully',
  wfCreatedButEditorFailed:
    'Workflow created, but the editor could not be opened. Refresh the list if needed.',
  wfCreateFailed: 'Failed to create workflow',
  wfNameAlreadyExists: 'A workflow with this name already exists.',
  wfInvalidSearchQuery:
    'The email search query is invalid. Check quotes and parentheses, and use only the supported operators.',
  wfCreditLimitExceeded:
    'Workflow run stopped, your monthly credits limit is reached.',
  wfRunsLimitExceeded: 'Monthly limit for workflow runs is reached.',
  wfWorkflows: 'Workflows',
  wfHubSubtitle:
    'Build AI-powered workflows that automate complex tasks, orchestrate agents and tools, and turn business processes into intelligent, repeatable operations.',
  wfNoWorkflowsMatchSearch: 'No workflows match your search.',
  wfNoWorkflowsToShow: 'No workflows to show.',
  wfNoWorkflowsByStatus: 'No {{statusFilter}} workflows to show.',
  wfLoadFailed: 'Failed to load workflows. Please try again.',
  wfBlocks: 'Blocks',
  wfCost: 'Cost',
  wfRuns: 'Runs',
  wfNode: 'Node',
  wfLoopStart: 'Loop start',
  wfBlockType: 'Block Type',
  wfFormFields: 'Form Fields',
  wfUserEndCustomization: 'User end customization',
  wfValidatingFields: 'Validating fields',
  wfButtonLabel: 'Button Label',
  wfSubmit: 'Submit',
  wfAdd: 'Add',
  wfRequired: 'Required',
  wfAllowMultipleUploads: 'Allow multiple uploads',
  wfArrayProvided: 'Array provided',
  wfPreviousIteration: 'Previous iteration',
  wfNextIteration: 'Next iteration',
  wfWriteCode: 'Write code',
  wfCodeIsWritten: 'Code is written.',
  wfPdfProcessor: 'PDF Processor',
  wfProcessing: 'Processing',
  wfProcessingItemOf: 'Processing item {{current}} of {{total}}',
  wfProcessingItem: 'Processing item {{current}}',
  wfExtractingTextTables: 'Extracting text/tables',
  wfConstructingPrompt: 'Constructing prompt',
  wfSpinningUpSandbox: 'Spinning up sandbox',
  wfRunningScript: 'Running script',
  wfWorkflowComplete: 'Workflow complete',
  wfWritePrompt: 'Write prompt',
  wfPromptWritten: 'Prompt is written.',
  wfWriteOutputValue: 'Write output value.',
  wfOutputValueWritten: 'Output value is written.',
  wfTemplateFieldPlaceholder:
    'Write text or use {{ }} to reference data from previous nodes',
  wfOutputNodeHint:
    'This node stores a value as an output of the workflow run. You can have multiple output nodes, each storing a value under its unique slug.',
  wfLoopEnd: 'Loop End',
  wfCloses: 'Closes:',
  wfReplace: 'Replace',
  wfDeactivate: 'Deactivate',
  wfAddStructuredOutput: 'Add structured output',
  wfThinking: 'Thinking',
  wfFieldDescriptionPlaceholder: 'Describe the purpose of this field.',
  wfLoop: 'Loop',
  wfArrayToLoopOver: 'Array to loop over',
  wfArrayToLoopOverPlaceholder:
    'Type text or use {{  }} to reference data from previous nodes',
  wfLoopVariable: 'Loop variable',
  wfCollectBlockOutputs: 'Collect block outputs',
  wfMaxIterations: 'Max iterations',
  wfHardcodedProcessorNoEditableFields:
    'Hardcoded processor with no editable fields.',
  wfHardcodedNoEditableFields: 'Hardcoded with no editable fields.',
  wfCode: 'Code',
  wfPythonCodePlaceholder: 'code',
  wfErrorHandling: 'Error handling',
  wfOnError: 'On error',
  wfStopWorkflow: 'Stop workflow',
  wfContinueUsingErrorOutput: 'Continue using error output',
  wfOutputNodeDescription:
    'This node stores a value as the output of the workflow run. You can have multiple output nodes, each storing a value under its unique slug.',
  wfOutputValue: 'Output value',
  wfOutputUrlPlaceholder: 'https://... or workspace path',
  wfAgent: 'Agent',
  wfSelectExisting: 'Select existing',
  wfModelRequired: 'Model*',
  wfPromptRequired: 'Prompt*',
  wfAddTool: 'Add tool',
  wfTools: 'Tools',
  wfKnowledge: 'Knowledge',
  wfAddKnowledge: 'Add knowledge',
  wfSelectFromNodes: 'Select from Nodes',
  wfStructuredOutput: 'Structured output',
  wfAddStructuredField: 'Add structured field',
  wfRemoveField: 'Remove field',
  wfMaxSteps: 'Max steps',
  wfMaxStepsLimitExceeded: 'Maximum allowed value is 20',
  wfNoCodeOutputConfigured: '*No code output configured.*',
  wfCreateNewWorkflow: 'Create new Workflow',
  wfGiveWorkflowDescriptiveName:
    "Give your workflow a clear name and description so it's easy to identify and reuse later.",
  wfEnter: 'Enter',
  wfCreating: 'Creating…',
  wfProvideWorkflowName: 'Provide a name of workflow',
  wfDescriptionOptional: 'Description (optional)',
  wfDescribeWorkflowPurpose: 'Describe what this workflow is designed for.',
  wfChooseFirstNode: 'Choose first node',
  wfTrigger: 'Trigger',
  wfTriggerSubtitle: 'Start with a form / upload trigger',
  wfWebhookSubtitle: 'Start with an external webhook',
  wfIntegrationTrigger: 'Integration Trigger',
  wfIntegrationTriggerSubtitle: 'Start with an external integration event',
  wfWebhookBlockDesc: 'Trigger from external apps or APIs',
  wfScheduledBlock: 'Scheduled',
  wfScheduledBlockDesc: 'Run automatically on a schedule',
  wfSchedule: 'Schedule',
  wfScheduleTypeLabel: 'Schedule for',
  wfScheduleTypeCustom: 'Custom',
  wfScheduleTypeEvery1Hour: 'Every 1 hour',
  wfScheduleTypeEvery2Hours: 'Every 2 hours',
  wfScheduleTypeEvery6Hours: 'Every 6 hours',
  wfScheduleTypeEvery12Hours: 'Every 12 hours',
  wfScheduleTypeDailyMidnight: 'Daily at midnight',
  wfScheduleTypeDaily6Am: 'Daily at 6:00 AM',
  wfScheduleTypeDaily9Am: 'Daily at 9:00 AM',
  wfScheduleTypeEveryMonday: 'Every Monday',
  wfScheduleTypeEverySunday: 'Every Sunday',
  wfScheduleTypeMonthly1st: 'Monthly on 1st',
  wfRunEvery: 'Run Every',
  wfDecreaseInterval: 'Decrease interval',
  wfPreviousMonth: 'Previous month',
  wfNextMonth: 'Next month',
  wfInvalidTypedDate: 'Invalid date. Use a format like {{example}}',
  wfIncreaseInterval: 'Increase interval',
  wfIntervalUnitMinute: 'Minute/s',
  wfIntervalUnitHour: 'Hour/s',
  wfIntervalUnitDay: 'Day/s',
  wfIntervalUnitWeek: 'Week/s',
  wfIntervalUnitMonth: 'Month/s',
  wfRunEverySummary: 'Every {{interval}} {{unit}}',
  wfTimezone: 'Timezone',
  wfSearchTimezone: 'Search timezone',
  wfNoTimezoneMatchSearch: 'No timezone matches your search.',
  wfStartsAt: 'Starts at',
  wfEndsAt: 'Ends at',
  wfEndsAtNever: 'Never',
  wfEndsAtOnDate: 'Set a date & time',
  wfPreview: 'Preview',
  wfPreviewRunNumber: '#{{number}}',
  wfNoUpcomingRuns: 'No upcoming runs',
  wfSelectDateTime: 'Select date & time',
  wfTest: 'Test',
  wfManualTrigger: 'Manual',
  wfManualTriggerDesc: 'Start workflow manually',
  wfFormBlock: 'Form',
  wfFormBlockDesc: 'Trigger from form submission',
  wfIntegrationBlock: 'Integration',
  wfIntegrationBlockDesc: 'Connect to external apps',
  wfIfElseBlock: 'IF/ELSE',
  wfIfElseBlockDesc: 'Route flow based on conditions',
  wfLoopBlockDesc: 'Repeat actions for each item',
  wfAgentBlockDesc: 'AI agent for task execution',
  wfCodeBlockDesc: 'Execute custom code logic',
  wfOutputBlockDesc: 'Display or export results',
  wfPdfProcessorBlockDesc: 'Extract and process PDF data',
  wfCategoryTrigger: 'Trigger',
  wfCategoryLogic: 'Logic',
  wfCategoryOthers: 'Others',
  wfCategoryProcessors: 'Processors',
  wfAddBlock: 'Add block',
  wfNoBlocksMatchSearch: 'No blocks match your search.',
  wfNoPastRuns: 'No past runs yet.',
  wfNoPastRunSteps: 'No data available for this run.',
  wfNoDeployVersions: 'No past deploy versions yet.',
  wfLetsStart: "Let's start",
  wfNewField: 'New field',
  wfRemoveField2: 'Remove field',
  wfLabel: 'Label',
  wfFieldTypeText: 'Text',
  wfFieldTypeMultilineText: 'Multi-line Text',
  wfFieldTypeCheckbox: 'Checkbox',
  wfFieldTypeTextarea: 'Textarea',
  wfFieldTypeNumber: 'Number',
  wfAllowMultipleFiles: 'Allow multiple files',
  wfDefaultValue: 'Default value',
  wfNodeConfig: 'Node config',
  wfNodeLabel: 'Node label',
  wfFields: 'Fields',
  wfAddField: 'Add field',
  wfPastRuns: 'Past runs',
  wfTotalRuns: 'Total runs',
  wfTotalCost: 'Total Credit',
  wfRunNumber: 'Run #{{runNumber}}',
  wfPastDeployVersions: 'Past deploy versions',
  wfLive: 'Live',
  wfRestore: 'Restore',
  wfRestoreVersionTitle: 'Restore this version?',
  wfRestoreVersionDesc:
    'Restoring to version {{version}} will overwrite your current workflow. This action cannot be undone.',
  wfUploadField: 'Upload {{name}}',
  wfUnsupportedField: 'Unsupported field: {{type}}',
  wfRunWorkflow: 'Run workflow',
  wfRunWorkflowInstructions:
    'Select files to start the upload automatically, then run the workflow.',
  wfPreparingUpload: 'Preparing upload…',
  wfUploadingBatch:
    'Uploading batch {{batchIndex}} of {{totalBatches}} — {{percent}}%',
  wfUploadingFiles: 'Uploading {{done}}/{{total}} file(s)…',
  wfUploadedFilesSuccess: 'Uploaded {{count}} file(s) successfully.',
  wfFilesFailedToUpload: '{{failed}} of {{total}} file(s) failed to upload.',
  wfUploadFailedRetry: 'Upload failed. Try again.',
  wfUploadedFilesToWorkspace: 'Uploaded {{count}} file(s) to workspace paths.',
  wfNoFilesUploaded: 'No files uploaded yet.',
  wfRemoveUnsupportedFilesToRun:
    'Remove unsupported files to run the workflow.',
  wfFileAlreadyAdded: 'Those files are already added.',
  wfFileSizeKb: '{{size}} KB',
  wfRun: 'Run',
  wfDeploy: 'Deploy',
  wfAuthenticationLabel: 'Authentication: {{label}}',
  wfNoAuthentication: 'No Authentication',
  wfBearerToken: 'Bearer Token',
  wfBasicAuth: 'Basic',
  wfApiKey: 'API Key',
  wfWebhook: 'Webhook',
  wfIntegration: 'Integration',
  wfSelectApplication: 'Select a application.',
  wfApplicationConnected: 'Application connected',
  wfApplication: 'Application',
  wfAction: 'Action',
  wfConnectedAs: 'Connected: {{email}}',
  wfDisconnect: 'Disconnect',
  wfDisconnectConfirmDescription:
    'Disconnecting this application will remove its trigger from the workflow',
  wfYesDisconnect: 'Yes, Disconnect',
  wfRemoveAll: 'Remove All',
  wfRemoveTrigger: 'Remove Trigger',
  wfYesRemoveTrigger: 'Yes, Remove Trigger',
  wfRemoveTriggerConfirmDescription:
    'Removing this trigger will disconnect the application from this workflow',
  wfConnectOutlook: 'Connect Outlook',
  wfConnectingEllipsis: 'Connecting…',
  wfCopiedToClipboard: 'Copied to clipboard',
  wfCopyFailed: 'Copy to clipboard failed',
  wfSaveWorkflowBeforeCopy: 'Save the workflow before copying its form URL.',
  wfDeployBeforeCopyUrl: 'You need to deploy the workflow to enable Copy URL.',
  wfAddBlockToRun: 'Add a block to run',
  wfConnectOutlookFailed: 'Failed to connect Outlook',
  wfConnectAccountFirst: 'Please connect an account from Connectors first.',
  wfTriggerTypeNotSupported: 'This trigger type is not supported.',
  wfTeamsChannelIdsRequired:
    'Team ID and Channel ID are required for a Teams channel trigger.',
  wfTeamsTeamIdIsConversationId:
    "Team ID is a conversation ID. Enter the team's group ID (GUID) or paste the channel link from Teams.",
  wfTeamsInvalidTeamId:
    "Team ID is invalid. Enter the team's group ID (GUID) or paste the channel link from Teams.",
  wfTeamsInvalidChannelId:
    'Channel ID is invalid. Enter an ID like 19:…@thread.tacv2 or paste the channel link from Teams.',
  wfTeamsChatIdRequired: 'Chat ID is required for a Teams chat trigger.',
  wfTeamsInvalidChatId: 'Chat ID is invalid. Enter an ID like 19:…@thread.v2.',
  wfTeamsChannelNotFound:
    'Teams channel not found. Check the Team ID and Channel ID.',
  wfTeamsChannelAccessDenied:
    'The connected Microsoft account does not have access to this Teams channel.',
  wfTeamsChatNotFound: 'Teams chat not found. Check the Chat ID.',
  wfTeamsChatAccessDenied:
    'The connected Microsoft account does not have access to this Teams chat.',
  wfConnectApplication: 'Connect the application.',
  wfIntegrationConnectFailed:
    'Integration trigger connection failed for provider "{{provider}}", trigger "{{trigger}}"',
  wfWebhookRegenerateFailed: 'Failed to regenerate webhook credential',
  wfWebhookAuthUpdateFailed: 'Failed to update authentication method',
  wfFormFieldRequired: 'Form field required.',
  wfFieldNameDuplicate: 'A field with this name already exists.',
  wfFormFieldAdded: 'Form field added.',
  wfBlockTypeForm: 'Form',
  wfDeployWorkflow: 'Deploy workflow',
  wfNewVersion: 'New version',
  wfMinor: 'Minor',
  wfMajor: 'Major',
  wfDescribeChangesPlaceholder:
    'Describe the changes you made in this version.',
  wfChanges: 'Changes',
  wfBriefDetails: 'Brief details',
  wfDescribeBriefPlaceholder: 'Describe brief of this version.',
  wfNoChangesToDeploy: 'No changes to deploy.',
  wfGoToBlock: 'Go to block',
  wfDeleted: 'Deleted',
  wfAdded: 'Added',
  wfEdgeRemoved: 'Edge removed',
  wfChangedLabel: 'Changed: {{label}}',
  wfResetNodePositions: 'Reset node positions',
  wfUndo: 'Undo',
  wfRedo: 'Redo',
  wfZoomIn: 'Zoom in',
  wfZoomOut: 'Zoom out',
  wfFitView: 'Fit to view',
  wfLock: 'Lock',
  wfTestExecute: 'Test Execute',
  wfStopExecution: 'Stop Execute',
  wfRenameWorkflow: 'Rename workflow',
  wfBackToConfigurations: 'Back to Edit Mode',
  wfDescriptionLabel: 'Description',
  wfAbortRunTooltip: 'Abort run and return to editing',
  wfResetRunTooltip: 'Reset run and return to editing',
  wfRename: 'Rename',
  wfDuplicate: 'Duplicate',
  wfDelete: 'Delete',
  wfRenamedSuccessfully: 'Workflow renamed successfully',
  wfRenameFailed: 'Failed to rename workflow',
  wfDuplicatedSuccessfully: 'Workflow duplicated successfully',
  wfDuplicateFailed: 'Failed to duplicate workflow',
  wfLogDuplicateFailed: 'duplicateWorkflow failed:',
  wfDeleteConfirmTitle: 'Delete the Workflow!',
  wfDeleteConfirmMessage: 'Are you sure you want to delete the Workflow?',
  wfDeletedSuccessfully: 'Workflow deleted successfully',
  wfDeleteFailed: 'Failed to delete workflow',
  wfDeleteDisabledActive: 'Deactivate workflow before deleting it',
  wfInvalidWorkflowTitle: 'Workflow Not Found',
  wfInvalidWorkflowMessage:
    'This workflow could not be loaded — it may have been deleted or the link is invalid. You can proceed with your existing workflows.',
  wfProcessWorkflowGrid: 'Process with existing workflows',
  wfWorkflowResult: 'Workflow result',
  wfOutputLabel: 'Output: {{outputField}}',
  wfDownloadOutputFile: 'Download output file',
  wfDownload: 'Download',
  wfOutputUrl: 'Output url',
  wfLoopToEnd: 'Loop end',
  wfAddOutputField: 'Add Output Field',
  wfFieldType: 'Field Type',
  wfFieldPurposePlaceholder: 'Describe the purpose of this field.',
  wfRequiredFieldHint: 'This field must be included in the agent output.',
  wfEnterFieldLabel: 'Enter field label',
  wfStructuredOutputAdded: 'Structured Output is added',
  wfStructuredOutputHint:
    'Output will be generated in an unstructured format when the toggle is off.',
  wfSelectModel: 'Select model',
  wfInsertContext: 'Insert context',
  wfInsert: 'Insert',
  wfRunBlock: 'Run Block',
  wfReRunBlock: 'Re-run Block',
  wfRunBlockToGenerate:
    'Click Run Block to generate data you can use as context for input.',
  wfNoUpstreamNodes: 'No previous nodes available.',
  wfTriggerPdfs: 'Trigger PDFs',
  wfInput: 'Input',
  wfOutput: 'Output',
  wfBody: 'body',
  wfCollapse: 'Collapse',
  wfQueued: 'Queued',
  wfSavedInEditorTooltip: 'Saved in editor — use main Save to store on server',
  wfUnsaved: 'Unsaved',
  wfBlocksCount: '{{blocks}} Blocks',
  wfCostLabel: '$ {{cost}} Cost',
  wfFlowRunsCount: '{{flowRuns}} Runs',
  wfTotalRunsCount: '{{totalRuns}} Runs',
  wfVersionLabel: 'Version {{version}}',
  wfVersionShort: '{{version}} Ver',
  wfClosesLoopVariable: 'Closes: {{loopVariable}}',
  wfInnerAgents: 'Inner agents',
  wfVariableLabel: 'Variable: ',
  wfProvideArrayToIterate: 'Provide an array to iterate',
  wfMaxFilesPerRun: 'You can upload at most {{max}} files per run.',
  wfFileExceedsLimit: '“{{name}}” exceeds the {{maxMb}} MB per-file limit.',
  wfUploadLimitsCaption:
    'Up to {{maxFiles}} files. Size limits vary by file type.',
  error: 'Error',
  wfWorkflowFailed: 'Workflow failed',
  wfWorkflowFailedAtNode: 'Workflow failed at {{node}}',
  wfNodeExecutionFailed: 'Node execution failed',
  wfAuthenticationMethod: 'Authentication method',
  wfUsername: 'Username',
  wfPassword: 'Password',
  wfWebhookSecret: 'Webhook Secret',
  wfWebhookCurl: 'Webhook cURL',
  wfTypeHerePlaceholder: 'Type here',
  wfHide: 'Hide',
  wfShow: 'Show',
  wfName: 'Name',
  wfNameMaxLengthReached: 'Maximum character limit reached',
  wfEditDetails: 'Edit details',
  wfEditWorkflowDetails: 'Edit workflow details',
  wfDetailsUpdated: 'Workflow details updated',
  wfDetailsUpdateFailed: 'Failed to update workflow details',
  wfFieldTypeFile: 'File',
  wfClose: 'Close',
  wfCopyWebhookSecret: 'Copy webhook secret',
  wfRevealToCopy: 'Reveal to copy',
  wfCopyWebhookUrl: 'Copy webhook URL',
  wfAcceptedTypesPlaceholder: '.pdf,.docx',
  wfCompleteRequiredFields:
    'Complete required fields before running: {{fields}}.',
  wfLogUpdateNameFailed: 'updateWorkflowName failed:',
  wfLogToggleActiveFailed: 'handleToggleWorkflowActive failed:',
  wfLogRenameFailed: 'renameWorkflow failed:',
  wfLogDeleteFailed: 'deleteWorkflow failed:',
  wfLogCreateFailed: 'createWorkflow failed:',
  wfLogSaveFailed: 'saveWorkflow failed:',
  wfLogWebhookRegenerateFailed: 'webhook regenerate failed:',
  wfLogWebhookAuthUpdateFailed: 'webhook auth update failed:',
  wfLogWebhookAuthTaskFailed: 'webhook auth update task failed:',
  wfLogKnowledgeUploadFailed: 'knowledge upload failed:',
  wfLogRunFailed: 'runWorkflow failed:',
  wfLogRunUploadFailed: 'run file upload failed:',
  wfLogGraphParseFailed: 'parseGraphField: malformed graph JSON',
  wfLogHydrationFailed: 'workflow hydration failed:',
  wfMcpConnected: '{{name}} connected successfully',
  wfMcpConnectFailed:
    'Could not connect {{name}}. The connection was not completed — please try again.',
  wfMcpDisconnected:
    '{{name}} was disconnected. Its tools stay in the workflow but will not run until you reconnect.',
  wfLogMcpConnectStarted: 'mcp connect started:',
  wfLogMcpConnected: 'mcp connector connected:',
  wfLogMcpConnectFailed: 'mcp connect did not complete:',
  wfLogMcpVerifyFailed: 'mcp connect verification failed:',
  wfLogMcpDisconnected: 'mcp category disconnected:',
  wfLogDownloadFallback: 'blob download failed; falling back to window.open',
  wfAiActionAriaLabel: 'AI',
  wfMoreActionsAriaLabel: 'More',
  wfSkippedStatus: 'Skipped',
  wfCollapseAriaLabel: 'Collapse',
  wfOperatorContains: 'contains',
  wfMaxIterationsShort: 'max',
  wfWorkflowActionsAriaLabel: 'Workflow actions',
  wfShareWorkflowAriaLabel: 'Share workflow',
  wfFavoriteWorkflowAriaLabel: 'Favorite workflow',
  wfFieldTypeString: 'String',
  wfFieldTypeBoolean: 'Boolean',
  wfFieldTypeObject: 'Object',
  wfFieldTypeArray: 'Array',
  wfEditField: 'Edit Field',
  wfAcceptedFileTypes: 'Accepted file types',
  wfEnterNamePlaceholder: 'Enter name',
  wfNewEmailAction: 'New email matching search',
  wfSearchQuery: 'Search Query',
  wfSearchQueryPlaceholder: 'Write search query',
  wfSearchQueryTooltip: 'Outlook search query the email must match. Examples',
  wfSearchQueryTooltipExample: 'from:johndoe@example.com',
  wfSearchQueryTooltipDetails:
    ', subject:invoice, body:"due date", NOT from:noreply. Combine filters with AND, OR, NOT and parentheses. Supported operators: from:, to:, cc:, bcc:, subject:, body:, participants:, recipients:. Find more info here:',
  wfGmailSearchQueryTooltip:
    'Gmail search query the email must match. Examples',
  wfGmailSearchQueryTooltipExample: 'from:johndoe@example.com',
  wfGmailSearchQueryTooltipDetails:
    ', subject:invoice, {from:amy from:david}, -from:noreply. Combine filters with AND, OR, - (exclude) and parentheses. Supported operators: from:, to:, cc:, bcc:, subject:. Find more info here:',
  wfTeamsNewChannelMessage: 'New channel message',
  wfTeamsNewChatMessage: 'New chat message',
  wfTeamsNewMeetingTranscript: 'New meeting transcript',
  wfTeamsChannelId: 'Channel ID',
  wfTeamsChatId: 'Chat ID',
  wfTeamsChannelIdTooltipDetails:
    'To find the Channel ID, open the required channel in Microsoft Teams and copy the channel link. The Channel ID is the part of the URL between channel and the next slash. Copy this value and paste it into the field.',
  wfTeamsChatIdTooltipDetails:
    'To find the Chat ID, open the required chat in Microsoft Teams and copy the chat link. The Chat ID is the part of the URL between chat and conversations. Copy this value and paste it into the field.',
  wfTeamsTeamId: 'Team ID',
  wfTeamsFilterKeyword: 'Filter Keyword',
  wfNoFilesAttachedYet: 'No files attached yet.',
  wfToggleAriaLabel: 'toggle',
  wfFormTriggerLabel: 'Form Trigger',
  wfUploadDocumentLabel: 'Upload Document',
  wfSaveBeforeRunning: 'Save the workflow before running it.',
  wfNoInputProvided:
    'No input was provided. Fill the form fields or upload files, then try again.',
  wfRunWorkflowFailedGeneric: 'Run workflow failed',
  wfRunScheduledWorkflowNoInput:
    'This workflow runs on a schedule and needs no input. Run it now to test it.',
  wfUnknownTime: 'Unknown time',
  wfPendingStatus: 'Pending',
  wfSuccessStatus: 'Success',
  wfWorkflowSavedSuccessfully: 'Workflow saved successfully',
  wfWorkflowDeployedSuccessfully: 'Workflow deployed successfully',
  wfNotAvailable: 'N/A',
  wfNoDescriptionAvailable: 'No description available.',
  wfPromptFieldLabel: 'Prompt',
  wfStructuredOutputFieldLabel: 'Structured output field',
  wfBranchConditionsLabel: 'Branch conditions',
  wfConnectedApplicationLabel: 'Connected application',
  wfFormFieldLabel: 'Form field',
  wfChangeCount: '{{count}} change(s)',
  wfViewingRunNumber: 'Viewing Run #{{number}}',
  connectionDetails: 'Connection Details',
  verbundeneAnwendungen: 'Verbundene Anwendungen',
  deleteDisabledDuringUpload:
    'Cannot delete while files are being uploaded to this folder',

  // Skills
  skills: 'Skills',
  skillsToolDescription: 'Call any of your skills and chat',
  manageSkills: 'Manage skills',
  loadMore: 'Load more',
  skillHeaderDescription:
    'Extend what you can do with reusable capabilities powered by EmpowerGPT skills.',
  noSkillsCreatedYet: "You haven't created any skills yet",
  noSkillsFound: 'No skills found',
  noSharedSkillsTitle: 'No shared skills yet',
  noSharedSkillsDescription:
    'Skills shared with you by others will appear here.',
  noDefaultSkillsTitle: 'No default skills available',
  noDefaultSkillsDescription: 'System skills will appear here when available.',
  install: 'Install',
  installed: 'Installed',
  uninstalled: 'Uninstalled',
  createSkill: 'Create skill',
  createWithChat: 'Create with chat',
  createWithChatDescription: 'Build a skill with Empower GPT',
  writeSkillInstructions: 'Write skill instructions',
  writeSkillInstructionsDescription: 'Customized and simple',
  uploadSkill: 'Upload a skill',
  uploadSkillMenuDescription: 'Upload .zip or .md file',
  writeSkillInstructionsModalDescription:
    'Write skill description and instructions for the best results.',
  skillName: 'Skill name',
  skillNamePlaceholder: 'ui-ux-assurance',
  skillDescriptionPlaceholder:
    "Create a brief description for a skill like 'UI-UX Assurance' that aids in conducting UX audits from design to development...",
  charactersCount: '{{current}} / {{max}} characters',
  skillActions: 'Skill actions',
  uploadSkillTitle: 'Upload skill',
  uploadSkillModalDescription:
    'Upload a SKILL.md file or import a .zip/.skill archive. Ensure the SKILL.md contains YAML frontmatter with a name and description.',
  dragAndDropToUpload: 'Drag and drop or click to upload',
  uploadSkillDropzoneHint:
    'You can upload a single SKILL.md file or a .zip/.skill archive.',
  skillZipStructureTitle: 'Zip structure',
  skillZipStructureDescription:
    'Follow the Agent Skills format: a single SKILL.md at the top and optional folders. Put files directly inside a folder (no folders within folders). Text files only, such as .md, .py, .json or .yaml.',
  skillZipStructureSkillMd: 'Required: name, description and instructions',
  skillZipStructureScripts: 'Optional: code the agent can run, e.g. .py',
  skillZipStructureReferences: 'Optional: documentation',
  skillZipStructureAssets: 'Optional: templates and other resources',
  skillZipStructureLearnMore: 'Learn more about Agent Skills',
  uploadingSkill: 'Uploading skill',
  uploadingSkillDescription:
    'Your skill is uploading. This will only take a moment.',
  skillDescription: 'Skill Description',
  noDescriptionProvided: 'No description provided.',
  moreOptions: 'More options',
  rawView: 'Raw',
  unsupportedSkillFile:
    'Unsupported file type. Upload a SKILL.md file or a .zip/.skill archive.',
  skillArchiveEmpty: 'The archive is empty. Add a SKILL.md file and try again.',
  skillArchiveOnlyMd:
    'Put SKILL.md at the top and other files directly inside folders such as scripts/ or references/. Move or remove: {{files}}',
  skillArchiveReadError:
    'Failed to read the archive. Please upload a valid .zip/.skill file.',
  you: 'You',
  enterMdFormat: 'Please enter md format',
  skillCreatedSuccessfully: 'Skill created successfully.',
  skillCreateFailed: 'Failed to create skill. Please try again.',
  deleteTheSkill: 'Delete the skill',
  deleteSkillConfirmation: 'Are you sure you want to delete the skill?',
  skillDeletedSuccessfully: 'Skill deleted successfully.',
  skillDeleteFailed: 'Failed to delete skill. Please try again.',
  skillFetchFailed: 'Failed to load skill details. Please try again.',
  editSkillInstructions: 'Edit skill instructions',
  skillUpdatedSuccessfully: 'Skill updated successfully.',
  skillUpdateFailed: 'Failed to update skill. Please try again.',
  skillEnabledSuccessfully: 'Skill enabled successfully.',
  skillDisabledSuccessfully: 'Skill disabled successfully.',
  skillInstalledSuccessfully: 'Skill installed successfully.',
  skillInstallFailed: 'Failed to install skill. Please try again.',
  skillDisabledByOwnerError:
    'This skill has been disabled by its owner and cannot be installed.',
  skillNotInstalledByOwnerError:
    'This skill has not been installed by its owner yet. Please ask the owner to install it first.',
  skillUninstalledSuccessfully: 'Skill uninstalled successfully.',
  skillUninstallFailed: 'Failed to uninstall skill. Please try again.',
  uninstall: 'Uninstall',
  copyFailed: 'Failed to copy to clipboard',
  filterBy: 'Filter by',
  skillNameFormatError:
    'Skill name may only contain lowercase letters (a–z), numbers (0–9), and hyphens (-).',
  skillNameStartEndHyphenError:
    'Skill name must not start or end with a hyphen.',
  skillNameConsecutiveHyphensError:
    'Skill name must not contain consecutive hyphens (--).',
  skillNameAlreadyExistsError: 'Skill with this name already exists.',
  skillNameExistsAsDeprecatedError:
    'A deleted skill with this name already exists. Please choose a different name.',
  skillZipRequired:
    'A zip file containing SKILL.md is required to create a skill.',
  skillZipValidationError:
    'Skill package validation failed. Check your SKILL.md format (name, description, and valid markdown body) and try again.',
  skillPublicationError:
    'Failed to update skill status in DocLM. Please try again.',
  skillPublicationJudgeFailedError:
    'Skill publication was rejected by the review process. Please revise the skill instructions and try again.',
  skillNotRegisteredInDocLMError:
    'This skill is not registered in DocLM and cannot be enabled or disabled.',
  skillZipMissingSkillFileError:
    'No SKILL.md found in the uploaded file. Place SKILL.md at the root of your zip, or inside a single folder named after the skill.',
  skillZipMultipleSkillsError:
    'The zip contains multiple skills. Each skill must be uploaded as a separate zip — zip each skill folder individually.',
  skillZipUnsafeError:
    'The uploaded zip failed security checks and cannot be processed. Ensure the file is a plain zip with no symlinks or encrypted entries.',
  skillZipInvalidPackageError:
    'The skill package is invalid. Check that SKILL.md has a valid frontmatter block with a lowercase name (letters, digits, hyphens only) and a description, followed by a non-empty markdown body.',
  skillInstructionsFrontmatterError:
    'Instructions should not include YAML frontmatter (---). Use the Name and Description fields above instead.',
  skillSharedSuccessfully: 'Skill shared successfully.',
  skillShareFailed: 'Failed to share skill. Please try again.',
  skillDownloadFailed: 'Failed to download skill. Please try again.',
  skillDownloadedSuccessfully: 'Skill downloaded successfully.',
  replaceSkillTitle: 'Replace "{{name}}" skill?',
  replaceSkillConfirmation:
    "There's an existing skill with the same name. Uploading this skill will replace the existing one, which can't be restored.",
  uploadAndReplace: 'Upload and replace',
  removePremissionsSuccess:
    '{{username}} was removed from the skill permissions successfully.',
  removePremissionsFailed:
    'Failed to remove user {{username}} from the skill permissions.',
  disableSSOConfirmTitle: 'Disable Single Sign-On (SSO)?',
  disableSSOConfirmDescription:
    "Users signed in through Active Directory or SSO will be logged out and won't be able to sign back in until SSO is re-enabled.",
  disableSSOConfirmButton: 'Disable SSO',

  // Upload Sessions
  sessionHistory: 'Session history',
  pinned: 'Pinned',
  completed: 'Completed',
  completedWithFailures: 'Completed with failures',
  others: 'Others',
  paused: 'Paused',
  pinThisSession: 'Pin this session',
  unpinSession: 'Unpin session',
  startSession: 'Start session',
  retryFailedItems: 'Retry failed items',
  cancelSession: 'Cancel session',
  deleteThisSession: 'Delete this session?',
  deleteConfirmationMessage: 'Are you sure you want to delete the session?',
  xOfYFiles: '{{uploaded}}/{{total}} files',
  xPercentYOfZFilesUploaded:
    '{{percent}}% - {{uploaded}} of {{total}} files uploaded',
  noTimeEstimation: '~ No time estimation',
  viewInFolder: 'View in folder',
  noSession: 'You have no session!',
  noSessionDescription:
    'Upload your folders or files to any workspace. Your session will be saved here temporarily, and you can also save it permanently.',
  noActiveSession: 'You have no active session!',
  noActiveSessionDescription:
    'Your in-progress session will be shown here and at the top of all sessions.',
  noPinnedSession: 'You have no pinned session!',
  noPinnedSessionDescription:
    'Pinned sessions appear here and stay at the top of your list. Pin any session from the All tab to keep it handy.',
  noCompletedSession: 'You have no completed session!',
  noCompletedSessionDescription: 'Completed sessions will appear here.',
  noFailedOrPausedSession: 'You have no failed or paused session!',
  noFailedOrPausedSessionDescription:
    'Failed and paused sessions will appear here.',
  backToAllSessions: 'Back to all sessions',
  backToWorkspaces: 'Back to Workspaces',
  sessionsInProgress: '{{count}} Sessions in progress',
  etaSeconds: '{{count}}s remaining',
  etaMinutes: '{{count}} min remaining',
  etaHours: '{{count}}h remaining',
  etaHoursMinutes: '{{hours}}h {{minutes}}m remaining',
  lockedFolderTitle: 'You can not edit, move or delete "{{folderName}}"',
  lockedFolderDescription:
    '{{userName}} is uploading files to this folder in session "{{sessionName}}". Wait for the upload to finish, or view the session for details.',
  lockedFolderDescriptionNoSession:
    '{{userName}} is uploading files to this folder. Wait for the upload to finish, or view the session for details.',
  lockedFolderDescriptionGeneric:
    'Someone is uploading files to this folder. Wait for the upload to finish, or view the session for details.',
  locked: 'Locked',
  lockedTooltip:
    'This folder is locked as {{userName}} is uploading to this workspace in session "{{sessionName}}".',
  lockedTooltipNoSession:
    'This folder is locked as {{userName}} is uploading to this workspace.',
  lockedTooltipGeneric:
    'This folder is locked as someone is uploading to this workspace.',
  lockedTooltipFile:
    'This file is locked as {{userName}} is uploading to this workspace in session "{{sessionName}}".',
  lockedTooltipFileNoSession:
    'This file is locked as {{userName}} is uploading to this workspace.',
  lockedTooltipFileGeneric:
    'This file is locked as someone is uploading to this workspace.',
  loadingSession: 'Loading session...',
  sessionNotFound: 'Session not found',
  loadingFiles: 'Loading files...',
  noFilesInSession: 'No files in this session',
  filesCount: 'Files ({{count}})',
  columnName: 'Name',
  columnSize: 'Size',
  columnStatus: 'Status',
  columnFormat: 'Format',
  fileStatusWaiting: 'Waiting',
  fileStatusUploading: 'Uploading',
  fileStatusUploaded: 'Uploaded',
  fileStatusFailed: 'Failed',
  fileStatusMissing: 'Missing',
  fileStatusCancelled: 'Cancelled',
  uploadDetail: 'Upload detail',
  syncingFilesTo: 'Syncing files to {{path}}',
  totalFiles: 'Total files',
  existingFiles: 'Existing files',
  newFiles: 'New files',
  downloadFilesDetail: 'Download files detail',
  csvFileName: 'File Name',
  csvFullPath: 'Full Path',
  csvSizeBytes: 'Size (bytes)',
  csvLocalModified: 'Local Modified',
  csvServerModified: 'Server Modified',
  csvStatus: 'Status',
  csvType: 'Type',
  csvTypeFile: 'File',
  csvTypeFolder: 'Folder',
  filesAlreadyExist:
    '{{count}} files already exists in this location. Do you want to replace the existing files with new ones or skip them?',
  replaceExistingFiles: 'Replace the existing files',
  filesBeingUploadedConflict:
    "{{count}} files are being uploaded in this location by {{owner}}. You can't upload right now!",
  sameFilesUploadingTitle: 'Same files are being uploaded in another session.',
  sameFilesUploadingDescription:
    'Please wait until the most recent files finish processing before starting a new upload session.',
  syncFolderToServer: 'Sync folder to server',
  syncDescription:
    "New files in your local folder will be uploaded to the server. Existing files on the server won't be changed, whether you've edited them or not. This is the default setting.",
  openAdvancedOptions: 'Open advanced options',
  thisSyncWill: 'This sync will',
  addNewFilesOnly: 'Add new files only',
  addAndUpdate: 'Add and update',
  mirror: 'Mirror',
  deleteAndAdd: 'Delete and add',
  alreadyIdentical: 'Already identical',
  newWillUpload: 'New - will upload',
  editedWillSkip: 'Edited - will skip',
  editedWillReplace: 'Edited - will replace',
  onlyOnServerKept: 'Only on server - kept',
  onlyOnServerDelete: 'Only on server - delete',
  advancedOptions: 'Advanced options',
  mirrorLocalFolderExactly: 'mirror the local folder exactly',
  advancedOptionsDescription:
    'These options change files that are already on the server. Both are off by default.',
  replaceEditedFilesOnServer: 'Replace edited files on the server',
  replaceEditedFilesDescription:
    '{{count}} files. The server copy is overwritten with your local version.',
  deleteServerFilesMissingLocally:
    'Delete server files that are missing locally',
  deleteServerFilesDescription:
    '{{count}} files. Turn both options on to mirror your local folder exactly.',
  filesWillBeRemoved:
    "{{count}} files will be permanently removed from the server. You'll be asked to confirm on the next step.",
  uploadXFiles: 'Upload {{count}} files',
  syncXFiles: 'Sync {{count}} files',
  mirrorXFiles: 'Mirror {{count}} files',
  exportFileList: 'Export file list',
  deleteFilesFromServer: 'Delete {{count}} files from the server?',
  deleteFilesFromServerDescription:
    "Mirroring will remove these files because they no longer exist in your local folder. They can't be recovered from the server afterwards.",
  yesDeleteFiles: 'Yes, delete files',
  noKeepFiles: 'No, keep files',
  wfSettingsDescription: 'Customize workflows for your organization',
  wfSettingsPlan: 'Plan',
  wfSettingsResetsOn: 'Reset at {{date}}',
  wfSettingsRuns: 'Runs: {{used}} / {{total}}',
  wfSettingsLimits: 'Limits',
  wfSettingsUsageCap: 'Usage Cap',
  wfSettingsUsageCapDescription:
    'Maximum AI credit usage allowed across all workflows.',
  wfSettingsSetCap: 'Set Cap',
  wfSelectedFiles: 'Selected files',
  wfFormSubmitting: 'Submitting',
  wfFormSubmitFailed: 'Failed to submit form.',
  wfFormSubmitted: 'Form Submitted!',
  wfFormSubmittedDescription:
    'Form submitted! Your response has been recorded.',
  professionalPlanHeadline: 'Managed Enterprise Cloud',
  professionalPlanSubheading: 'Enterprise AI without dedicated infrastructure',
  professionalPlanDescription:
    'Deploy AI quickly across departments and business units with a fully managed enterprise platform.',
  professionalPlanFootnote:
    'Includes €5 Enterprise AI Credits • No credit card required',
  professionalPlanCta: 'Upgrade',
  professionalFeature1: 'Flexible monthly or annual subscription',
  professionalFeature2: '€15 AI Credits included per user',
  professionalFeature3:
    'Continue seamlessly with transparent Pay As You Go pricing',
  professionalFeature4: 'Shared Enterprise AI Credit Pool',
  professionalFeature5: 'Customer Success included',
  professionalFeature6: 'One platform. All features included.',
  enterprisePlanHeadline: 'Dedicated Enterprise Deployment',
  enterprisePlanSubheading: 'Enterprise AI designed around your organization',
  enterprisePlanDescription:
    'Deploy EmpowerGPT in the environment, operating model and scale that best fits your business.',
  enterprisePlanFootnote:
    'Tailored to your deployment and business requirements',
  enterprisePlanCta: 'Talk to Sales',
  enterpriseFeature1: 'Public, Dedicated, Hybrid or On-Premises deployment',
  enterpriseFeature2: 'Enterprise Capacity Planning',
  enterpriseFeature3: 'Dedicated Customer Success',
  enterpriseFeature4: 'Custom Integrations & Enterprise Support',
  enterpriseFeature5: 'Annual enterprise agreement',
  perUserPerMonthExclVat: '/Per user / month (excl. VAT)',
  workflowAddOnTitle: 'Workflows',
  workflowAddOnBadge: 'Add on',
  workflowAddOnBasic: 'Basic',
  workflowAddOnAdvanced: 'Advanced',
  workflowAddOnIncludedInProfessional: 'Included in Professional',
  workflowAddOnPerMonth: '/month',
  workflowAddOnPerYear: '/year',
  workflowAddOnProfessionalRuns: '6,000 Workflow runs per month',
  workflowAddOnEnterpriseRuns: '50,000 Workflow runs per month',
  workflowAddOnFeatureUsers: 'Unlimited Users',
  workflowAddOnFeatureBlocks: 'Unlimited blocks per Workflow',
  workflowAddOnFeatureHistory:
    'All Workflow features included such as historical runs',
  workflowAddOnFeaturePayg: 'Credits are charged using Pay-as-you-go model',
  workflowAddOnCta: 'Get Started',
  addOnCancel: 'Cancel subscription',
  addOnReactivate: 'Reactivate',
  addOnPurchaseConfirmTitle: 'Purchase Workflow add-on?',
  addOnPurchaseConfirmDescription:
    'Your saved card will be charged the prorated amount immediately.',
  addOnCancelConfirmTitle: 'Cancel Workflow add-on?',
  addOnCancelConfirmDescription:
    'The add-on stays active until the end of the current billing period and will not be billed again.',
  addOnPurchaseSuccess: 'Workflow add-on activated',
  addOnReactivateSuccess: 'Workflow add-on reactivated',
  addOnCancelSuccess:
    'Workflow add-on will be cancelled at the end of the current period',
  addOnNotEligibleError:
    'Add-ons require an active Essential or Professional plan',
  addOnAlreadyActiveError: 'This add-on is already active',
  addOnNotFoundError: 'No active add-on to cancel',
  addOnPurchaseError: 'Unable to purchase the add-on. Please try again.',
  addOnCancelError: 'Unable to cancel the add-on. Please try again.',

  // ââ ChatV2 ââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââ
  assistantNotFound: 'Assistant not found',
  noPermissionToEditAssistant:
    'You don’t have permission to edit this assistant',
  projectNotFound: 'Project not found',
  attachmentsNotAvailableInPreview: 'Attachments aren’t available in preview',
  sendMessage: 'Send message',
  addToThisMessage: 'Add to this message',
  startVoiceInput: 'Start voice input',
  voiceInputUnavailable: 'Voice input unavailable',
  stopVoiceInput: 'Stop voice input',
  world: 'World',
  featureComingSoon: '{{feature}} are coming soon',
  removeItem: 'Remove {{name}}',
  shareChat: 'Share chat',
  continueWithThisModel: 'Continue with this model',
  resizeChatAndDocumentPanes: 'Resize chat and document panes',
  jumpToLatestMessage: 'Jump to latest message',
  conversationMessages: 'Conversation messages',
  sharedConversationMessages: 'Shared conversation messages',
  shareProject: 'Share project',
  startNewChatInThisProject: 'Start a new chat in this project',
  shareProjectDescription:
    'Anyone you add gets access to this project and all of its chats, including this one.',
  mcpOAuthOwnerManaged:
    'This connection is managed by the assistant owner. Ask them to connect it before running this action.',
  confirmActionHeading: 'Do you want to confirm this action?',
  connectAccountHeading: 'Connect your account to continue',
  connectAccountDescription:
    'This action needs access to your account. Connect it and the agent will carry on from here.',
  editMessage: 'Edit message',
  otherEllipsis: 'Other...',
  addSpecificDetailsHere: 'Add specific details here',
  likedResponse: 'Liked response',
  dislikedResponse: 'Disliked response',
  likeResponse: 'Like response',
  dislikeResponse: 'Dislike response',
  stopReading: 'Stop reading',
  readAloud: 'Read aloud',
  feedbackReportDisclaimer:
    'Submitting this report will send the current conversation to Empower GPT for future improvements to our models.',
  minimizeImage: 'Minimize',
  toggleSidebar: 'Toggle sidebar',
  rotateClockwise: 'Rotate clockwise',
  fitToWidth: 'Fit to width',
  print: 'Print',
  fileSize: 'File size',
  keywords: 'Keywords',
  pdfProducer: 'PDF producer',
  pdfVersion: 'PDF version',
  pageCount: 'Page count',
  pageSize: 'Page size',
  fastWebView: 'Fast web view',
  yes: 'Yes',
  no: 'No',
  documentProperties: 'Document properties',
  pageNumber: 'Page number',
  previousPage: 'Previous page',
  nextPage: 'Next page',
  documentNavigation: 'Document navigation',
  thumbnails: 'Thumbnails',
  outline: 'Outline',
  currentZoom: 'Current zoom',
  twoPageView: 'Two page view',
  noFileOpen: 'No file open',
  closeTab: 'Close {{name}}',
  pageWithNumber: 'Page {{page}}',
  creatingLink: 'Creating link',
  shareChatLinkDisclaimer:
    'Anyone with this link can see the conversation. New messages won’t be visible. Avoid sharing private or sensitive info unless you trust the person.',
  shareUsingCopyLink: 'Share using copy link',
  onlyMessagesUpToThisPoint: 'Only messages up to this point will be shared.',
  sessionIsPrivate: 'This session is private',
  sharedSessionReadOnlyNotice:
    'You are viewing a read-only snapshot shared with you. Editing, regenerating, and reacting to messages are disabled.',
  viewMoreFilesCount: 'View more files ({{count}})',
  openSource: 'Open {{name}}',
  performedOneStep: 'Performed 1 step',
  performedStepsCount: 'Performed {{count}} steps',
  script: 'Script',
  searchingTheWorkspaces: 'Searching the workspaces',
  searchingTheWeb: 'Searching the web',
  runningAScript: 'Running a script',
  executingTheCode: 'Executing the code',
  deepResearch: 'Deep research',
  callingASubAgent: 'Calling a sub agent',
  checkingFiles: 'Checking files',
  toolSearch: 'Tool search',
  waitingForConfirmation: 'Waiting for confirmation',
  failedDoingAction: 'Failed doing action',
  working: 'Working',
  suggestedQuestions: 'Suggested questions',
  hiHowCanIAssistYouToday: 'Hi, How can I assist you today?',
  howCanIAssistYouToday: 'How can I assist you today?',
  askAnythingAboutProject:
    'Ask anything about {{projectName}} and its knowledge base.',
  assistantUpdatedByController:
    'The controller has updated the assistant, so your experience may vary.',
  assistantModelDisabledMessage:
    'The admin has disabled the assistant’s AI model. Controller users can assign a new model, but for now, we’re switching you to {{model}}.',
  latestAndMostUsedModelNamed: 'our latest and most used AI model, {{model}}',
  latestAndMostUsedModel: 'our latest and most used AI model',
  assistantFilesNoPermission:
    'You don’t have permission to chat certain files in this assistant’s knowledge base.',
  assistantFilesLimitedAccess:
    'Your access to its knowledge base is limited, so responses may be restricted.',
  assistantFilesLimitedAccessLong:
    'Your access to the assistant’s knowledge base is limited, so responses may be restricted accordingly!',
  assistantUpdatedByCreator:
    'The assistant has been updated by its creator, possibly due to deleted files or new files they added. Responses will reflect these changes.',
  assistantUpdatedByCreatorShort:
    'It has been updated by its creator — files may have been added or removed — so responses will reflect those changes.',
  reconnectingToChatService:
    'Reconnecting to the chat service (attempt {{attempt}})…',
  chatConnectionLost:
    'Lost connection to the chat service. Your next message will reconnect — replies may not stream until then.',
  attachmentUploadFailed: 'Upload failed',
  skippedFilesWarning:
    'Some files were skipped because they are unsupported, too large, over the attachment limit, or could not be uploaded.',
  openingEllipsis: 'Opening…',
  citationSourcePending: 'Sources become available when the response finishes.',
  citationSourceUnresolved:
    'This citation’s source isn’t listed in this answer.',
  citationSourceReadOnly: 'Sources can’t be opened here.',
  openCitation: 'Open citation {{label}}: {{name}}',
  citationWithTitle: 'Citation {{label}} — {{title}}',
  viewSource: 'View source',
  viewDiagram: 'View diagram',
  downloadDiagram: 'Download diagram',
  copyCode: 'Copy code',
  waitForResponseToFinish: 'Wait for the response to finish',
  filesAreStillUploading: 'Files are still uploading',
  filesAreStillBeingProcessed: 'Files are still being processed',
  waitForBothAnswersToFinish: 'Wait for both answers to finish',
  pickModelForEachColumn: 'Pick a model for each column to compare',
  nameYourAssistantToTryItOut: 'Name your assistant to try it out',
  pickAModelToTryItOut: 'Pick a model to try it out',
  assistantModelDisabledClause:
    "Its AI model has been disabled, so we've switched you to {{model}}.",
  hiComma: 'Hi,',
  assistantActionsAriaLabel: '{{name}} — assistant actions',
  shareChatTrustTitle: "Do you trust the person you're sharing with?",
  shareProjectTitle: "You're sharing the whole project",
  feedbackDislikeTitle: "What didn't you like about this response? (optional)",
  developerRelease: 'developer release',
  totalDocumentsProcessed: 'Total documents · {{percent}}% processed',
  moreCount: '{{count}}+ more',
  aiModelsInfo:
    'Every chat this period, broken down by which AI model answered it.',
  chatTabLabel: 'Chat',
  chatsPerDayAvg: 'Chats per day (avg)',
  activeMembersWithChat: 'Active members (1+ chat)',
  chatKnowledge: 'Chat knowledge',
  chatKnowledgeInfo:
    'Chats are conversations started; Messages are individual queries within them. A busy day can have few chats but many queries.',
  dailyActivity: 'Daily activity',
  lessLabel: 'Less',
  moreLabel: 'More',
  chatsByModules: 'Chats by Modules',
  chatsByModulesInfo:
    'Number of times chat was used in each module. Like in Chat, inside Projects, through Assistants, or from Smart Meet and Workflows.',
  moduleColumn: 'Module',
  toolUsage: 'Tool usage',
  toolUsageInfo:
    'Tools used in the chats across your team. Which tools the assistant reached for while generating responses, day by day. This reflects what powered the answer, not what the user typed.',
  enterpriseSearch: 'Enterprise search',
  moreOthers: 'More Others',
  documentsInfo:
    'How many documents your workspace has processed. Processed documents are ready to search and cite; Unprocessed ones are still being read.',
  appsInfo:
    'Usage across built-in apps this period, with the change versus the previous period.'
};
